import { useContext, useState, useEffect, useRef, createContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Modal, AutoComplete, Popover, Row, Col, Table, Drawer, Button, Input, Spin, message, Select, DatePicker, Form, Tabs, Checkbox, Card, Switch, Radio } from "antd";
import {
  CalendarOutlined,
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  CloseOutlined,
  LoadingOutlined,
  CloseSquareFilled,
  RightOutlined,
  DownOutlined,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  AppstoreOutlined,
  CodeSandboxOutlined,
  RedoOutlined,
  WarningOutlined,
  CarOutlined,
  GiftOutlined,
  ReloadOutlined,
  ArrowsAltOutlined,
  UserOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import "react-aspect-ratio/aspect-ratio.css";
import "../../../style.css";
import "../styles.css";
import { Scrollbars } from "react-custom-scrollbars";
import "../../../globalStyles.css";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { useWindowDimensions } from "../../../../lib/useViewport";
import BarCodeComponentForRetail from "../../../../lib/BarCodeComponentForRetail";
import BarCodeComponentForNoFocus from "../../../../lib/BarCodeComponentForNoFocus";
import db from "../../../../database";
import { v4 as uuidv4 } from "uuid";
import { processSync } from "../../../Sync/syncData";
import { clock } from "../../../../utility/clock";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import { useEventBus } from "../../../../lib/hooks/EventBusProvider";
import userIcon from "../../../../assets/images/userId.svg";
import clearFilters from "../../../../assets/images/clearFilters.svg";
import POSLogo from "../../../../assets/images/NewLogoCW.svg";
import LockScreen from "../../../../assets/images/lockScreen.svg";
import Close from "../../../../assets/images/close-x.svg";
import sideMenu from "../../../../assets/images/side-menu.svg";
import NotesImage from "../../../../assets/images/notes.svg";
import NotesAdd from "../../../../assets/images/note-add.svg";
import userAddIcon from "../../../../assets/images/userAddIcon.svg";
import leftLoading from "../../../../assets/images/opo.gif";
import unlinkTillIcon from "../../../../assets/images/unlink-icon.svg";
import couponIcon from "../../../../assets/images/coupon-icon.svg";
import LockIcon from "../../../../assets/images/lock-icon.svg";
import information from "../../../../assets/images/information.svg";
import FilterIcon from "../../../../assets/images/filterNewICon.svg";
import View from "../../../../assets/images/view.svg";
import ScanIcon from "../../../../assets/images/scanIcon.svg";
import AddUser from "../../../../assets/images/userAdd.svg";
import CustomerSearch from "../../../../assets/images/c-serach.svg";
import ticSelect from "../../../../assets/images/tic.png";
import CustomerIcon from "../../../../assets/images/customer1.svg";
import Retrieve from "../../../../assets/images/retrieve.png";
import { htmlPrint } from "../../../../lib/printer/htmlPrinter";
import { xmlPrint } from "../../../../lib/printer/xmlPrinter";
import printerIcon from "../../../../assets/images/printerIcon.svg";
import salesReportIcon from "../../../../assets/images/salesReportIcon.svg";
import openDrawerIcon from "../../../../assets/images/openDrawer.svg";
import layAwayIcon from "../../../../assets/images/retrieve.png";
import Discard from "../../../../assets/images/return.png";
import Cancel from "../../../../assets/images/cancel-new.svg";
import Back from "../../../../assets/images/backIcon.svg";
import Hold from "../../../../assets/images/pause-new.svg";
import POSIcon from "../SvgComponent/POS";
import ParkedBillIcon from "../SvgComponent/ParkedBill";
import AdditionalChargesIcon from "../SvgComponent/AdditionalCharges";
import CashManagementIcon from "../SvgComponent/CashManagementIcon";
import SalesHistoryIcon from "../SvgComponent/SalesHistoryIcon";
import data from "../../../../constants/retailPos.json";
import Offers from "../../../../assets/images/promoTag.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import DeleteProduct from "../../../../assets/images/delete1.svg";
import discount from "../../../../assets/images/discount.svg";
import giftVoucher from "../../../../assets/images/giftVoucher.svg";
import creditNote from "../../../../assets/images/creditNote.svg";
import wallet from "../../../../assets/images/wallet.svg";
import SyncIcon from "../../../../assets/images/syncIcon.svg";
import SyncSide from "../../../../assets/images/sideFullSync.svg";
import Loyality from "../../../../assets/images/loyalityIcon.svg";
import UPI from "../../../../assets/images/upiIcon.svg";
import Gift from "../../../../assets/images/giftIcon.svg";
import Credit from "../../../../assets/images/creditCardIcon.svg";
import cardType from "../../../../assets/images/cardType.svg";
import ReturnIcon from "../../../../assets/images/return.svg";
import Logout from "../../../../assets/images/logout-new.svg";
import Online from "../../../../assets/images/green.svg";
import Ofline from "../../../../assets/images/red.svg";
import _, { merge } from "lodash";
import RetailModals from "../RetailModals";
import QuantityUpdate from "../QuantityUpdate";
import walletWhite from "../../../../assets/images/walletWhite.png";
import { useGlobalContext } from "../../../../lib/auth/globalStore";
import DefaultProductImage from "../../../../assets/images/no-image.svg";
import HCPrint from "../../../../lib/printer/hardWareControllerPrinter";
import printController from "../../../../lib/printer/printController";
import openDrawer from "../../../../lib/printer/openDrawer";
import PoleDisplay from "../../../../lib/printer/poleDisplay";
import salesReportPrinter from "../../../../lib/printer/salesReportPrinter";
import salesReportCWHCPrinter from "../../../../lib/printer/saleReportCWHCPrinter";
import { useTranslation } from "react-i18next";
import TextArea from "antd/lib/input/TextArea";
import ProductPanelSM from "../productPanelSM";
import styles from "../../../../constants/styles.json";
import user_add from "../../../../assets/images/user_add.svg";
import userTieIcon from "../../../../assets/images/userTieIcon.svg";
import productionIcon from "../../../../assets/images/production.svg";
import LoadingScreen from "./LoadingScreen";
import CWHCPrint from "../../../../lib/printer/CWHardwareController";
import CWPoleDisplay from "../../../../lib/printer/CWPoleDisplay";
import GroupedProducts from "../../../../lib/hooks/GroupedProducts";
import QuotationComponent from "../Quotation";
import {
  discardCouponService,
  discardGiftCard,
  getProductsNearbyStockService,
  upsertGiftCardTransaction,
  verifyReturn,
  unlinkTill,
  upsertCreditTransaction,
  cartHistory,
  upsertCart,
  upsertWalletTransactionService,
  getEstimates,
  syncSingleProductByValue,
} from "../../../../services";
import RenderInput from "../../../../lib/hooks/RenderInput";
import messages from "../../../../errors/messages.en-IN.json";
import layAwaySvg from "../../../../assets/images/layaway.svg";
import { getWorkflowData } from "../../../../utility/getWorkflowData";
import useRestaurantWebSocket from "../../../../hooks/use-websocket";
import moment from "moment";
import { stock } from "../../Core/stock";

const rfidScanerFlag = process.env.REACT_APP_ENABLE_VISION;
const version_number = process.env.REACT_APP_release_no || "24Q0.0.0";
const posConfig = JSON.parse(localStorage.getItem("posConfig"));
const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
const EditableContext = createContext(null);
const isPreOrderPage = window.location.pathname.includes("/preorder");
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, setModalEditState, setIsInputFocused, ...restProps }) => {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(record.qtyToReturn); // State to manage input value
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  const { t } = useTranslation();
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    setModalEditState(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      values.qtyToReturn = parseFloat(values.qtyToReturn);
      let returnTotal = record.qty - record.returnQty;
      let isDecimalFlag = false;
      await db.products
        .where("mProductId")
        .equalsIgnoreCase(record.product.mProductId)
        .and((product) => product.isactive === true)
        .toArray()
        // .then((product) => {
        //   if (product.length > 0 && product[0].uomData[0]?.decimal === "Y" && !Number.isInteger(values.qtyToReturn)) {
        //     isDecimalFlag = true;
        //   }
        // });
        .then(async (product) => {
          let productList = product;
          const tillData = JSON.parse(localStorage.getItem("tillData")) || {};
          const productId = record?.product?.mProductId;

          // 🔥 SYNC ONLY IF NOT FOUND
          if ((!productList || productList.length === 0) && productId) {
            try {
              const normalizedValue = productId.toString().trim();

              console.log("Syncing product for return validation:", normalizedValue);

              const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

              await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, normalizedValue);

              // 🔁 Re-fetch
              productList = await db.products
                .where("mProductId")
                .equalsIgnoreCase(productId)
                .and((product) => product.isactive === true)
                .toArray();
            } catch (err) {
              console.error("Return validation sync failed:", err);
            }
          }

          const productObj = productList?.[0];

          // ❌ STILL NOT FOUND → skip decimal validation
          if (!productObj) return;

          if (productObj?.uomData?.length > 0 && productObj.uomData[0]?.decimal === "Y" && !Number.isInteger(values.qtyToReturn)) {
            isDecimalFlag = true;
          }
        });

      if (values.qtyToReturn > returnTotal) {
        {
          message.warning(`${t("sales_return_error")}`);
        }
        throw new Error("Qty is more than ordered, invalid value");
      } else if (isDecimalFlag === false && values.qtyToReturn.toString().includes(".")) {
        message.warning(`${messages.warnings.payment.sales_return_qty_error}`);
        throw new Error("Qty is not a valid type, invalid value");
      } else {
        toggleEdit();
        record.qtyToReturn = values.qtyToReturn;
        handleSave({ ...record, ...values });
      }
    } catch (errInfo) {
      console.error("Save failed:", errInfo);
    }
  };

  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
        initialValue={record.qtyToReturn}
      >
        <Input
          className="qtyReturn"
          style={{ width: "40%", height: "5vh", borderRadius: "5px" }}
          onFocus={() => setIsInputFocused(true)}
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={save}
          onPressEnter={(e) => {
            e.preventDefault();
            save();
          }}
        />
      </Form.Item>
    ) : (
      <div
        className="qtyReturn"
        style={{
          border: "1px solid #d9d9d9",
          padding: "0.4vh 1vw",
          width: "40%",
          borderRadius: "5px",
          fontSize: "14px",
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};

const PointOfSaleMarket = (props) => {
  const { t } = useTranslation();
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  let parkedBillRef = useRef();
  let searchCustomersRef = useRef();
  //let notesInputRef = useRef();
  // const previousTcsRef = useRef(0);

  const redirectUrl = process.env.REACT_APP_redirectURL;
  const domainURL = process.env.REACT_APP_domain;
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const authHeaders = getOAuthHeaders();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const { dispatchEvent, dispatchItemSelection } = useEventBus();
  const {
    record,
    form,
    addProduct,
    cart,
    setCart,
    checkIsManualWeight,
    clearProductSearchResults,
    closeProductPanel,
    showAddNewCustomerFields,
    decreaseProductQty,
    deleteCart,
    giftCardData,
    setGiftCardData,
    deleteProduct,
    getMoreProducts,
    getSearchedProducts,
    increaseProductQty,
    isProductsFilter,
    isQtyUpdate,
    loader,
    loading,
    setLoading,
    onBarcodeInput,
    openDisplayParkedBillModal,
    setFilterdDate,
    orderType,
    parkBill,
    parkedList,
    setShowProductionOrder,
    productSearchInput,
    selectProductInCart,
    selectedProductInCart,
    selectedRowKeys,
    selectedKeys,
    setDisplayCustomerSearch,
    setDisplayUAECustomerSearch,
    setCloseCustomerFlag,
    setIsProductsFilter,
    setQtyNumberFlag,
    filtersFlag,
    setFiltersFlag,
    setIsQtyUpdate,
    setIsSearchProducts,
    setProductSearchInput,
    showOrderHistory,
    tillData,
    setManualDiscountInput,
    setSelectedManualDiscountTypeValue,
    prevHistoryRef,
    setManualDiscountModalVisible,
    setDisplayOfferProductSelection,
    offerProductsList,
    clearSelectedProductInCart,
    productListCardRef,
    posLogActivity,
    upsertPOSLog,
    removeCutomer,
    handleLoyaltyPayment,
    onChangeTotalQuantity,
    filterDrawer,
    setFilterDrawer,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    searchParkedBill,
    parkedBillSearchInput,
    filterdParkedList,
    discardParkedBill,
    setFilterdParkedList,
    parkedBills,
    mapParkedList,
    selectParkedBill,
    selectLayAwayOrder,
    setAddCashFlag,
    setCouponInput,
    searchOrderHistory,
    getSalesHistoryData,
    orderHistoryDetails,
    setOrderHistoryDetails,
    ordersCopy,
    paymentModal,
    tillDataPaymentMethods,
    requestPayment,
    setCouponModalVisible,
    paymentCardRef,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    setAmount,
    setNumb,
    onChangeAmount,
    paymentModalInputRef,
    processOrder,
    handleAmount,
    handleCashPayment,
    setOverPayedAmount,
    overPayedAmount,
    handleTotalQty,
    handleRealPrice,
    enterTotalQty,
    enterRealPrice,
    showPaymentMethods,
    setShowPaymentMethods,
    setCashAddInFlag,
    addCashFlag,
    isPrintModeXML,
    setSelectedKeys,
    setDisplayReturnOrderSearch,
    displayReturnOrderSearch,
    isProductsVisible,
    setIsProductsVisible,
    pickProduct,
    validateGiftCard,
    giftCardFlag,
    giftCardItems,
    setGiftCardType,
    setIsCardPaymentFlag,
    setIsGiftCardFlag,
    setKeyboardType,
    keyboardType,
    inputName,
    setInputName,
    keyboardInputFields,
    setKeyboardInputFields,
    keyboardRef,
    searchHistoryInput,
    setSearchhistoryInput,
    showEditOldCustomerFields,
    setEditFlag,
    openPaymentModalByCustomer,
    setSelectedProductInCart,
    setParkedBillSearchInput,
    salesHistoryCustomerSearchInput,
    salesHistoryDocumentNoSearchInput,
    setSalesHistoryCustomerSearchInput,
    setSalesHistoryDocumentNoSearchInput,
    quantityInputRef,
    setIsInputFocused,
    isInputFocused,
    getCategoryProducts,
    salesHistoryType,
    setStartRowData,
    startRowData,
    cartObj,
    documentSequence,
    setDocumnetSequence,
    notesValue,
    setNotesValue,
    selectedProductForNotes,
    setSelectedProductForNotes,
    couponModalVisible,
    displayCustomerSearch,
    displayAddNewCustomer,
    displayEditOldCustomer,
    isGiftCardFlag,
    manualDiscountModalVisible,
    loyalityOtpModalVisible,
    productsData,
    orderDelay,
    setOrderDelay,
    addToBagFlag,
    setAddToBagFlag,
    setStockList,
    stockList,
    displayUAECustomer,
    setDisplayUAECustomer,
    showSaleType,
    setShowSaleType,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    selectedSaleType,
    setSelectedSaleType,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    isRevenueCategoryFlag,
    setIsRevenueCategoryFlag,
    selectedRevenueCategoryName,
    setSelectedRevenueCategoryName,
    openSalesRep,
    setOpenSalesRep,
    manualDiscountForm,
    verifyStock,
    setIsStockModal,
    showPayments,
    setShowPayments,
    filteredPaymentMethods,
    setStartIndex,
    startIndex,
    getFilteredPaymentMethods,
    handleCartTotalClick,
    isShowingAll,
    setIsShowingAll,
    initialShowPayments,
    open,
    setOpen,
    productSearchInputRef,
    customerSearchInputRef,
    customerSearchInput,
    setCustomerSearchInput,
    layoutName,
    setLayoutName,
    giftCardRef,
    searchTerm,
    setSearchTerm,
    salesRepRef,
    salesRepValue,
    setSalesRepValue,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    documentTypes,
    keyboard,
    modifyProductList,
    currenciesData,
    calendarVisible,
    setCalendarVisible,
    selectedDate,
    setSelectedDate,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    realPrice,
    setRealPrice,
    firstInputValue,
    setFirstInputValue,
    customMixItems,
    setCustomMixItems,
    existingGroupItems,
    setExistingGroupItems,
    selectedCustomMix,
    setSelectedCustomMix,
    groupQty,
    setGroupQty,
    setOrderType,
    posSaleTypes,
    setPosSaleTypes,
    setCurrenciesData,
    hasShownCustomerModalRef,
    showCustomMix,
    setShowCustomMix,
    additionalInfo,
    setAdditionalInfo,
    additionalInfoForm,
    couponInfo,
    options,
    setOptions,
    searchInputRef,
    activeInput,
    setActiveInput,
    qtyInputRef,
    deleteReceipt,
    totalBillDiscountData,
    setTotalBillDiscountData,
    discountAdditionalInfo,
    setDiscountAdditionalInfo,
    discountAdditionalInfoForm,
    processManualDiscount,
    discountInforApplication,
    setProductStock,
    showCustomerWallet,
    setShowCustomerWallet,
    customersData,
    setCustomersData,
    selectedCustomer,
    setSelectedCustomer,
    fetchWalletData,
    tillLink,
    setTillLink,
    showCompleteSaleStock,
    setShowCompleteSaleStock,
    completeSaleStockData,
    setCompleteSaleStockData,
    setPettCashIn,
    isWalletFlag,
    setIswalletFlag,
    setIsNewGiftCardFlag,
    isRefundWalletOpen,
    setIsRefundWalletOpen,
    clearReturnCartData,
    cashIn,
    setCashIn,
    cashOut,
    setCashOut,
    pettyCashIn,
    setPettyCashIn,
    pettyCashOut,
    setPettyCashOut,
    processBillDiscounts,
    setLoader,
    processTotalManualDiscount,
    walletFunc,
    bankTransferFunc,
    syncLoad,
    setSyncLoad,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    setShowCardPaymnteModal,
    showCardPaymnteModal,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    setPopoverVisible,
    isPopoverVisible,
    dateRef,
    isCardPaymentFlag,
    processCouponApplication,
    selectedCoupon,
    setSelectedCoupon,
    selectedExternalCouponType,
    setSelectedExternalCouponType,
    checkExternalCoupon,
    totalBillCouponData,
    setTotalBillCouponData,
    couponInputRef,
    setCardPaymnetError,
    redeemNumberRef,
    isOnline,
    setIsOnline,
    integratedPaymentStatus,
    setIntegratedPaymentStatus,
    isViewMode,
    setIsViewMode,
    toCamelCaseMetaData,
    convertMetaDataToKeyValue,
    viewCustomerValues,
    setViewCustomerValues,
    customerForm,
    setDisplayEditOldCustomer,
    setDisplayAddNewCustomer,
    setSelectedEditOldCustomer,
    formDataCache,
    setFormDataCache,
    retailCustomerFields,
    isParkedBill,
    setIsparkedBill,
    setTempCart,
    checkAndShowTcsModal,
    retrieveParkedData,
    discardMessage,
    handleOk,
    discardGiftCards,
    fetchOnlineBatches,
    onlineBatches,
    setOnlineBatches,
    isRefundCustomerEdit,
    setIsRefundCustomerEdit,
    addSelectedReturnProductsToCart,
    selectedReturnOrder,
    setSelectedReturnOrder,
    checkedKeys,
    setCheckedKeys,
    getProductData,
    dataSource,
    setDataSource,
    handleSaveReturnCartRecord,
    showReturnPurchase,
    setShowReturnPurchase,
    selectPurchaseBillForReturn,
    retrunSearchType,
    setReturnSearchType,
    searchReturnHistory,
    showReturnOptions,
    setShowReturnOptions,
    isPurchaseReturn,
    setIsPurchaseReturn,
    notesPopup,
    setNotesPopup,
    handleShift,
    rejectQuotation,
    setRejectQuotation,
    setModalEditState,
    modalEditState,
    returnProcessRef,
    customerConfigData,
    retailCustomerRules,
    autoEnablePanCustomer,
    autoEnableNriBilling,
    handlePayment,
    paymentType,
    setPaymentType,
    isNriBilling,
    setIsNriBilling,
    customerSearchResult,
    setCustomerSearchResults,
    isPanCustomer,
    setIsPanCustomer,
    setSelectedRowKeys,
    selectedRowKeysRef,
    removeCoupon,
    previousTcsRef,
    exchangeCartTcs,
    setExchangeCartTcs,
    supplyRegionProceed,
    setSupplyRegionProceed,
    isNewGiftCardFlag,
    showGiftCardTopup,
    giftCardTopupPaymentMethod,
    setGiftCardTopupPaymentMethod,
    giftCardTopupCardInput,
    handleGiftCardTopupPostPayment,
    currentCardInput,
    setCurrentCardInput,
    handleWalletPostPayment,
    currentUPIInput,
    currentPaymentInput,
    giftCardTopupUPIInput,
  } = props;
  const { globalStore, setGlobalStore } = useGlobalContext();
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage } = globalStore;
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const posConfigData = JSON.parse(localStorage.getItem("posConfigData"));
  const customerId = tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId;
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;
  const [tableValue, setTableValue] = useState("POS");
  const [isReturn, setIsReturn] = useState(false);
  const [layawayFlag, setLayAwayFlag] = useState(false);
  const [reasonPopup, setReasonPopup] = useState(false);
  const [parkedBill, setParkedBill] = useState();
  const [keyValue, setKeyValue] = useState("0");
  const [reasonForm] = Form.useForm();
  const { width } = useWindowDimensions();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [cashManagementData, setCashManagementData] = useState(false);
  const [productArray, setProductArray] = useState();
  const [productItems, setProductItems] = useState([]);
  // const [open, setOpen] = useState(true);
  // const [paymentType, setPaymentType] = useState(tillDataPaymentMethods);
  const [isCashMangement, setIsCashManagement] = useState(false);
  const [returnFlag, setReturnFlag] = useState(false);
  const [productsDisplay, setProductDisplay] = useState("super-market");
  // const productsDisplay = "super-market";
  const [isLocked, setIsLocked] = useState(false);
  const history = useHistory();
  const { Option } = Select;
  const [clock1, setClock1] = useState(clock());
  const [showOverlay, setShowOverlay] = useState(rfidScanerFlag || false);
  const [enableProduction, setEnableProduction] = useState(posConfigData?.posType === "PRD" ? true : false);
  const [isQuotation, setIsQuotation] = useState(() => {
    const cartObj = localStorage.getItem("cartObj");
    return cartObj ? (JSON.parse(cartObj)?.isQuotation ?? false) : false;
  });
  const [showCreateOrder, setShowCreateOrder] = useState(false);
  // const [rejectQuotation, setRejectQuotation] = useState(false);
  const [showOrderSelection, setShowOrderSelection] = useState(false);
  const [saleTypeData, setSaleTypeData] = useState([]);
  const [calendarVisibleMap, setCalendarVisibleMap] = useState({});

  // Return Bill Start
  // const [modalEditState, setModalEditState] = useState(false);
  const [isSectionVisible, setIsSectionVisible] = useState(false);
  const showVirtualKeyboard = posConfig?.showKeyboard === "Y" ? true : false;
  const returnReasons = JSON.parse(localStorage.getItem("tillData")).returnReasons;
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillAccessData = tillData?.tillAccess;
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const wsUrl = process.env.REACT_APP_WS_URL;

  const productSearchRef = useRef(null);
  const productPanelSearchRef = useRef(null);
  //view stock
  const [viewStock, setViewStock] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const selectBagRef = useRef(null);

  const [activeTab, setActiveTab] = useState("pending");
  const [loadingCart, setLoadingCart] = useState(false);
  const [cartHistoryData, setCartHistoryData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [showPrintTemplateModal, setShowPrintTemplateModal] = useState(false);
  const [selectedPrintTemplate, setSelectedPrintTemplate] = useState(null);
  const [pendingReprintRecord, setPendingReprintRecord] = useState(null);
  const printTemplates = tillData?.tillAccess?.cwrTill?.printTemplates ? JSON.parse(tillData.tillAccess.cwrTill.printTemplates) : [];
  const enableMultiPrintTemplates = tillData?.tillAccess?.cwrTill?.enableMultiPrintTemplates === "Y";
  const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
  const exchangeCart = localStorage.getItem("selectedReturnType");
  const [isEstimatesFlag, setIsEstimatesFlag] = useState(false);
  const [activeEstimatesTab, setActiveEstimatesTab] = useState("pending");
  const [loadingEstimates, setLoadingEstimates] = useState(false);
  const [estimatesData, setEstimatesData] = useState([]);
  const [searchEstimatesInput, setSearchEstimatesInput] = useState("");
  const [expandedEstimatesRowKey, setExpandedEstimatesRowKey] = useState(null);
  const isStoreCredit = localStorage.getItem("selectedReturnType") === "EXCHANGE";
  const payments = tillData.tillAccess.csBunit.paymentMethodList;
  const tillId = tillData.tillAccess?.cwrTill?.cwrTillID;
  const tillSession = JSON.parse(localStorage.getItem("tillSession"));
  const sessionId = tillSession?.tillSessionId;
  const paymentMethodList = payments.filter((payment) => !payment.cwrTillId || payment?.cwrTillId === tillId);
  // Get current month date range
  const getCurrentMonthRange = () => {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    return [startOfMonth, endOfMonth];
  };

  // Map tab to status
  const getStatusForTab = (tab) => {
    switch (tab) {
      case "pending":
        return "DR";
      case "processed":
        return "CO";
      case "cancelled":
        return "CL";
      default:
        return "DR";
    }
  };

  const getStatusForEstimatesTab = (tab) => {
    switch (tab) {
      case "pending":
        return "PE";
      case "processed":
        return "CO";
      case "cancelled":
        return "CL";
      default:
        return "PE";
    }
  };

  // Fetch cart history data
  const fetchCartHistory = async (status) => {
    setLoadingCart(true);
    try {
      const dateRange = getCurrentMonthRange();
      const filterBy = JSON.stringify({
        status: [status],
        DateRange: dateRange,
      });
      const sortBy = JSON.stringify({
        created: "DESC",
      });

      const response = await cartHistory({
        q: searchInput,
        filter_by: filterBy,
        sort_by: sortBy,
        tillId: tillData?.tillAccess?.cwrTill?.cwrTillID ? tillData?.tillAccess?.cwrTill?.cwrTillID : null,
      });
      if (response?.status === 200) {
        const data = JSON.parse(response?.data?.data?.cartHistory || "[]");

        // Transform the data to add keys for the table
        const transformedData = data.map((item, index) => ({
          ...item,
          key: item.cwr_store_discount_id || `${index}`,
        }));

        setCartHistoryData(transformedData);
      } else {
        message.warning("Something is wrong in cartHistory service");
      }
    } catch (error) {
      console.error("Error fetching cart history:", error);
    } finally {
      setLoadingCart(false);
    }
  };

  // Fetch data on component mount (default to Pending/DR)
  useEffect(() => {
    if (isParkedBill) fetchCartHistory("DR");
  }, [isParkedBill]);

  // Handle tab change
  const handleTabChange = (key) => {
    setActiveTab(key);
    const status = getStatusForTab(key);
    fetchCartHistory(status);
    setExpandedRowKey(null);
  };

  // Fetch cart history data
  const fetchEstimates = async (status) => {
    setLoadingEstimates(true);
    try {
      const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
      const currentDate = moment().format("YYYY-MM-DD");
      const response = await getEstimates({
        bunitId: bunitId,
        recordId: "",
        status: status,
        startRow: "0",
        endRow: "2000",
        date: currentDate,
        documentno: searchEstimatesInput,
      });
      if (response?.status === 200) {
        const data = JSON.parse(response?.data?.data?.getEstimates || "[]");

        // Transform the data to add keys for the table
        const transformedData = data?.estimates?.map((item, index) => ({
          ...item,
          key: item.s_estimate_id || `${index}`,
        }));

        setEstimatesData(transformedData);
      } else {
        message.warning("Something is wrong in get estimates service");
      }
    } catch (error) {
      console.error("Error fetching estimates:", error);
    } finally {
      setLoadingEstimates(false);
    }
  };

  const toCamelCase = (str) => {
    if (!str) return "";

    return str
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase()))
      .replace(/\s+/g, "");
  };

  // Fetch data on component mount (default to Pending/PE)
  useEffect(() => {
    if (isEstimatesFlag) fetchEstimates("PE");
  }, [isEstimatesFlag]);

  const toggleExpand = (key) => {
    setExpandedRowKey(expandedRowKey === key ? null : key);
  };

  const handleRetrieve = async (record) => {
    console.log("[v0] Retrieving record:", record);
    const selectedParkedBill = { ...record.cart_items, isRetrived: "Y", cwr_pos_cart_id: record?.cwr_pos_cart_id };
    let stockCheckResult = true;
    let isFinalValidation = false;
    let isCompleteSale = false;
    if (navigator.onLine && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
      stockCheckResult = await stock({
        cart: selectedParkedBill,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      } else {
        setShowPaymentMethods(true);
        setOrderHistoryDetails([]);
        setIsparkedBill(false);
      }
    } else {
      setShowPaymentMethods(true);
      setOrderHistoryDetails([]);
      setIsparkedBill(false);
    }
    setCart(selectedParkedBill);
    localStorage.setItem("cartObj", JSON.stringify(selectedParkedBill));
    setCartHistoryData([]);
    setExpandedRowKey(null);
  };

  const handleRetrieveEstimate = async (record) => {
    console.log("[v0] Retrieving estimate record:", record);
    const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
    const documentno = `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`;
    const cartData = JSON.parse(record.estimate_json || "{}");
    cartData.estimateId = record?.s_estimate_id;
    cartData.documentno = documentno;
    cartData.tillName = JSON.parse(localStorage.getItem("tillValue"))?.name;
    if (record?.is_advanceorder === "Y") {
      cartData.layAway = "Y";
    }

    let stockCheckResult = true;
    let isFinalValidation = false;
    if (navigator.onLine && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
      stockCheckResult = await stock({
        cart: cartData,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      } else {
        setShowPaymentMethods(true);
        setOrderHistoryDetails([]);
        setIsEstimatesFlag(false);
      }
    } else {
      setShowPaymentMethods(true);
      setOrderHistoryDetails([]);
      setIsEstimatesFlag(false);
    }
    setCart(cartData);
    localStorage.setItem("cartObj", JSON.stringify(cartData));
    setEstimatesData([]);
    setExpandedEstimatesRowKey(null);
    setSearchEstimatesInput("");
  };

  const toFixedTruncate = (num, decimalPlaces = 3) => {
    if (isNaN(num) || num === null) num = 0;
    const factor = Math.pow(10, decimalPlaces);
    const truncatedNum = Math.trunc(num * factor) / factor;
    const result = truncatedNum.toFixed(decimalPlaces);
    return result;
  };

  const applyRounding = (value, precision = pricePrecision) => {
    if (isNaN(value) || value === null) return 0;
    const factor = Math.pow(10, precision);
    switch (roundingOption) {
      case "Round Up":
        return Math.ceil(value * factor) / factor;
      case "Round Down":
        return Math.floor(value * factor) / factor;
      case "No Rounding":
      default:
        return parseFloat(toFixedTruncate(value, precision));
    }
  };

  // useEffect(() => {
  //   const subtotal = cart?.subTotal || 0;
  //   const localCart = JSON.parse(localStorage.getItem("cartObj"));
  //   const tempServiceChargeAmount = localCart?.serviceCharge || applyRounding(serviceChargeEnabled ? (subtotal * serviceChargePercentage) / 100 : 0);
  //   const tempTipTotal = localCart?.tip || applyRounding(tipMode === "Percentage" && tipPercentage > 0 ? (subtotal * tipPercentage) / 100 : tipAmount);
  //   const tempDeliveryChargeAmount = localCart?.deliveryCharge || applyRounding(deliveryCharge);
  //   const tempPackingChargeAmount = localCart?.packingCharge || applyRounding(packingCharge);
  //   // const tempAdditionalChargesTotal = tempServiceChargeAmount + tempTipTotal + tempDeliveryChargeAmount + tempPackingChargeAmount;
  //   setServiceChargeAmount(tempServiceChargeAmount);
  //   setTipTotal(tempTipTotal);
  //   setDeliveryChargeAmount(tempDeliveryChargeAmount);
  //   setPackingChargeAmount(tempPackingChargeAmount);
  //   // setAdditionalChargesTotal(tempAdditionalChargesTotal);
  // }, [additionalCharges, serviceChargeEnabled, serviceChargePercentage]);

  // const handleApplyCharges = () => {
  //   setAdditionalCharges(false);
  //   const subtotal = cart?.subTotal || 0;
  //   const localCart = JSON.parse(localStorage.getItem("cartObj"));
  //   const tempServiceChargeAmount = applyRounding(serviceChargeEnabled ? (subtotal * serviceChargePercentage) / 100 : 0);
  //   const tempTipTotal = applyRounding(tipMode === "Percentage" && tipPercentage > 0 ? (subtotal * tipPercentage) / 100 : tipAmount);
  //   const tempDeliveryChargeAmount = applyRounding(deliveryCharge);
  //   const tempPackingChargeAmount = applyRounding(packingCharge);
  //   // const tempAdditionalChargesTotal = tempServiceChargeAmount + tempTipTotal + tempDeliveryChargeAmount + tempPackingChargeAmount;
  //   setServiceChargeAmount(tempServiceChargeAmount);
  //   setTipTotal(tempTipTotal);
  //   setDeliveryChargeAmount(tempDeliveryChargeAmount);
  //   setPackingChargeAmount(tempPackingChargeAmount);
  //   // setAdditionalChargesTotal(tempAdditionalChargesTotal);
  //   if (localCart) {
  //     localCart.serviceCharge = tempServiceChargeAmount;
  //     localCart.tip = tempTipTotal;
  //     localCart.deliveryCharge = tempDeliveryChargeAmount;
  //     localCart.packingCharge = tempPackingChargeAmount;
  //     const updatedTotal =
  //       parseFloat(localCart.subTotal || 0) + parseFloat(localCart.tax || 0) + tempServiceChargeAmount + tempTipTotal + tempDeliveryChargeAmount + tempPackingChargeAmount;
  //     localCart.total = updatedTotal;
  //     localStorage.setItem("cartObj", JSON.stringify(localCart));
  //     setCart(localCart);
  //   }
  // };

  const handleApplyCharges = () => {
    setAdditionalCharges(false);

    const chargeMap = {};

    tempSaleTypeData.forEach((charge, index, array) => {
      const chargeType = charge.chargeType;
      const sameTypeCount = array.filter((c) => c.chargeType === chargeType).length;

      let uiValue = null;

      if (chargeType === "SERVICE_CHARGE") {
        uiValue = serviceChargeEnabled ? serviceChargePercentage : null;
      }
      if (chargeType === "TIP") {
        uiValue = tipMode === "Percentage" ? tipPercentage : tipAmount;
      }
      if (chargeType === "DELIVERY_FEE") {
        uiValue = deliveryCharge;
      }
      if (chargeType === "PACKING_FEE") {
        uiValue = packingCharge;
      }

      chargeMap[chargeType] = {
        value: uiValue !== null && uiValue !== "" ? Number(uiValue) : null,
        defaultAmount: charge.defaultAmount,
        defaultPercentage: charge.defaultPercentage,
        isPercentage:
          (chargeType === "SERVICE_CHARGE" && serviceChargeEnabled) ||
          (chargeType === "TIP" && tipMode === "Percentage") ||
          (charge.defaultPercentage > 0 && charge.defaultAmount === 0),
        sameTypeCount: sameTypeCount,
      };
    });

    const subtotal = cart?.subTotal || 0;
    const localCart = JSON.parse(localStorage.getItem("cartObj")) || {};
    const tax = localCart.tax || 0;

    const serviceChargeAmt = calculateCharge(chargeMap["SERVICE_CHARGE"], subtotal);
    const tipAmt = calculateCharge(chargeMap["TIP"], subtotal);
    const deliveryAmt = calculateCharge(chargeMap["DELIVERY_FEE"], subtotal);
    const packingAmt = calculateCharge(chargeMap["PACKING_FEE"], subtotal);

    const tempServiceCharge = applyRounding(serviceChargeAmt);
    const tempTip = applyRounding(tipAmt);
    const tempDelivery = applyRounding(deliveryAmt);
    const tempPacking = applyRounding(packingAmt);

    localCart.serviceCharge = tempServiceCharge;
    localCart.tip = tempTip;
    localCart.deliveryCharge = tempDelivery;
    localCart.packingCharge = tempPacking;

    localCart.total = parseFloat(subtotal) + parseFloat(tax) + tempServiceCharge + tempTip + tempDelivery + tempPacking;

    localStorage.setItem("cartObj", JSON.stringify(localCart));
    setCart(localCart);
  };

  const compare = (lhs, operator, rhs) => {
    switch (operator) {
      case ">":
        return lhs > rhs;
      case "<":
        return lhs < rhs;
      case "=":
        return lhs == rhs;
      default:
        return false;
    }
  };

  const selectedReturnType = localStorage.getItem("selectedReturnType");

  let activeCart = cart;

  if (selectedReturnType === "EXCHANGE") {
    const exchangeCart = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
    if (exchangeCart?.customer) {
      activeCart = exchangeCart;
    }
  }

  // const computeTCS = (cart, tempSaleTypeData) => {
  //   if (!cart?.customer) return { total: 0, eligible: false };

  //   const isNRI = cart?.customer?.nriBilling === true;
  //   if (isNRI) {
  //     const cartTotal = cart?.total || 0;

  //     const tcsCharge = tempSaleTypeData?.find((c) => c.chargeType === "TCS");

  //     let threshold = 0;
  //     let rate = 0;

  //     if (tcsCharge?.conditionsFormula) {
  //       const formula = JSON.parse(tcsCharge.conditionsFormula);

  //       // 👉 Get NRI threshold from applicability
  //       const applicabilityConditions = formula?.applicability?.conditions || [];
  //       for (const cond of applicabilityConditions) {
  //         if (cond?.when?.field === "customer.customer_type" && cond?.when?.operator === "IN" && cond?.when?.value?.includes("NRI")) {
  //           threshold = cond.value; // ✅ dynamic threshold from JSON
  //           break;
  //         }
  //       }

  //       // 👉 Get NRI rate from rate_determination
  //       const rateConditions = formula?.rate_determination?.conditions || [];

  //       for (const cond of rateConditions) {
  //         if (cond?.when?.field === "customer.customer_type" && cond?.when?.operator === "IN" && cond?.when?.value?.includes("NRI")) {
  //           rate = cond.rate;
  //           break;
  //         }
  //       }
  //     }

  //     if (threshold === 0 || rate === 0) {
  //       return { total: 0, eligible: false };
  //     }

  //     if (cartTotal > threshold) {
  //       const subtotal = cart?.subTotal || 0;
  //       const nriTcs = applyRounding(subtotal * rate);

  //       return {
  //         total: nriTcs,
  //         eligible: true,
  //       };
  //     }

  //     // below threshold
  //     return { total: 0, eligible: false };
  //   }
  //   if (!cart?.customer?.customerProperties) return { total: 0, eligible: false };

  //   const tcsCharge = tempSaleTypeData?.find((c) => c.chargeType === "TCS");
  //   if (!tcsCharge || !tcsCharge.conditionsFormula) return { total: 0, eligible: false };

  //   const formula = JSON.parse(tcsCharge.conditionsFormula);
  //   // 👉 Determine rate from rate_determination
  //   let rate = 0;
  //   const rateDetermination = formula?.rate_determination;
  //   // const panStatus = cart.customer.customerProperties?.realStatus;
  //   const panStatus = cart.customer.customerProperties?.realStatus?.trim()?.toUpperCase();
  //   if (rateDetermination?.type === "conditional") {
  //     for (const cond of rateDetermination.conditions || []) {
  //       const { when, rate: condRate } = cond;
  //       if (
  //         when.field === "customer.pan_status" &&
  //         when.operator === "IN" &&
  //         when.value
  //           ?.filter((v) => v !== null && v !== undefined)
  //           .map((v) => v.toString().trim().toUpperCase())
  //           .includes(panStatus)
  //       ) {
  //         rate = condRate;
  //         break;
  //       }
  //     }
  //   }

  //   if (rate === 0) return { total: 0, eligible: false };

  //   // clear previous itemTcs
  //   cart.items?.forEach((item) => delete item.itemTcs);

  //   // 👉 Apply calculation rule
  //   let totalTcs = 0;
  //   // const applicability = formula?.applicability?.conditions?.[0];
  //   const applicabilityConditions = formula?.applicability?.conditions || [];
  //   let applicableCondition = null;
  //   for (const cond of applicabilityConditions) {
  //     // 👉 Skip NRI condition if not NRI
  //     if (cond.when) {
  //       if (cond.when.field === "customer.customer_type" && cond.when.operator === "IN" && cond.when.value?.includes("NRI")) {
  //         if (cart?.customer?.nriBilling) {
  //           applicableCondition = cond;
  //           break;
  //         } else {
  //           continue; // skip this condition
  //         }
  //       }
  //     }

  //     // 👉 Normal condition fallback
  //     if (!cond.when) {
  //       applicableCondition = cond;
  //     }
  //   }
  //   let hasEligibleItems = false;
  //   let subtotalTrigger = false;

  //   if (applicableCondition?.field === "cart.bill_item_value") {
  //     cart.items?.forEach((item) => {
  //       const itemValue = item.linegross || item.lineGross || item.nettotal || 0;
  //       if (compare(itemValue, applicableCondition.operator, applicableCondition.value)) {
  //         hasEligibleItems = true;
  //         const itemTcs = applyRounding(itemValue * rate);
  //         totalTcs += itemTcs;
  //         item.itemTcs = itemTcs;
  //       }
  //     });
  //   } else {
  //     const subtotal = cart?.subTotal || 0;
  //     if (compare(subtotal, applicableCondition.operator, applicableCondition.value)) {
  //       subtotalTrigger = true;
  //       totalTcs += subtotal * rate;
  //     }
  //   }

  //   return {
  //     total: applyRounding(totalTcs),
  //     eligible: hasEligibleItems || subtotalTrigger,
  //   };
  // };

  const computeTCS = (cart, tempSaleTypeData) => {
    if (!cart?.customer) return { total: 0, eligible: false };

    const tcsCharge = tempSaleTypeData?.find((c) => c.chargeType === "TCS");
    if (!tcsCharge || !tcsCharge.conditionsFormula) {
      return { total: 0, eligible: false };
    }

    const formula = JSON.parse(tcsCharge.conditionsFormula);

    const isNRI = cart?.customer?.nriBilling === true;
    const panStatus = cart?.customer?.customerProperties?.realStatus?.toString()?.trim()?.toUpperCase();

    // =========================
    // ✅ STEP 1: RATE
    // =========================
    let rate = 0;
    const rateConditions = formula?.rate_determination?.conditions || [];

    for (const cond of rateConditions) {
      const { when, rate: condRate } = cond;

      // 👉 NRI rate
      if (when?.field === "customer.customer_type" && when?.operator === "IN" && when?.value?.includes("NRI") && isNRI) {
        rate = condRate;
        break;
      }

      // 👉 PAN-based rate (Non-NRI)
      if (
        when?.field === "customer.pan_status" &&
        when?.operator === "IN" &&
        when?.value
          ?.filter((v) => v !== null && v !== undefined)
          .map((v) => v.toString().trim().toUpperCase())
          .includes(panStatus)
      ) {
        rate = condRate;
        break;
      }
    }

    if (rate === 0) return { total: 0, eligible: false };

    // =========================
    // ✅ STEP 2: APPLICABILITY
    // =========================
    const applicabilityConditions = formula?.applicability?.conditions || [];
    let applicableCondition = null;

    for (const cond of applicabilityConditions) {
      // 👉 NRI condition
      if (cond?.when?.field === "customer.customer_type" && cond?.when?.operator === "IN" && cond?.when?.value?.includes("NRI")) {
        if (isNRI) {
          applicableCondition = cond;
          break;
        } else {
          continue;
        }
      }

      // 👉 Default fallback
      if (!cond?.when) {
        applicableCondition = cond;
      }
    }

    if (!applicableCondition) {
      return { total: 0, eligible: false };
    }

    // =========================
    // ✅ STEP 3: THRESHOLD (NRI only)
    // =========================
    if (isNRI && applicableCondition.field === "cart.total") {
      const cartTotal = cart?.total || 0;

      if (!compare(cartTotal, applicableCondition.operator, applicableCondition.value)) {
        return { total: 0, eligible: false };
      }
    }

    // =========================
    // ✅ STEP 4: ITEM CALCULATION
    // =========================

    // clear previous values
    cart.items?.forEach((item) => delete item.itemTcs);

    let totalTcs = 0;
    let hasEligibleItems = false;

    cart.items?.forEach((item) => {
      const itemValue = item.linegross || item.lineGross || item.nettotal || 0;

      // 👉 CASE 1: NRI (cart.total condition already passed)
      if (applicableCondition.field === "cart.total") {
        hasEligibleItems = true;

        const itemTcs = applyRounding(itemValue * rate);
        totalTcs += itemTcs;

        item.itemTcs = itemTcs;
      }

      // 👉 CASE 2: Normal item-level condition
      else if (compare(itemValue, applicableCondition.operator, applicableCondition.value)) {
        hasEligibleItems = true;

        const itemTcs = applyRounding(itemValue * rate);
        totalTcs += itemTcs;

        item.itemTcs = itemTcs;
      }
    });

    return {
      total: applyRounding(totalTcs),
      eligible: hasEligibleItems,
    };
  };

  const getChargeLabel = (charge, cart) => {
    // Special case for TCS
    if (charge.chargeType === "TCS") {
      const tcsValue = cart?.tcs ? Number(cart.tcs).toFixed(2) : "0";
      return `TCS - ${tcsValue}`;
    }

    // Normal UI display name logic
    try {
      if (charge.conditionsFormula) {
        const parsed = JSON.parse(charge.conditionsFormula);
        if (parsed?.ui?.display_name) {
          return parsed.ui.display_name;
        }
      }
    } catch (e) {}

    // Fallback formatting
    const label = charge.chargeType.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()); // DELIVERY_FEE → Delivery Fee

    // No value for other types since requirement was only for TCS
    return label;
  };

  const renderAdditionalChargesButton = () => {
    if (!tempSaleTypeData || tempSaleTypeData.length === 0) return null;

    return (
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-parked-bill"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => setAdditionalCharges(true)}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <AdditionalChargesIcon color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Additional Charges</span>
          </div>
        </button>
      </div>
    );
  };

  const calculateCharge = (charge, subtotal) => {
    if (!charge) return 0;

    if (charge.value !== null) {
      if (charge.isPercentage) {
        return (subtotal * charge.value) / 100;
      }
      return charge.value;
    }

    // default fallback
    if (charge.sameTypeCount === 1) {
      if (charge.isPercentage && charge.defaultPercentage > 0) {
        return (subtotal * charge.defaultPercentage) / 100;
      }
      return charge.defaultAmount || 0;
    }

    return 0;
  };

  // const resetToInitialState = () => {
  //   setServiceChargeEnabled(false);
  //   setServiceChargePercentage(5);
  //   setTipMode("Percentage");
  //   setTipPercentage(0);
  //   setTipAmount(0);
  //   setDeliveryCharge(0);
  //   setPackingCharge(0);
  //   setRoundingOption("No Rounding");
  //   setServiceChargeAmount(0);
  //   setTipTotal(0);
  //   setDeliveryChargeAmount(0);
  //   setPackingChargeAmount(0);
  //   const localCart = JSON.parse(localStorage.getItem("cartObj"));
  //   if (localCart) {
  //     localCart.serviceCharge = 0;
  //     localCart.tip = 0;
  //     localCart.deliveryCharge = 0;
  //     localCart.packingCharge = 0;
  //     const updatedTotal = parseFloat(localCart.subTotal || 0) + parseFloat(localCart.tax || 0);
  //     localCart.total = updatedTotal;
  //     localStorage.setItem("cartObj", JSON.stringify(localCart));
  //     setCart(localCart);
  //   }
  // };

  const realPriceRef = useRef(null);
  // const [showCustomMix, setShowCustomMix] = useState(false);
  // const [customMixItems, setCustomMixItems] = useState([]);
  const [groupName, setGroupName] = useState("Custom Mix");
  // const [groupQty, setGroupQty] = useState(1);
  const [expandTotals, setExpandTotals] = useState(false);
  const [showInputFields, setShowInputFields] = useState(false);
  const [productMap, setProductMap] = useState({});
  const { TabPane } = Tabs;
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

  //Additional Charges
  const [additionalCharges, setAdditionalCharges] = useState(false);
  const [tempSaleTypeData, setTempSaleTypeData] = useState([]);
  const [serviceChargeEnabled, setServiceChargeEnabled] = useState(false);
  const [serviceChargePercentage, setServiceChargePercentage] = useState(5);
  const [tipMode, setTipMode] = useState("Percentage");
  const [tipPercentage, setTipPercentage] = useState(0);
  const [tipAmount, setTipAmount] = useState(0);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [packingCharge, setPackingCharge] = useState(0);
  const [tcsModalAmount, setTcsModalAmount] = useState(0);
  const [showTcsModal, setShowTcsModal] = useState(false);
  const [roundingOption, setRoundingOption] = useState("No Rounding");
  const [serviceChargeAmount, setServiceChargeAmount] = useState(() => {
    const localCart = JSON.parse(localStorage.getItem("cartObj"));
    if (localCart) {
      if (localCart?.serviceCharge) {
        return localCart?.serviceCharge;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  });
  const [tipTotal, setTipTotal] = useState(() => {
    const localCart = JSON.parse(localStorage.getItem("cartObj"));
    if (localCart) {
      if (localCart?.tip) {
        return localCart?.tip;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  });
  const [deliveryChargeAmount, setDeliveryChargeAmount] = useState(() => {
    const localCart = JSON.parse(localStorage.getItem("cartObj"));
    if (localCart) {
      if (localCart?.deliveryCharge) {
        return localCart?.deliveryCharge;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  });
  const [packingChargeAmount, setPackingChargeAmount] = useState(() => {
    const localCart = JSON.parse(localStorage.getItem("cartObj"));
    if (localCart) {
      if (localCart?.packingCharge) {
        return localCart?.packingCharge;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  });

  useEffect(() => {
    const saleTypeData = localStorage.getItem("saleTypeData");
    if (saleTypeData) {
      const parsed = JSON.parse(saleTypeData);
      const localCartFromStorage = JSON.parse(localStorage.getItem("cartObj")) || {};
      let updatedTempSaleTypeData = parsed?.additionalCharges || [];
      if (updatedTempSaleTypeData?.length > 0) {
        // Default localCart fields to 0 if null or undefined
        const localCart = {
          ...localCartFromStorage,
          serviceCharge: localCartFromStorage.serviceCharge ?? 0,
          tip: localCartFromStorage.tip ?? 0,
          deliveryCharge: localCartFromStorage.deliveryCharge ?? 0,
          others: localCartFromStorage.others ?? 0,
          packingCharge: localCartFromStorage.packingCharge ?? 0,
          tax: localCartFromStorage.tax ?? 0,
          total: localCartFromStorage.total ?? 0, // Ensure total starts as 0
        };
        // Map localCart values to tempSaleTypeData with priority on user selection
        updatedTempSaleTypeData = updatedTempSaleTypeData.map((charge, index, array) => {
          const sameTypeCount = array.filter((c) => c.chargeType === charge.chargeType).length;
          const subtotal = cart?.subTotal ?? 0; // Default to 0 if undefined
          const localValue =
            localCart[
              charge.chargeType === "SERVICE_CHARGE"
                ? "serviceCharge"
                : charge.chargeType === "TIP"
                  ? "tip"
                  : charge.chargeType === "DELIVERY_FEE"
                    ? "deliveryCharge"
                    : charge.chargeType === "OTHERS"
                      ? "others"
                      : charge.chargeType === "PACKING_FEE"
                        ? "packingCharge"
                        : null
            ] || 0;
          const isPercentageMatch = charge.defaultPercentage > 0 && Math.abs(localValue - (subtotal * charge.defaultPercentage) / 100) < 0.01;

          let newValue;
          if (localValue > 0) {
            newValue = isPercentageMatch ? charge.defaultPercentage : localValue;
          } else if (sameTypeCount > 1 && localValue === 0) {
            newValue = ""; // Show placeholder for multiple options with no selection
          } else {
            newValue = charge.value ?? (charge.defaultAmount !== 0 ? charge.defaultAmount : charge.defaultPercentage);
          }

          switch (charge.chargeType) {
            case "SERVICE_CHARGE":
            case "TIP":
            case "DELIVERY_FEE":
            case "OTHERS":
            case "PACKING_FEE":
              return { ...charge, value: newValue };
            default:
              return charge;
          }
        });

        setTempSaleTypeData(updatedTempSaleTypeData);

        // Initialize or update localCart total with debugging
        // const subtotal = localCart?.subTotal ?? 0; // Ensure subtotal is 0 if undefined
        // const tax = localCart.tax;
        const discount = localCart.discount;
        // const updatedTotal =
        //   // parseFloat(subtotal) +
        //   // parseFloat(tax) +
        //   localCart?.total +
        //   // -
        //   // parseFloat(discount)
        //   localCart.serviceCharge +
        //   localCart.tip +
        //   localCart.deliveryCharge +
        //   localCart.others +
        //   localCart.packingCharge +
        //   (localCart.tcs ?? 0);
        let updatedTotal;

        if (localCart.isReturn === true) {
          const returnTotal = localCart.items.reduce((sum, item) => sum + (item.nettotal ?? 0), 0);
          const existingTcs = localCart.tcs ?? 0;
          const cleanedCart = {
            ...localCart,
            subTotal: returnTotal,
            tax: 0,
            serviceCharge: 0,
            tip: 0,
            deliveryCharge: 0,
            others: 0,
            packingCharge: 0,
            total: returnTotal + existingTcs,
          };
          localStorage.setItem("cartObj", JSON.stringify(cleanedCart));
          return;
        } else {
          updatedTotal =
            (localCart.subTotal ?? 0) +
            (localCart.tax ?? 0) +
            (localCart.serviceCharge ?? 0) +
            (localCart.tip ?? 0) +
            (localCart.deliveryCharge ?? 0) +
            (localCart.others ?? 0) +
            (localCart.packingCharge ?? 0);
        }
        if (localCart.total !== updatedTotal && (localCart?.isReturn !== true || localCart?.isLayaway !== "Y")) {
          localCart.total = updatedTotal;
          localStorage.setItem("cartObj", JSON.stringify(localCart));

          // Avoid unnecessary setCart loop
          // if (JSON.stringify(cart) !== JSON.stringify(localCart)) {
          //   setCart(localCart);
          // }
        }
      }
    }
  }, [cart]);

  useEffect(() => {
    if (!cart || !Array.isArray(cart.items)) return;
    if (!Array.isArray(tempSaleTypeData)) return;

    const selectedReturnType = localStorage.getItem("selectedReturnType");

    const stored = selectedReturnType === "EXCHANGE" ? JSON.parse(localStorage.getItem("exchangeCartObj")) || {} : JSON.parse(localStorage.getItem("cartObj")) || cart;

    // compute tcs
    let tcsValue;
    if (stored.isReturn) {
      tcsValue = stored.tcs || 0;
    } else {
      const exchangeCart = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
      const activeCart = selectedReturnType === "EXCHANGE" && exchangeCart?.customer ? exchangeCart : cart;
      const { total } = computeTCS(activeCart, tempSaleTypeData);
      tcsValue = total;
    }

    // const subtotal = stored.subTotal || 0;
    // const tax = stored.tax || 0;
    const discount = stored.discount || 0;

    const updatedTotal =
      (stored.subTotal || 0) +
      (stored.tax || 0) +
      (stored.serviceCharge || 0) +
      (stored.tip || 0) +
      (stored.deliveryCharge || 0) +
      (stored.others || 0) +
      (stored.packingCharge || 0) +
      tcsValue;

    const tcsChanged = stored.tcs !== tcsValue;
    const totalChanged = Math.abs((stored.total || 0) - updatedTotal) > 0.01;

    if (tcsChanged || totalChanged) {
      // build safe cart update
      const merged = {
        ...stored,
        // ...cart, // preserve items, customer, etc
        tcs: tcsValue,
        total: updatedTotal,
      };

      if (selectedReturnType === "EXCHANGE") {
        localStorage.setItem("exchangeCartObj", JSON.stringify(merged));
      } else {
        localStorage.setItem("cartObj", JSON.stringify(merged));
      }

      // update react state as well
      // setCart(merged);
    }
  }, [cart?.items, cart?.subTotal, tempSaleTypeData, cart?.customer, cart?.discount, exchangeCartTcs]);

  useEffect(() => {
    if (!cart) return;
    if (cart.isReturn) return;

    const selectedReturnType = localStorage.getItem("selectedReturnType");
    const exchangeCart = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
    const activeCart = selectedReturnType === "EXCHANGE" && exchangeCart?.customer ? exchangeCart : cart;
    const { total, eligible } = computeTCS(activeCart, tempSaleTypeData);
    const prev = previousTcsRef.current;

    if (eligible && total > 0 && total !== prev) {
      setTcsModalAmount(total);
      setShowTcsModal(true);

      // auto close after 5 sec (optional)
      setTimeout(() => setShowTcsModal(false), 5000);
    }

    previousTcsRef.current = total;
  }, [cart?.total, cart?.subTotal, cart?.items, cart?.customer, cart?.discount, tempSaleTypeData, exchangeCartTcs]);

  useEffect(() => {
    if (!selectedProductInCart || !selectedProductInCart.productId) return;

    // Check if the selected product still exists in the cart
    const stillExists = cart.items.some((item) => item.productId === selectedProductInCart.productId);

    if (!stillExists) {
      // If deleted, auto-select the next available item
      if (cart.items.length > 0) {
        setSelectedProductInCart(cart.items[cart.items.length - 1]);
      } else {
        // If no items left, clear the panel
        setSelectedProductInCart({});
        setStockList([]);
      }
    }
  }, [cart.items]); // runs every time cart items update

  useEffect(() => {
    if (cardPaymnetStatusPLB) {
      Modal.info({
        icon: null,
        // centered: true,
        okButtonProps: { style: { display: "none" } },
        okText: "Go Back",
        content: (
          <div
            style={{
              fontSize: "18px",
              fontWeight: "500",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: 0,
              fontSize: "1vw",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "58px",
                height: "58px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 165, 0, 0.2)",
                marginTop: "15px",
              }}
            >
              <ExclamationCircleOutlined
                style={{
                  fontSize: "35px",
                  color: "orange",
                }}
              />
            </div>
            <p style={{ color: "#0F0718", fontWeight: 550, fontSize: "1.8em", padding: "15px 15px 0 15px", marginBottom: 0 }}>Payment Timed Out</p>
            <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "5px 20px 0 20px" }}>
              Your payment request couldn't be processed in time. Please try again
            </p>

            <button
              style={{
                backgroundColor: "#2F3856",
                color: "#fff",
                // padding: "10px",
                padding: "10px 50px 10px 50px",
                borderRadius: "10px",
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => {
                setCardPaymnetStatusPLB(false);
                Modal.destroyAll();
              }}
            >
              Try Again
            </button>
          </div>
        ),
        style: {
          textAlign: "center",
          height: "50vh",
          width: "50%",
        },
        modalRender: (modal) => <div style={{ borderRadius: "12px", overflow: "hidden" }}>{modal}</div>,
        bodyStyle: {
          padding: "0",
        },
        closable: false,
        onOk: null,
      });
    }
  }, [cardPaymnetStatusPLB]);

  useEffect(() => {
    if (isPurchaseReturn) {
      setTimeout(() => {
        searchCustomersRef?.current?.focus();
      }, 10);
    }
  }, [isPurchaseReturn]);

  useEffect(() => {
    if (isParkedBill) {
      setTimeout(() => {
        parkedBillRef?.current?.focus();
      }, 10);
    }
  }, [isParkedBill]);

  useEffect(() => {
    document.documentElement.style.setProperty("--table-bg-color", themeJSON.productTableBGColor || "#fff");
  }, [themeJSON]);

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, [isLocked]);

  // const productSearchInputRef = useRef(null);
  useEffect(() => {
    getCategoryProducts();
    // Focus the input element when the component mounts
    setTimeout(() => {
      try {
        const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
        if (cartDetails !== null) {
          setCart(cartDetails);
        }
      } catch (error) {
        console.error("Error parsing cart details:", error);
      }
    }, 200);

    setTimeout(() => {
      setProductSearchInput("");
      const productSearchInput = document.getElementById("sm-product-search");
      if (productSearchInput) {
        productSearchInput.blur();
      }
      keyboard?.current?.setInput("");
    }, 200);
  }, []);

  useEffect(() => {
    const orderDetails = JSON.parse(localStorage.getItem("cartObj"));
    // setSelectedDocumentType(orderDetails?.layAway === "Y" ? "Advance" : "Invoice");
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const getSaleTypeData = async () => {
      const saleData = await db.posSaletypes.toArray();
      // setSaleTypeData(saleData);
      const filteredSaleData = saleData?.filter(
        (sale) => sale?.cwrSaletype?.fulfilmentType !== "TA" && sale?.cwrSaletype?.fulfilmentType !== "DI" && sale?.cwrSaletype?.fulfilmentType !== "DE"
      );

      setSaleTypeData(filteredSaleData);
    };

    getSaleTypeData();
  }, []);

  useEffect(() => {
    // Update the current date and time every second
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let syncOrdersInterval;

    const startSyncInterval = () => {
      syncOrdersInterval = setInterval(async () => {
        // Check if cartObj exists in localStorage
        if (!localStorage.getItem("cartObj")) {
          return;
        }
        const activeElement = document.activeElement;
        const isDrawerOrModalOpen =
          !!document.querySelector(".ant-drawer-open") || !!document.querySelector(".ant-modal-mask") || document.body.classList.contains("ant-modal-open");
        if (isDrawerOrModalOpen) return;

        const lastUpdatedTimeString = moment(localStorage.getItem("lastUpdatedTime")).format("HH:mm:ss");
        const lastUpdatedTime = moment(lastUpdatedTimeString, "HH:mm:ss");
        const lastUpdatedOrder = moment(orderDelay).format("HH:mm:ss");
        const lastOrderTime = moment(lastUpdatedOrder, "HH:mm:ss");

        // Create a moment object for the current time
        let cartObj = JSON.parse(localStorage.getItem("cartObj"));
        const currentTime = moment();
        const syncTime = posConfig["Incremental Data Sync Frequency (In Minutes)"] ? posConfig["Incremental Data Sync Frequency (In Minutes)"] : 15;
        const lastFullSyncTime = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");

        const fullSync = posConfig["fullDataSyncFrequency"] ? posConfig["fullDataSyncFrequency"] : 360;
        // Calculate the difference in minutes and seconds
        const diffMinutes = currentTime.diff(lastUpdatedTime, "minutes");
        let lastUpdatedFullTimeString = moment(new Date()).format("HH:mm:ss");
        if (lastFullSyncTime?.length > 0) {
          lastUpdatedFullTimeString = moment(lastFullSyncTime[0]?.syncEndTime).format("HH:mm:ss");
        }
        const lastUpdatedFullTime = moment(lastUpdatedFullTimeString, "HH:mm:ss");
        const diffMinutesFullSync = currentTime.diff(lastUpdatedFullTime, "minutes");
        const diffSeconds = currentTime.diff(lastOrderTime, "seconds");
        if (cartObj.items?.length === 0 && diffMinutesFullSync >= fullSync) {
          localStorage.removeItem("lastUpdatedTime");
          setTillLink(false);
          setSyncLoad(true);
          let tillData = JSON.parse(localStorage.getItem("tillData"));
          const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : "";
          setCart({ ...cart, customer: defaultCustomer });
          await processSync(tillData, setGlobalStore, "Full Sync");
          setSyncLoad(false);
          setGlobalStore({ percent: "0%" });
          setGlobalStore({ productCategoryPercentage: "0" });
          setGlobalStore({ productPercentage: "0" });
          setGlobalStore({ promotionPercentage: "0" });
          // window.location.reload();
        } else if (cartObj.items?.length === 0 && diffMinutes >= syncTime && diffSeconds >= 15) {
          clearInterval(syncOrdersInterval); // Clear the interval while syncing
          setSyncLoad(true);
          let tillData = JSON.parse(localStorage.getItem("tillData"));
          const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : tillData.tillAccess.csBunit.b2cCustomer;
          setCart({ ...cartObj, customer: defaultCustomer });
          await processSync(tillData, setGlobalStore, "Incremental Sync");
          setSyncLoad(false);
          setGlobalStore({ percent: "0%" });
          setGlobalStore({ productCategoryPercentage: "0" });
          setGlobalStore({ productPercentage: "0" });
          setGlobalStore({ promotionPercentage: "0" });
          // window.location.reload();
          // startSyncInterval(); // Restart the interval after sync is complete
        }
      }, 1000); // 30000 milliseconds = 30 seconds
    };

    startSyncInterval();

    return () => {
      clearInterval(syncOrdersInterval);
    };
  }, []);

  useEffect(() => {
    let methods = [];
    tillDataPaymentMethods.map((item) => {
      if (item.name === "Cash" && posConfig?.enableCash === "Y") {
        methods.push(item);
      } else if (item.name === "Card" && posConfig?.enableCard === "Y") {
        methods.push(item);
      } else if (item.name !== "Cash" && item.name !== "Card") {
        methods.push(item);
      }
    });
    setPaymentType(methods);
    if (!localStorage.getItem("salesReturn")) {
      localStorage.setItem("salesReturn", "N");
    }

    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, []);

  const tableBodyRef = useRef(null);
  const debounceTimeoutRef = useRef(null);
  const isPendingFetchRef = useRef(false);

  useEffect(() => {
    const antTableBody = tableBodyRef.current;
    if (antTableBody) {
      antTableBody.addEventListener("scroll", fetchMoreData);
      return () => {
        antTableBody.removeEventListener("scroll", fetchMoreData);
      };
    }
  }, [isPurchaseReturn]);

  const returnBillSearchInputRef = useRef();
  const parkedBillsRef = useRef();
  useEffect(() => {
    if (displayReturnOrderSearch) {
      setTimeout(() => {
        returnBillSearchInputRef.current.focus();
      }, 100);
    }
  }, [retrunSearchType, displayReturnOrderSearch]);

  useEffect(async () => {
    filterdParkedList?.map((item, index) => {
      item.key = uuidv4().replace(/-/g, "").toUpperCase();
    });
    let data = await db.cashInCashOut.toArray();
    setCashManagementData(data);
    if (paymentModal === false) {
      setTimeout(() => {
        setKeyValue("0");
      }, 1000);
    }
  }, [addCashFlag, paymentModal]);

  useEffect(async () => {
    if (cart.items.length === 0 && cart.payments.length > 0) {
      await cart.payments.map(async (payment) => {
        handleDeletePayment(payment);
      });
    }
  }, [cart]);

  const [selectedRecords, setSelectedRecords] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  // const [notesPopup, setNotesPopup] = useState(false);

  useEffect(() => {
    if (orderHistoryDetails.length > 0) {
      const newArray = orderHistoryDetails.map((item) => {
        const isReturn = item.items.some((product) => product.isReturn);
        const isLayaway = posConfig?.advanceLayaway === "Y" ? item.layAway === "Y" : item.layAway === "Y" && item.paid === 0;
        const isCancel = (item.total === 0 || item.total === "0.00") && item.totalQty === 0;
        const isCreditSaleRecord = item.creditSale === "Y";
        const type = item.isReturn === "Y" ? "Return" : isLayaway ? "Layaway" : isCancel ? "Cancelled" : isCreditSaleRecord ? "Credit Sale" : "Receipt";
        const newItem = { ...item, type };
        return newItem;
      });
      if (!arraysAreEqual(newArray, orderHistoryDetails)) {
        setOrderHistoryDetails(newArray);
      }
    }
  }, [orderHistoryDetails]);

  useEffect(async () => {
    if (cart?.manualDiscountData) {
      if (cart?.manualDiscountData?.totalLevelDiscount?.length > 0) {
        const pr = await db.pricingRules.toArray();
        const index = pr.findIndex((md) => md.mPricingrulesId === cart?.items[0]?.mPricingruleId && md.manualDiscount === "Y");
        if (index !== -1) {
          const pricingRule = pr[index];
          const matchedPricingRule = cart?.manualDiscountData?.totalLevelDiscount?.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
          manualDiscountForm.setFieldsValue({
            discountName: pricingRule.mPricingrulesId,
            discountValue: cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
          });
          setManualDiscountInput(cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        } else {
          manualDiscountForm.resetFields();
          setManualDiscountInput("");
          setSelectedManualDiscountTypeValue("");
        }
      }
    }
  }, [cart, manualDiscountModalVisible]);

  const handleWebSocketMessage = useCallback(async (message) => {
    try {
      switch (message.type) {
        case "SUBSCRIBED":
          console.log("[v0] [HandleMessage] SUBSCRIBED to bunit:", message.bunitId);
          break;

        case "MISSED_EVENTS_COMPLETE":
          console.log(`[v0] [HandleMessage] Missed table status events sync complete. Total: ${message.count}`);
          break;

        case "REDIS_RECONNECTED":
          console.log("[v0] [HandleMessage] Redis reconnected - table status will sync automatically");
          break;

        case "ERROR":
          console.error("[v0] [HandleMessage] WebSocket error message:", message.error || message.message);
          break;

        default:
          console.log("[v0] [HandleMessage] Unknown message type:", message.type);
      }
    } catch (error) {
      console.error("[v0] [HandleMessage] Error handling WebSocket message:", error);
      console.error("[v0] [HandleMessage] Stack trace:", error.stack);
    }

    console.log("[v0] [HandleMessage] ========== MESSAGE PROCESSING DONE ==========");
  }, []);

  const {} = useRestaurantWebSocket({
    url: wsUrl,
    bunitId: tillData?.tillAccess?.csBunit?.csBunitId,
    enabled: wsUrl ? true : false,
    onMessage: handleWebSocketMessage,
    onConnect: () => {
      console.log("[v0] WebSocket connected successfully");
      console.log("[v0] - URL:", wsUrl);
    },
    onDisconnect: () => {
      console.log("[v0] WebSocket disconnected");
    },
    onError: (error) => {
      console.error("[v0] WebSocket error:", error);
    },
  });

  const showProductInfo = posConfig?.showProductInfoPanel === "Y" ? true : false;
  const shouldShowPanel = Object.keys(selectedProductInCart)?.length > 0 && showProductInfo;
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [offersDrawerOpen, setOffersDrawerOpen] = useState(false);

  // useEffect(() => {
  //   qtyInputRef.current?.focus();
  // }, [selectedProductInCart]);

  const cartItems = (parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
    (item) => item.weight !== 0
  );
  const hasExpandableRows = cartItems.some((item) => item.children && item.children.length > 0);

  const handleProductionClick = () => {
    // setEnableProduction(true);
    // setTillLink(false);
    history.push("/production");
  };

  // const handleSearch = async (data) => {
  //   const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  //   const search = data.toLowerCase();
  //   if (!data) {
  //     setOptions([]);
  //     return;
  //   }

  //   let products;

  //   if (posConfig?.is_smart_product_search === "Y") {
  //     products = await db.products
  //       .filter((product) => product.isactive === true)
  //       .filter((product) => product.productSegment !== "BG")
  //       .filter((product) => product.value?.toLowerCase() === data)
  //       .limit(20)
  //       .toArray();

  //     if (products.length === 0) {
  //       products = await db.products
  //         .filter((product) => product.isactive === true)
  //         .filter((product) => product.productSegment !== "BG")
  //         .filter((product) => {
  //           return product.upcIndex === data || product.upc === data || product.name?.toLowerCase().includes(search);
  //         })
  //         .limit(20)
  //         .toArray();
  //     }
  //   } else {
  //     products = await db.products
  //       .filter((product) => product.isactive === true)
  //       .filter((product) => product.productSegment !== "BG")
  //       .filter((product) => {
  //         return product.name?.toLowerCase().includes(search) || product.upcIndex === data || product.upc === data || product.value === data;
  //       })
  //       .limit(20)
  //       .toArray();
  //   }
  //   if (products.length > 0) {
  //     const filteredOptions = products.map((item) => ({
  //       label: `${item.value} - ${item.name}`,
  //       value: item.value,
  //     }));
  //     const map = {};
  //     products.forEach((item) => {
  //       map[item.value] = item;
  //     });
  //     setOptions(filteredOptions);
  //     setProductMap(map);
  //   } else {
  //     setOptions([]);
  //     setProductMap({});
  //   }
  // };
  const handleSearch = async (data) => {
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));
    const normalizedData = data?.toString().trim();
    const search = normalizedData.toLowerCase();

    if (!normalizedData) {
      setOptions([]);
      return;
    }

    let products;

    if (posConfig?.is_smart_product_search === "Y") {
      products = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.productSegment !== "BG")
        .filter((product) => product.value?.toLowerCase() === search)
        .limit(20)
        .toArray();

      if (products.length === 0) {
        products = await db.products
          .filter((product) => product.isactive === true)
          .filter((product) => product.productSegment !== "BG")
          .filter((product) => {
            return product.upcIndex === normalizedData || product.upc === normalizedData || product.name?.toLowerCase().includes(search);
          })
          .limit(20)
          .toArray();
      }
    } else {
      products = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.productSegment !== "BG")
        .filter((product) => {
          return product.name?.toLowerCase().includes(search) || product.upcIndex === normalizedData || product.upc === normalizedData || product.value === normalizedData;
        })
        .limit(20)
        .toArray();
    }

    // 🔥 CONTROLLED SYNC (ONLY WHEN NEEDED)
    if ((!products || products.length === 0) && normalizedData.length >= 3) {
      try {
        console.log("Autocomplete sync:", normalizedData);

        const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

        await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, normalizedData);

        // 🔁 Re-fetch after sync
        products = await db.products
          .filter((product) => product.isactive === true)
          .filter((product) => product.productSegment !== "BG")
          .filter((product) => {
            return product.name?.toLowerCase().includes(search) || product.upcIndex === normalizedData || product.upc === normalizedData || product.value === normalizedData;
          })
          .limit(20)
          .toArray();
      } catch (err) {
        console.error("Autocomplete sync failed:", err);
      }
    }

    // ✅ FINAL RESULT
    if (products.length > 0) {
      const filteredOptions = products.map((item) => ({
        label: `${item.value} - ${item.name}`,
        value: item.value,
      }));

      const map = {};
      products.forEach((item) => {
        map[item.value] = item;
      });

      setOptions(filteredOptions);
      setProductMap(map);
    } else {
      setOptions([]);
      setProductMap({});
    }
  };

  const handleQuotationClick = () => {
    cart.isQuotation = true;
    setCart(cart);
    localStorage.setItem("cartObj", JSON.stringify(cart));
    setIsQuotation(true);
    setTillLink(false);
  };

  const handleViewStockClick = () => {
    getProductNearByStock();
    setViewStock(true);
  };

  const handleOutsideClick = (event) => {
    const excludedIds = ["sm-parked-bill-customer", "sm-salesHistory-customer", "sm-product-search", "sm-salesHistory-document"];
    if (!excludedIds.includes(event.target?.id) && event.target.offsetParent?.className !== "ant-drawer-content" && event.target.id !== "") {
      setOpen(false);
    }
  };

  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long", // Full day name (e.g., Wednesday)
    day: "numeric", // Day of the month (e.g., 28)
    month: "long", // Full month name (e.g., June)
    year: "numeric", // Full year (e.g., 2023)
  })}`;

  const handleSave = (row) => {
    setIsInputFocused(true);
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];

    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
    handleSaveReturnCartRecord(newData);
  };

  const handleKey = (e) => {
    const { altKey, keyCode } = e;
    if (altKey && keyCode === 82) {
      if (posConfig?.showSalesReturn === "Y") {
        setDisplayReturnOrderSearch(true);
      }
    }
  };

  const getProductNearByStock = async () => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    try {
      const stockInputValues = {
        query: `
        query {
          getProductsNearbyStock(
            bUnitId: "${tillData.tillAccess.csBunit.csBunitId}",
            code: "${selectedProductInCart.value}"
          ) {
            csBunitId
            value
            name
            totalQty
            stores {
              csNearbyStoreId
              name
              nearbybUnitId
              viewStock
              isIssue
              warehouse {
                mWarehouseID
                name
                value
                storageBin {
                  mStoragebinID
                  name
                  stocks {
                    mStockID
                    qtyonhand
                    product {
                      mProductId
                      value
                      name
                      upc
                      uom {
                        csUomId
                        name
                      }
                      productCategory {
                        mProductCategoryId
                        value
                        name
                      }
                    }
                    batch {
                      mBatchId
                      batchno
                      upc
                      price
                      startdate
                      enddate
                      life
                      purchasePrice
                      listPrice
                      purchaseDate
                    }
                  }
                  totalQty
                }
              }
            }
          }
        }
      `,
      };

      const response = await getProductsNearbyStockService(stockInputValues);

      const { stores, totalQty, csBunitId } = response.data.data.getProductsNearbyStock;

      const currentStock = {
        csNearbyStoreId: "53F4FBEBDAB94C4AB205B7415EBD739E",
        name: tillData.tillAccess.csBunit.mWarehouse.name,
        nearbybUnitId: "EEF9FADCE0D74AE3B8B6096E6C35B6AA",
        viewStock: "Y",
        isIssue: "Y",
        warehouse: {
          mWarehouseID: "79FD0E516E4F4C5F9A7932F0C5C82C92",
          name: tillData.tillAccess.csBunit.mWarehouse.name,
          value: "Central WH TTLLC",
          storageBin: {
            mStoragebinID: "09581CA09C154830A20B88370C501FD6",
            name: "Central Warehouse",
            stocks: [],
            totalQty: totalQty || 0,
          },
        },
      };

      const isStorePresent = stores?.some((store) => store?.nearbybUnitId === csBunitId);
      setStockList(isStorePresent ? stores : [currentStock, ...stores]);
    } catch (error) {
      console.error("Error fetching nearby stock:", error);
    }
  };

  // handle scroll start

  let scrollLeft;
  let maxScroll;
  let currentScroll;

  // let debounceTimeout;

  // const fetchMoreData = (event) => {
  //   const lengthOff = localStorage.getItem("dataLength");
  //   let previousMaxScroll = maxScroll;
  //   let previousScroll = currentScroll;
  //   maxScroll = event.target.scrollHeight - event.target.clientHeight;
  //   currentScroll = event.target.scrollTop;
  //   if (scrollLeft !== event.target.scrollLeft) {
  //     scrollLeft = event.target.scrollLeft;
  //     return null;
  //   }

  //   if (Math.round(currentScroll) >= Math.round(maxScroll) - 1) {
  //     let orderD = JSON.parse(localStorage.getItem("orderType"));

  //     setStartRowData((prevData) => {
  //       const newStartRow = lengthOff;
  //       const newEndRow = lengthOff + 20;

  //       // Validate using previous data
  //       // if (orderD.length > 0 && (prevData.startRow !== newStartRow || prevData.endRow !== newEndRow) && (previousMaxScroll !== maxScroll || previousScroll !== currentScroll)) {
  //       if (
  //         orderD.length > 0 &&
  //         (prevData.startRow !== newStartRow || prevData.endRow !== newEndRow) &&
  //         (previousMaxScroll !== maxScroll || previousScroll !== currentScroll) &&
  //         ordersCopy.length > 0
  //       ) {
  //         if (tableBodyRef.current) {
  //           tableBodyRef.current.scrollTop = Math.round(currentScroll) - 5;
  //         }
  //         let dateFlag = true;
  //         if (dateRef.current.textContent !== "Choose date range") {
  //           dateFlag = false;
  //         }

  //         clearTimeout(debounceTimeout);

  //         debounceTimeout = setTimeout(() => {
  //           searchOrderHistory(orderD[0], orderD[1], lengthOff, true, dateFlag);
  //         }, 300);
  //       }

  //       // Return the new state
  //       return {
  //         startRow: newStartRow,
  //         endRow: newEndRow,
  //       };
  //     });
  //   }
  // };

  // let antTableBody = document.querySelector(".sm-cart-table");

  const fetchMoreData = (event) => {
    const lengthOff = Number.parseInt(localStorage.getItem("dataLength") || "0", 10);
    let previousMaxScroll = maxScroll;
    let previousScroll = currentScroll;
    maxScroll = event.target.scrollHeight - event.target.clientHeight;
    currentScroll = event.target.scrollTop;
    if (scrollLeft !== event.target.scrollLeft) {
      scrollLeft = event.target.scrollLeft;
      return null;
    }

    if (Math.round(currentScroll) >= Math.round(maxScroll) - 1) {
      let orderD = JSON.parse(localStorage.getItem("orderType"));

      // <CHANGE> Check if fetch is already pending
      if (isPendingFetchRef.current) {
        return null;
      }

      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }

      setLoading((prevLoading) => {
        if (orderD?.length > 0 && !prevLoading) {
          // <CHANGE> Set pending flag
          isPendingFetchRef.current = true;

          if (tableBodyRef.current) {
            tableBodyRef.current.scrollTop = Math.round(currentScroll) - 5;
          }
          let dateFlag = true;
          if (dateRef.current.textContent !== "Choose date range") {
            dateFlag = false;
          }

          debounceTimeoutRef.current = setTimeout(() => {
            searchOrderHistory(orderD[0], orderD[1], lengthOff, true, dateFlag);
            // <CHANGE> Reset pending flag after call
            isPendingFetchRef.current = false;
          }, 100); // <CHANGE> Reduced from 300ms to 100ms
        } else {
          console.log("[v0] Conditions NOT met - orderD length:", orderD?.length, "prevLoading:", prevLoading);
        }

        return prevLoading;
      });
    }
  };

  // let antTableBody = document.querySelector(".sm-cart-table");

  orderHistoryDetails.map((item) => {
    item.name = item.customer.name;
    item.status = item.isSynced === 1 || item.status === "Success" ? "Success" : "Pending";
  });

  const removeProductModal = (record) => {
    setShowCustomMix(false);
    deleteProduct(record);
    // if (productSearchInputRef.current) {
    //   productSearchInputRef.current.focus();
    //   const productSearchInput = document.getElementById("sm-product-search");
    //   if (productSearchInput) {
    //     productSearchInput.focus();
    //     productSearchInput.select();
    //   }
    // }
  };

  const cancelOrder = async () => {
    if (posConfig?.saveParkedBills === "Y" && cart?.isRetrived === "Y") {
      const csBunitId = tillData?.tillAccess?.csBunit?.csBunitId;
      const cwrPosCartId = JSON.parse(localStorage.getItem("cartObj"))?.cwr_pos_cart_id || null;
      const cwrTillId = tillData?.tillAccess?.cwrTill?.cwrTillID;
      const status = "CL";

      // cartItems is stored as string → parse it
      const cartItems = JSON.parse(localStorage.getItem("cartObj"));

      const cartPayload = {
        csBunitId,
        cwrPosCartId,
        cwrTillId,
        status,
        cartItems,
      };

      const response = await upsertCart(cartPayload);
      if (response?.status === 200) {
        if (response?.data?.data?.upsertCart?.status === "200") {
          // clearCart(cart.type);
          deleteCart();
          setIsNriBilling(false);
          setIsPanCustomer(false);
          localStorage.removeItem("selectedReturnType");
          localStorage.removeItem("exchangeCartObj");
          localStorage.removeItem("isPanCustomer");
          localStorage.removeItem("isNriBilling");
          setExchangeCartTcs(false);
          setSupplyRegionProceed(false);
          hasShownCustomerModalRef.current = false;
          if (searchInputRef?.current) {
            searchInputRef.current.focus();
          }
        }
      } else {
        message.warning("Something is wrong in upsertCart service");
      }
    } else if (posConfig?.saveCancelledOrders !== "Y") {
      deleteCart();
      setIsNriBilling(false);
      setIsPanCustomer(false);
      localStorage.removeItem("selectedReturnType");
      localStorage.removeItem("exchangeCartObj");
      localStorage.removeItem("isPanCustomer");
      localStorage.removeItem("isNriBilling");
      setExchangeCartTcs(false);
      setSupplyRegionProceed(false);
      hasShownCustomerModalRef.current = false;
      if (searchInputRef?.current) {
        searchInputRef.current.focus();
      }
    } else {
      let setAuthTokens;
      setSelectedDocumentType("Invoice");
      let PaymentMethods = getFilteredPaymentMethods() || [];
      let payments =
        PaymentMethods.length > 5
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
            )
          : PaymentMethods;

      setShowPayments(payments);
      if (authHeaders && authHeaders.access_token) {
        setAuthTokens = authHeaders.access_token;
      }
      if (cart?.couponInput?.length > 0) {
        const serverUrl = process.env.REACT_APP_serverUrl;

        const couponsData = [...cart.couponInput];
        // Function to discard a coupon
        const discardCoupon = async (coupon) => {
          const discardCouponQuery = {
            query: `query {
                  discardCoupon(couponcode: "${coupon.couponCode}", referenceId: "${coupon.referenceId}") {
                    status
                    message
                  }
                }`,
          };
          try {
            const response = await discardCouponService(coupon.couponCode, coupon.referenceId);

            console.log(`Coupon ${coupon.couponCode} discarded:`, response.data);
          } catch (error) {
            console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
          }
        };
        couponsData.forEach((coupon) => {
          discardCoupon(coupon);
        });
      }

      discardGiftCards(cart);
      let index = cart.payments.findIndex((payment) => payment.name.toLowerCase() === "loyalty" && !cart.isReturn);
      if (index >= 0) {
        handleLoyaltyPayment(cart.payments[index], cart);
      }
      clearCart(cart.type);
      setIsNriBilling(false);
      setIsPanCustomer(false);
      hasShownCustomerModalRef.current = false;
      // const productSearchInput = document.getElementById("sm-product-search");
      // if (productSearchInput) {
      //   setTimeout(() => {
      //     productSearchInput.focus();
      //   }, 300);
      // }
      localStorage.removeItem("couponAdditionalInfo");
      localStorage.removeItem("exchangeCartObj");
      localStorage.removeItem("isCreditSale");
      localStorage.removeItem("returnThisReceipt");
      localStorage.removeItem("isPanCustomer");
      localStorage.removeItem("isNriBilling");
      setExchangeCartTcs(false);
      setShowInputFields(false);
      setCustomMixItems([]);
      setGroupQty(1);
      setActiveInput("search");
      setProductSearchInput("");
      setSupplyRegionProceed(false);
      if (searchInputRef?.current) {
        searchInputRef.current.focus();
      }
    }
  };

  const deleteProductModal = () => {
    if (cart.payments.length > 0) {
      message.warning(`${messages.errors.cart.delete_payment_first}`);
      return;
    }
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "This action will remove all products from the cart, including the selected customer.Do you wish to proceed?",
        icon: null,
        cancelText: "No",
        okText: "Yes",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        async onOk() {
          const { workflowRules, approvers } = await getWorkflowData();
          const cancelParkedBillRule = workflowRules.find((res) => res.eventName === "Cancel Parked Bill");
          if (cancelParkedBillRule && cart.parked === "Y" && cart.isRetrived === "Y") {
            dispatchEvent(cancelParkedBillRule.eventName, cancelParkedBillRule.ruleName, cancelParkedBillRule.ruleCondition, approvers, null, async (eventData) => {
              if (eventData?.approvalGranted) {
                await cancelOrder();
              } else {
                Modal.error({
                  title: "Approval Required",
                  content: "The cancellation request was not approved.",
                });
              }
            });
          } else {
            await cancelOrder();
          }
        },
      });
    }
  };

  const showMoreItems = () => {
    const PaymentMethods = tillData.tillAccess.csBunit.paymentMethodList;
    let paymentDetails = getFilteredPaymentMethods();
    if (
      cart?.docType === "Advance" &&
      posConfig?.allowLayawaywithoutPayment !== "Y" &&
      !cart.items.some((item) => item.type === "S" && item?.productSegment === "AD" && item.weight > 0)
    ) {
      paymentDetails = [
        ...paymentDetails,
        ...(posConfig?.enablePreOrder !== "Y"
          ? [
              {
                cWRPaymentMethodID: "",
                sequenceNo: 9999,
                finPaymentmethodId: "",
                finFinancialAccountId: "",
                finDayCloseAccountId: null,
                name: "Complete Order",
                integratedPayment: false,
                isloyalty: false,
                paymentProvider: null,
                iscredit: false,
                isGiftCard: false,
                isDefault: "N",
                csCurrencyId: "",
                isoCode: "AED",
                isactive: true,
                salesType: [],
              },
            ]
          : []),
      ];
    }
    let itemsPerPage =
      tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5;
    if (startIndex + itemsPerPage >= paymentDetails.length) {
      if (startIndex < paymentDetails.length) {
        setShowPayments(paymentDetails.slice(startIndex, paymentDetails.length));
        setStartIndex(paymentDetails.length);
      } else {
        setShowPayments(paymentDetails.slice(0, itemsPerPage));
        // setStartIndex(4);
        setStartIndex(itemsPerPage);
      }
    } else {
      setShowPayments(paymentDetails.slice(startIndex, itemsPerPage + startIndex));
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const showPreviousItems = () => {};

  const handleDeletePayment = (payment) => {
    let activeCart = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj")) : JSON.parse(localStorage.getItem("cartObj")) || cart;
    let paid = 0;
    Promise.all(
      activeCart.payments.map(async (pay) => {
        if (payment.name.toLowerCase() === "gift card" && payment?.finPaymentmethodId === pay?.finPaymentmethodId) {
          let setAuthTokens;
          if (authHeaders && authHeaders.access_token) {
            setAuthTokens = authHeaders.access_token;
          }
          const upsertDetails = giftCardData.map((ele) => ({
            cardNo: ele.number ? ele.number : null,
            type: "RD",
            referenceNo: activeCart.referenceId,
            amount: ele.amount * -1,
            cardPin: ele.pin ? ele.pin : null,
          }));

          const upsertDetailsStrings = upsertDetails.map(
            (detail) => `{
          cardNo: ${detail.cardNo ? `"${detail.cardNo}"` : null},
          type: "${detail.type}",
          referenceNo: "${detail.referenceNo}",
          amount: ${detail.amount},
          cardPin: ${detail.cardPin ? `"${detail.cardPin}"` : null}
          tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
          b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
        }`
          );

          const data = {
            query: `
              mutation {
                upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) {
                  status
                  message
                }
              }`,
          };

          const response = await upsertGiftCardTransaction(data);
          let cardDetails = [...giftCardData];
          let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
          if (response.data.data.upsertGiftCardTransaction.status == 200) {
            upsertDetails.forEach((detail) => {
              cardDetails.push({
                number: detail.cardNo,
                amount: detail.amount,
                redemptionId: uniqId,
                pin: detail.cardPin ? detail.cardPin : null,
              });
            });
          }
          setGiftCardData(cardDetails);
        } else if (payment.name.toLowerCase() === "credit" && payment?.finPaymentmethodId === pay?.finPaymentmethodId) {
          const trxData = [
            {
              b2cCustomerId: activeCart?.customer?.cwrCustomerId,
              trxDate: moment(new Date()).format("YYYY-MM-DD"),
              trxAmt: Number(payment.amount),
              openingAmt: activeCart?.customer?.creditBalance - Number(payment.amount),
              closingAmt: activeCart?.customer?.creditBalance,
              type: "CR",
              cwrTillId: null,
              sOrderId: null,
              referenceNo: activeCart?.referenceId,
            },
          ];
          const creditUpsertResponse = await upsertCreditTransaction(trxData);
        } else if (payment.name.toLowerCase() === "loyalty" && payment?.finPaymentmethodId === pay?.finPaymentmethodId) {
          await handleLoyaltyPayment(payment, activeCart);
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.isWallet === "Y" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          try {
            const tillData = JSON.parse(localStorage.getItem("tillData")) || {};
            const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;

            const refundAmount = Number(payment.amount);

            const payload = {
              bunitId,
              customerId: activeCart.customer.cwrCustomerId,
              trxType: "DP", // Deposit back
              trxValue: refundAmount,
              tillId: tillData?.tillAccess.cwrTill.cwrTillID,
              payments: [],
              transactionDetails: "{}",
            };

            const response = await upsertWalletTransactionService(payload);

            if (response?.status === "200") {
              // 🟢 Update frontend balance
              const updatedCustomer = {
                ...selectedCustomer[0],
                currentBalance: (selectedCustomer[0]?.currentBalance || 0) + refundAmount,
              };

              setSelectedCustomer([updatedCustomer]);
              message.success("Wallet amount refunded");
            } else {
              message.error("Wallet refund failed");
            }
          } catch (err) {
            console.error("Wallet refund error", err);
          }
        }
      })
    )
      .then((results) => {
        activeCart.payments = results.filter((result) => result !== undefined);
        activeCart.paid = paid + (activeCart?.advancePayment || 0);
        setAmount(parseFloat((activeCart.total - activeCart.paid).toFixed(pricePrecision)));
        if (payment?.name?.toLowerCase() === "cash") {
          activeCart.tenderedAmount = activeCart.tenderedAmount - payment.amount;
        } else if (payment?.name?.toLowerCase() === "gift card") {
          activeCart.giftCardNumbers = [];
        }
        if (isExchange) {
          localStorage.setItem("exchangeCartObj", JSON.stringify(activeCart));
        } else {
          localStorage.setItem("cartObj", JSON.stringify(activeCart));
          setCart(activeCart);
        }
      })
      .catch((error) => {
        // Handle errors
        console.error(error);
      });
  };

  // const clearCart = async (type) => {
  //   const tillSession = JSON.parse(localStorage.getItem("tillSession"));
  //   const tillSessionId = tillSession.tillSessionId;
  //   const newDocumentSequence = cart.parked === "Y" ? documentSequence : documentSequence + 1;
  //   let cartToDb = cart;
  //   cartToDb.orderTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
  //   cartToDb.createdBy = tillData.tillAccess.csUserId;
  //   cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId;
  //   cartToDb.orderDate = moment(new Date()).format("DD-MM-YYYY");
  //   cartToDb.tillSessionId = tillSessionId;
  //   cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
  //   cartToDb.isSynced = 0;
  //   cartToDb.syncAttempts = 0;
  //   cartToDb.customerSearchKey = cart.customer.code;
  //   cartToDb.tax = 0;
  //   cartToDb.total = 0;
  //   cartToDb.docType = "Invoice";
  //   cartToDb.totalQty = 0;
  //   cartToDb.couponInput = [];
  //   cartToDb.discount = 0;
  //   cartToDb.isReturn = false;
  //   const resetItemValues = (item) => {
  //     item.realWeight = item.weight;
  //     item.salePrice = 0;
  //     item.sunitprice = 0;
  //     item.netStd = 0;
  //     item.nettotal = 0;
  //     item.unitTax = 0;
  //     item.taxAmount = 0;
  //     item.weight = 0;
  //     item.unitPrice = 0;
  //     item.isReturn = false;
  //     item.netList = 0;
  //     item.discount = 0;
  //     item.linetax = 0;
  //     item.linenet = 0;
  //     item.linegross = 0;
  //     item.linestd = 0;
  //     item.netunit = 0;
  //     item.listPrice = 0;
  //     item.grossunit = 0;
  //     item.grossstd = 0;
  //     item.grosslist = 0;

  //     if (Array.isArray(item.children) && item.children.length > 0) {
  //       item.children.forEach((child) => resetItemValues(child));
  //     }
  //   };
  //   cartToDb.items.forEach((item) => resetItemValues(item));
  //   deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
  //   setGiftCardData([]);
  //   if (type === "Layaway") {
  //     setDocumnetSequence(documentSequence);
  //   } else {
  //     localStorage.setItem("documentSequence", newDocumentSequence);
  //     setDocumnetSequence(newDocumentSequence);
  //     await db.orders.add(cartToDb);
  //   }
  // };

  const clearCart = async (type) => {
    const tillSession = JSON.parse(localStorage.getItem("tillSession"));
    const tillSessionId = tillSession.tillSessionId;
    const newDocumentSequence = cart.parked === "Y" ? documentSequence : documentSequence + 1;
    let cartToDb = JSON.parse(JSON.stringify(cart)); // DEEP copy to avoid any reference issues
    cartToDb.orderTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    cartToDb.createdBy = tillData.tillAccess.csUserId;
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId;
    cartToDb.orderDate = moment(new Date()).format("DD-MM-YYYY");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart.customer.code;
    cartToDb.tax = 0;
    cartToDb.total = 0;
    cartToDb.docType = "Invoice";
    cartToDb.totalQty = 0;
    cartToDb.couponInput = [];
    cartToDb.discount = 0;
    cartToDb.isReturn = false;
    cartToDb.paid = 0; // <-- FIX: ensure paid is 0 for cancelled order
    cartToDb.payments = []; // <-- FIX: ensure payments is empty for cancelled order
    cartToDb.change = 0; // <-- FIX: ensure change is 0
    const resetItemValues = (item) => {
      item.realWeight = item.weight;
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.isReturn = false;
      item.netList = 0;
      item.discount = 0;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
      if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((child) => resetItemValues(child));
      }
    };
    cartToDb.items.forEach((item) => resetItemValues(item));
    // Save to DB BEFORE resetting the cart state
    if (type === "Layaway") {
      setDocumnetSequence(documentSequence);
    } else {
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
      await db.orders.add(cartToDb);
    }

    deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
    localStorage.removeItem("selectedReturnType");
    setGiftCardData([]);
  };
  const columns = [
    {
      title: "Parked Sale",
      dataIndex: "parkedTime",
      key: "parkedTime",
      width: "20%",
    },
    {
      title: "Document No",
      dataIndex: "parkedDocNo",
      key: "parkedDocNo",
      width: "25%",
    },
    {
      title: "Customer",
      dataIndex: "customer",
      key: "customer",
      width: "20%",
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      width: "20%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "15%",
    },
  ];

  const onSelectAllChange = (e) => {
    if (e.target.checked) {
      // If the checkbox in the header is checked, select all rows
      const allKeys = dataSource.map((record) => {
        let giftCardItem = giftCardItems.filter((giftCard) => giftCard.mProductId === record.product.mProductId);
        if (record.returnQty < record.qty && giftCardItem.length === 0) return record.key;
      });
      setCheckedKeys(allKeys);
      setSelectedRecords(dataSource);
    } else {
      // If the checkbox in the header is unchecked, clear the selection
      setCheckedKeys([]);
      setSelectedRecords([]);
    }
  };

  const onSelect = (record) => {
    const newCheckedKeys = [...checkedKeys];
    const recordKey = record.key;
    let giftCardItem = giftCardItems.filter((giftCard) => giftCard.mProductId === record.product.mProductId);
    if (newCheckedKeys.includes(recordKey)) {
      // If the record is already selected, deselect it
      const index = newCheckedKeys.indexOf(recordKey);
      newCheckedKeys.splice(index, 1);

      // Remove the record from the selectedRecords array
      const newSelectedRecords = selectedRecords.filter((selectedRecord) => selectedRecord.key !== recordKey);
      setSelectedRecords(newSelectedRecords);
    } else {
      const index = dataSource.findIndex((record) => record.key === recordKey);
      if (dataSource[index].returnQty < dataSource[index].qty && giftCardItem.length === 0) {
        newCheckedKeys.push(recordKey);
      }
      // If the record is not selected, select it

      // Add the record to the selectedRecords array
      const newSelectedRecords = [...selectedRecords, record];
      setSelectedRecords(newSelectedRecords);
    }

    setCheckedKeys(newCheckedKeys);
  };

  const rowSelection = {
    selectedRowKeys: checkedKeys,
    onChange: (selectedKeys) => {
      setCheckedKeys(selectedKeys);
    },
  };

  const inputReturnQty = (record, e) => {
    dataSource.map((item) => {
      if (item.key === record.key) {
        item.qtyToReturn = e.target.value;
      }
    });
    setDataSource(dataSource);
  };

  const columns1 = [
    {
      title: <Checkbox onChange={onSelectAllChange} checked={checkedKeys.length === dataSource.length} />,
      width: "7%",
      dataIndex: "selection", // Use a unique dataIndex for this column
      render: (_, record) => <Checkbox checked={checkedKeys.includes(record.key)} onChange={() => onSelect(record)} />,
    },
    {
      title: "Description",
      dataIndex: "product",
      width: "25%",
      render: (_, record) => {
        return record.product.name;
      },
    },
    {
      title: "Unit Price",
      dataIndex: "grossstd",
      width: "15%",
      render: (_, record) => {
        return parseFloat(record.grossstd).toFixed(pricePrecision);
      },
    },
    {
      title: "Qty Ordered",
      dataIndex: "qty",
      width: "15%",
    },
    {
      title: "Remaining Qty",
      dataIndex: "remainingQty",
      width: "15%",
    },
    {
      title: "Qty to Return",
      dataIndex: "qtyToReturn",
      width: "15%",
      // render: (_, record) => (
      //   <Input
      //   value={record.qtyToReturn}
      //     onChange={(e) => inputReturnQty(record,e)}
      //   />
      // ),
    },
  ];

  const orderHistoryColumns = [
    {
      title: "Document Number",
      dataIndex: "documentno",
      key: "documentno",
      width: "20%",
    },
    {
      title: "Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: "20%",
    },
    {
      title: "Customer",
      dataIndex: "name",
      key: "name",
      width: "25%",
    },
    {
      title: "Total Amount",
      dataIndex: "total",
      key: "total",
      width: "25%",
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   width: "19%",
    // },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "20%",
      filters: [
        {
          text: "Layaway",
          value: "Layaway",
        },
        {
          text: "Credit Sale",
          value: "Credit Sale",
        },
        {
          text: "Return",
          value: "Return",
        },
        {
          text: "Receipt",
          value: "Receipt",
        },
      ],
      onFilter: (value, record) => record?.type === value,
      render: (text, record) => {
        let colorStyle;
        switch (record.type) {
          case "Layaway":
            colorStyle = { color: "#007BFF" };
            break;
          case "Credit Sale":
            colorStyle = { color: "#007BFF" };
            break;
          case "Return":
            colorStyle = { color: "#f0ad4e" };
            break;
          case "Receipt":
            colorStyle = { color: "#28a745" };
            break;
          default:
            colorStyle = {};
        }

        return (
          <div style={{ position: "relative" }}>
            <span style={colorStyle}>{text}</span>
            {record.status === "Success" ? (
              <CheckCircleTwoTone
                style={{
                  fontSize: "1rem",
                  cursor: "pointer",
                  marginLeft: "1vw",
                  position: "absolute",
                  right: 1,
                  top: "15%",
                }}
                twoToneColor="#A4CD38"
              />
            ) : (
              <ExclamationCircleTwoTone
                style={{
                  fontSize: "1rem",
                  cursor: "pointer",
                  marginLeft: "1vw",
                  position: "absolute",
                  right: 1,
                  top: "15%",
                }}
                twoToneColor="red"
              />
            )}
          </div>
        );
      },
    },
  ];

  const cashManagementColumn = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: "30%",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "30%",
      render: (text, record) => {
        return record.type === "cashOut"
          ? "Cash Out"
          : record.type === "pettyCashOut"
            ? "Petty Cash Out"
            : record.type === "pettyCashIn"
              ? "Petty Cash In"
              : record.type === "bankTransfer"
                ? "Bank Transfer"
                : "Cash In";
      },
    },
    {
      title: "Reasons",
      dataIndex: "note",
      key: "note",
      width: "33%",
    },
    {
      title: "Transactions(Rs)",
      dataIndex: "amount",
      key: "amount",
      width: "20%",
      render: (text, record) => {
        return record.type === "cashOut" || record.type === "pettyCashOut" || record.type === "bankTransfer" ? (
          <span style={{ color: "red" }}>-{record.amount}</span>
        ) : (
          record.amount
        );
      },
    },
  ];

  const onClose = () => {
    setOpen(false);
  };

  const handleKeyvalue = async (key) => {
    if (key === "0") {
      setSelectedPaymentMethod({});
      setKeyValue("0");
      setSelectedKeys([]);
    }
    if (key === "1") {
      filterdParkedList?.map((item, index) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
      setKeyValue("1");
      setSelectedKeys([]);
    }
    if (key === "2") {
      setKeyValue("2");
      setSelectedKeys([]);
    }

    if (key === "3") {
      showOrderHistory();
      setKeyValue("3");
      setSelectedKeys([]);
    }

    if (key === "4") {
      setSyncLoad(true);
      let tillData = JSON.parse(localStorage.getItem("tillData"));
      // const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : defaultCustomer;
      const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : tillData.tillAccess.csBunit.b2cCustomer;
      setCart({ ...cart, customer: defaultCustomer });
      await processSync(tillData, setGlobalStore, "Incremental Sync");
      setSyncLoad(false);
      setGlobalStore({ percent: "0%" });
      setGlobalStore({ productCategoryPercentage: "0" });
      setGlobalStore({ productPercentage: "0" });
      setGlobalStore({ promotionPercentage: "0" });
      // window.location.reload();
    }

    if (key === "7") {
      setKeyValue("7");
      setSelectedKeys([]);
    }

    if (key === "parked-bill") {
      const parkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
      const updatedParkedList = parkedList.map((item) => ({
        ...item,
        status: "Parked",
        key: uuidv4().replace(/-/g, "").toUpperCase(),
        customer: item?.parkedCart?.customer?.name.toLowerCase(),
        qty: item.parkedCart.totalQty,
      }));
      setFilterdParkedList(updatedParkedList);
      localStorage.setItem("parkedList", JSON.stringify(updatedParkedList));
    }
  };

  const retrieveLayaway = (record) => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Save Cart Items ?",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            You can retrieve the bill later by selecting the 'Retrieve' option in Parked Bills.
            <br />
            Do you want to continue parking the bill?
          </div>
        ),
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          parkBill();
          upsertPOSLog(cart, "OPK", "Parked");
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 600);
          }
          setTimeout(() => {
            // selectParkedBill(record, "management");
          }, 2000);
        },
        onCancel() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 300);
          }
          // selectParkedBill(record, "management");
        },
      });
    } else {
      selectLayAwayOrder(record);
    }
  };

  const onKeyPress = (button) => {
    const productSearchInput = document.getElementById("sm-product-search");
    if (button === "{enter}") {
      setLayoutName("default");
      switch (inputName !== "") {
        case inputName === "parkedBill":
          searchParkedBill(parkedBillSearchInput);
          break;
        case inputName === "salesHistoryInput":
          const inputValue = searchHistoryInput;
          if (inputValue !== "") {
            searchOrderHistory("customer", inputValue, 0, dateRange?.length > 0);
          }
          break;
        case inputName === "productSearch":
          onBarcodeInput(productSearchInput?.value, true);
          // getSearchedProducts();
          break;
        case inputName === "productSearch1":
          handleSelectProduct();
        default:
          // Handle the default case or do nothing
          break;
      }
    } else if (button === "{number}") {
      setLayoutName("number");
    } else if (button === "{numbers}") {
      setLayoutName("numbers");
    } else if (button === "{caps}") {
      setLayoutName("default");
    } else if (button === "{small}") {
      setLayoutName("shift");
    } else if (button === "{shift}" || button === "{lock}") handleShift();
  };

  // const handleShift = () => {
  //   layoutName === "default" ? setLayoutName("shift") : setLayoutName("default");
  // };

  // const onChangeInput = async (event) => {
  //   const inputVal = event.target.value;
  //   // await handleSearch(inputVal);
  //   setProductSearchInput(inputVal);
  //   localStorage.setItem("productName", inputVal);
  //   keyboard?.current?.setInput(inputVal);
  // };

  const onChangeInput = async (event) => {
    const inputVal = event.target.value;
    setProductSearchInput(inputVal);
    localStorage.setItem("productName", inputVal);
    keyboard?.current?.setInput(inputVal);
    if (posConfig?.product_search_display_mode === "dropdown") {
      if (inputVal.trim() === "") {
        setOptions([]);
        setProductMap({});
        return;
      }
      await handleSearch(inputVal);
    }
  };

  const onChangeParkedBill = (inputVal) => {
    setParkedBillSearchInput(inputVal);
    keyboard?.current?.setInput(inputVal);
  };

  const updateKeyboardInputs = async (inputs) => {
    if (!inputs) return;
    if (inputName === "customerSearch") setCustomerSearchInput(inputs?.customerSearch || "");
    if (inputName === "productSearch") {
      const searchValue = inputs?.productSearch || "";
      setProductSearchInput(searchValue);
      await handleSearch(searchValue);
    }
    if (inputName === "productSearch1") setProductSearchInput(inputs?.productSearch1 || "");
    if (inputName === "parkedBill") setParkedBillSearchInput(inputs?.parkedBill || "");
    if (inputName === "salesHistoryInput") setSearchhistoryInput(inputs?.salesHistoryInput || "");
    if (inputName === "giftCardInput") setSearchTerm(inputs?.giftCardInput || []);
    if (keyboardInputFields?.type === "addCustomerForm" || keyboardInputFields?.type === "editCustomerForm" || keyboardInputFields?.type === "UAECustomerForm") {
      const customerObj = form?.getFieldsValue(true) || {};
      const updatedFields = {
        ...customerObj,
        ...inputs,
      };
      setKeyboardInputFields(updatedFields);
      form?.setFieldsValue(updatedFields);
    }
  };

  // const handleSelectProduct = async () => {
  //   await db.products
  //     .filter((product) => product.isactive === true)
  //     .filter((product) => product.productSegment !== "BG")
  //     .toArray()
  //     .then((productsFetched) => {
  //       const lowerCaseSearchInput = productSearchInput.toLowerCase();
  //       const filteredProducts = productsFetched.filter(
  //         (product) =>
  //           product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
  //           product?.batchIndex === lowerCaseSearchInput ||
  //           product?.upcIndex === lowerCaseSearchInput ||
  //           product?.value === lowerCaseSearchInput ||
  //           product?.upc === lowerCaseSearchInput
  //       );
  //       if (filteredProducts.length === 0) {
  //         {
  //           message.info(`${t("product_search_category_error")}`);
  //         }
  //       } else {
  //         setProductsList(filteredProducts);
  //       }
  //     });
  // };
  const handleSelectProduct = async () => {
    try {
      const normalizedValue = productSearchInput?.toString().trim();
      const lowerCaseSearchInput = normalizedValue.toLowerCase();

      let productsFetched = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.productSegment !== "BG")
        .toArray();

      let filteredProducts = productsFetched.filter((product) => {
        return (
          product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
          product?.batchIndex === normalizedValue ||
          product?.upcIndex === normalizedValue ||
          product?.value === normalizedValue ||
          product?.upc === normalizedValue
        );
      });

      // 🔥 SYNC IF NOT FOUND
      if ((!filteredProducts || filteredProducts.length === 0) && normalizedValue) {
        try {
          console.log("Syncing from handleSelectProduct:", normalizedValue);

          const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

          await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, normalizedValue);

          // 🔁 Re-fetch after sync
          productsFetched = await db.products
            .filter((product) => product.isactive === true)
            .filter((product) => product.productSegment !== "BG")
            .toArray();

          filteredProducts = productsFetched.filter((product) => {
            return (
              product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
              product?.batchIndex === normalizedValue ||
              product?.upcIndex === normalizedValue ||
              product?.value === normalizedValue ||
              product?.upc === normalizedValue
            );
          });
        } catch (err) {
          console.error("Sync failed in handleSelectProduct:", err);
        }
      }

      // ✅ FINAL RESULT
      if (!filteredProducts || filteredProducts.length === 0) {
        message.info(`${t("product_search_category_error")}`);
      } else {
        setProductsList(filteredProducts);
      }
    } catch (error) {
      console.error("Error in handleSelectProduct:", error);
    }
  };

  // useEffect(() => {
  //   const notesValueInput = document.getElementById("notes-input");
  //   if (notesPopup) {
  //     notesValueInput.focus();
  //   } else {
  //     notesValueInput?.blur(); // Remove focus
  //     setIsInputFocused(false);
  //   }
  // }, [notesPopup]);
  // Helper function to check if two arrays are equal
  function arraysAreEqual(arr1, arr2) {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }

  const wareHouse = JSON.parse(localStorage.getItem("tillData"));
  const tillUnlink = async () => {
    let parkedBills = JSON.parse(localStorage.getItem("parkedList"));
    let posConfig = JSON.parse(localStorage.getItem("posConfig"));
    const orders = await db.orders.where("isSynced").equals(0).toArray();
    if (posConfigData?.posType === "PRD") {
      const unlinkTillAPI = async () => {
        try {
          let id = tillData.tillAccess.cwrTill.cwrTillID;

          const response = await unlinkTill(id);

          if (response.data.data.unlinkTill.status === "200") {
            const keepKey = "";
            localStorage.clear();
            await Promise.all(
              db.tables.map(async (table) => {
                if (table.name !== keepKey) {
                  await table.clear();
                }
              })
            );
          }

          document.cookie.split(";").forEach((cookie) => {
            document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`);
          });

          localStorage.removeItem("unlink");
          window.location.assign(`${redirectUrl}sign-in`);
        } catch (error) {
          console.error("Error in unlinkTillAPI:", error);
        }
      };
      await unlinkTillAPI();
    }
    if (parkedBills?.length > 0) {
      {
        message.error(`${t("unlink_till_parked_bill_error")}`);
      }
    } else if (cart?.items?.length > 0) {
      {
        message.error(`${t("unlink_till_cart_error")}`);
      }
    } else if (orders?.length > 0) {
      message.error(`${messages.errors.till_management.unlink_till_sync_po}`);
    } else {
      // If none of the conditions is satisfied, you can provide a default message
      if (posConfig?.shiftClose === "Y") {
        if (posConfig?.showDenominations === "Y") {
          history.push("/close-till");
          localStorage.setItem("unlink", true);
        } else if (posConfig?.showDenominations === "N") {
          history.push("/close-till-all");
          localStorage.setItem("unlink", true);
        }
      } else {
        history.push("/");
      }
    }
  };

  const handleLogin = () => {
    if (isOnline) {
      const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());

      for (let i = 0; i < cookiesToDelete.length; i++) {
        const cookie = cookiesToDelete[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        const domain = "domain=" + domainURL;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
      }

      // }
      // localStorage.removeItem("tillSession")
      localStorage.setItem("locked", isLocked);
      const redirectWithIsLocked = `${redirectUrl}sign-in/?username=${authHeaders.username}&readOnly=true`;
      window.location.assign(redirectWithIsLocked);
    } else {
      errorMessage("Sync Failed", "Please check your network connection and try again");
    }
  };
  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };
  const handleButtonClick = () => {
    setPopoverVisible(!isPopoverVisible);
  };

  const matchedSaleType = tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId;

  const renderCustomerWallet = () => {
    if (posConfig?.enable_customer_wallet !== "Y") return null;
    // Check if the cart's customer ID matches the saleTypeData's customer ID
    const selectedCustomer = cartObj?.customer?.cwrCustomerId !== matchedSaleType && cartObj?.customer?.mobileNo !== null;

    return (
      <Col
        onClick={() => {
          if (!selectedCustomer) {
            message.warning("Please update customer mobile number to proceed with Wallet");
            return;
          }
          if (selectedCustomer) {
            fetchWalletData(false); // Only fetch wallet data if not default customer
          }
        }}
        style={{
          // cursor: !selectedCustomer ? "not-allowed" : "pointer",
          cursor: "pointer",
          marginBottom: "2vh",
          //opacity: isDefaultCustomer ? 0.6 : 1, // Reduce opacity for disabled state
        }}
        span={22}
      >
        <img
          src={wallet}
          style={{
            height: "2.5vh",
            filter: !selectedCustomer ? "grayscale(100%)" : "none", // Grayscale for disabled
          }}
          alt=""
        />
        <span
          style={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "1.2em",
            paddingLeft: "1vw",
            color: "#0F0718", // Keep normal color for all cases
          }}
        >
          Customer Wallet
        </span>
      </Col>
    );
  };

  let reconstructedObject;
  const rawtillAccessMeta = tillData?.tillAccess?.tillAccessMeta;
  if (rawtillAccessMeta) {
    const rawDataArray = tillData?.tillAccess?.tillAccessMeta;
    const printObject = rawDataArray.find((item) => item.key === "Print");
    const printObjectValue = printObject?.value;
    if (printObjectValue !== undefined) {
      const cleanedData = printObjectValue.replace(/[{}"]/g, "");

      const keyValuePairs = cleanedData.split(",");

      reconstructedObject = {};
      keyValuePairs.forEach((pair) => {
        if (pair.includes(":")) {
          const [key, value] = pair.split(":");

          if (key !== undefined && value !== undefined) {
            reconstructedObject[key.trim()] = value.trim();
          }
        }
      });
    } else {
      console.error("printObjectValue is undefined");
    }
  }

  const handleExpand = (record) => {
    const nextExpandedKeys = [...expandedRowKeys];
    const index = nextExpandedKeys.indexOf(record.key);
    if (index > -1) {
      nextExpandedKeys.splice(index, 1); // Collapse row if already expanded
    } else {
      nextExpandedKeys.push(record.key); // Expand row if not expanded
      getSalesHistoryData(record.sOrderID);
    }
    setExpandedRowKeys(nextExpandedKeys);
  };

  const handleExpandPerkedData = (record) => {
    const nextExpandedKeys = [...expandedRowKeys];
    const index = nextExpandedKeys.indexOf(record.key);
    if (index > -1) {
      nextExpandedKeys.splice(index, 1); // Collapse row if already expanded
    } else {
      nextExpandedKeys.push(record.key); // Expand row if not expanded
    }
    setExpandedRowKeys(nextExpandedKeys);
  };

  // const onAddNotes = () => {
  //   let updatedCart;
  //   const activeCart = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
  //   if (selectedProductForNotes !== null && cart.items.length > 0) {
  //     updatedCart = { ...activeCart };
  //     let index = updatedCart.items.findIndex((res) => res.lineId === selectedProductForNotes.lineId);
  //     if (index >= 0) {
  //       updatedCart.items[index].notes = notesValue;
  //     }
  //     setNotesValue();
  //   } else {
  //     updatedCart = {
  //       ...activeCart,
  //       description: notesValue,
  //     };
  //     // setNotesValue()
  //   }
  //   setSelectedProductForNotes(null);
  //   if (isExchange) {
  //     localStorage.setItem("exchangeCartObj", JSON.stringify(updatedCart));
  //   } else {
  //     setCart(updatedCart);
  //     localStorage.setItem("cartObj", JSON.stringify(updatedCart));
  //   }
  //   setNotesPopup(false);
  //   setIsInputFocused(false);
  //   let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
  //     ? JSON.parse(localStorage.getItem("orderTimeDetails"))
  //     : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
  //   if (updatedCart.items.length === 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === updatedCart.customer.cwrCustomerId) {
  //     orderTimeDetails = {
  //       ...orderTimeDetails,
  //       paymentStartTime: "",
  //       orderStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
  //     };
  //   } else if (updatedCart.items.length > 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== updatedCart.customer.cwrCustomerId) {
  //     orderTimeDetails = {
  //       ...orderTimeDetails,
  //       paymentStartTime: "",
  //     };
  //   }
  //   if (updatedCart.description === "") {
  //     orderTimeDetails = {
  //       ...orderTimeDetails,
  //       paymentStartTime: "",
  //       orderStartTime: "",
  //     };
  //   }
  //   localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
  // };

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     onAddNotes();
  //   }
  // };

  // const onChange = (input) => {
  //   if (input !== "Enter") {
  //     setNotesValue(input);
  //   }
  // };

  // const onChangeInputKeyboard = (event) => {
  //   const input = event.target.value;
  //   setNotesValue(input);

  //   if (keyboardRef.current) {
  //     keyboardRef.current.setInput(input);
  //   }
  // };

  const handleDateSelect = (record) => (date, dateString) => {
    let updatedCart;
    setSelectedDate(date); // Store the selected date (you can use it elsewhere)

    setCalendarVisible(false); // Close the calendar after selection
    if (searchInputRef?.current) {
      searchInputRef?.current.focus();
    }
    if (record !== null && cart.items.length > 0) {
      updatedCart = { ...cart };
      let index = updatedCart.items.findIndex((res) => res.lineId === record.lineId);
      if (index >= 0) {
        updatedCart.items[index].deliveryDate = date && date.format("DD-MM-YYYY HH:mm:ss");
      }
      toggleCalendar(record.lineId);
    } else {
      updatedCart = {
        ...cart,
        deliveryDate: (date && date.format("DD-MM-YYYY HH:mm:ss")) || "",
        deliveryDatePromised: (date && dateString) || "", // Update the delivery date in the cart
      };
    }
    setSelectedProductForNotes(null);
    setCart(updatedCart);
    localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    setNotesPopup(false);
    setIsInputFocused(false);
    let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
      ? JSON.parse(localStorage.getItem("orderTimeDetails"))
      : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    if (updatedCart.items.length === 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
      };
    } else if (updatedCart.items.length > 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
      };
    }
    if (updatedCart.description === "") {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: "",
      };
    }
    localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
  };

  // Toggle calendar visibility for a specific row
  const toggleCalendar = (key) => {
    setCalendarVisibleMap((prev) => ({
      ...prev,
      [key]: !prev[key] || false, // Toggle or default to false
    }));
  };

  // Calendar content for a specific row
  const calendarContent = (record) => (
    <DatePicker showTime={{ format: "hh:mm A" }} format="DD-MM-YYYY hh:mm A" onChange={handleDateSelect(record)} value={selectedDate} style={{ width: 250 }} />
  );

  const showConfirm = () => {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: (
          <>
            <ExclamationCircleOutlined style={{ color: "#FAAD17" }} /> Confirm Payment Details
          </>
        ),
        icon: null,
        content: (
          <div
            style={{
              background: "#fff",
              height: "auto",
              width: "100%",
              border: "1px solid #fff",
              borderRadius: "7px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Bill Amount Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Bill Amount</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(Math.abs(cart.total)).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Tendered Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Tendered</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(amount).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Received Row */}
            <Row
              style={{
                fontSize: "1em", // Adjust font size for readability
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Received</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {Math.abs(cart.total - cart.paid).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Change Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Change Due</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {cart.paid + parseFloat(amount) - Math.abs(cart.total) > 0
                    ? (cart.paid + parseFloat(amount) - Math.abs(Math.abs(cart.total) + (posConfig?.enableChangeRounding === "Y" ? Math.abs(overPayedAmount) : 0))).toFixed(
                        pricePrecision
                      )
                    : cart?.change <= 0
                      ? "0.00"
                      : cart?.change}
                </p>
              </Col>
            </Row>
          </div>
        ),
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
        cancelButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the Cancel button
          },
        },
        okButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the OK button
          },
        },
      });
    });
  };

  let barcodeFlag = false;
  const inputElement = document.getElementById("sm-customer-search");
  const amountInput = document.getElementById("sm-amount-input");
  const totalAmountInout = document.getElementById("sm-total-amount-input");
  const inputFocused = inputElement === document.activeElement || amountInput === document.activeElement || totalAmountInout === document.activeElement;
  // const searchProductInput = document.getElementById("sm-product-search");
  // const noFocus = posConfig && posConfig?.noFocus === "Y" ? true : false;
  // const searchInputFocused = noFocus === true ? true : searchProductInput === document.activeElement ? true : false;
  const approvalFlag = localStorage.getItem("approvalFlag") ? localStorage.getItem("approvalFlag") : "1";
  if (
    !couponModalVisible &&
    !displayAddNewCustomer &&
    !validateGiftCard &&
    !displayCustomerSearch &&
    !displayEditOldCustomer &&
    !giftCardFlag &&
    !filterDrawer &&
    !isGiftCardFlag &&
    !manualDiscountModalVisible &&
    !loyalityOtpModalVisible &&
    !inputFocused &&
    !showCardPaymnteModal &&
    !showCustomMix &&
    approvalFlag === "1"
    // &&
    // searchInputFocused
  ) {
    barcodeFlag = true;
  } else {
    barcodeFlag = false;
  }

  const onFinish = async (values) => {
    let updatedCart;
    const returnSummary = {
      returnReferenceNo: values.referenceNo,
      returnRemarks: values.remarks,
    };
    const activeCart = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
    updatedCart = {
      ...activeCart,
      returnSummary,
      returnReasonId: values.reason,
    };
    if (isExchange) {
      localStorage.setItem("exchangeCartObj", JSON.stringify(updatedCart));
    } else {
      setCart(updatedCart);
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    }
    await handleCartTotalClick();
    setReasonPopup(false);
  };

  const mainDivStyles = themeJSON.appBgImageURL
    ? { backgroundImage: `url(${themeJSON.appBgImageURL})`, height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" }
    : { backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" };
  document.querySelectorAll("amt-dial-btn-market").forEach((element) => {
    element.style.backgroundColor = themeJSON.keyBoardColor;
  });

  const renderInvoice = () => {
    if (posConfig?.enablePreOrder !== "Y" && posConfig?.allowLayawaywithoutPayment !== "Y") {
      return (
        <span
          style={{ fontSize: "0.85rem", cursor: "pointer" }}
          onClick={() => {
            // setIsSectionVisible(true);
            if (posConfig?.enablePreOrder !== "Y") {
              let filtredDocument = documentTypes?.filter((element) => element.type !== selectedDocumentType && element.isVisible);
              if (cart?.docType !== "Advance" && filtredDocument.length > 0) {
                setShowDocumentPopup(true);
              }
            }
          }}
        >
          {selectedDocumentType || "Sales Invoice"} <DownOutlined style={{ fontSize: "0.7rem" }} />
        </span>
      );
    } else if (posConfig?.enablePreOrder !== "Y" && cart.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
      return <span style={{ fontSize: "0.85rem", cursor: "pointer" }}>Layaway</span>;
    } else if (posConfig?.showDocNoOnPOS === "Y") {
      return <span style={{ fontSize: "0.85rem", cursor: "pointer" }}>Order</span>;
    } else {
      return <span style={{ fontSize: "0.85rem", cursor: "pointer" }}>Invoice</span>;
    }
  };

  const renderExchangeDiv = () => {
    const returnCart = JSON.parse(localStorage.getItem("cartObj") || "{}");

    const exchangeCart = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");

    const returnTotal = parseFloat(returnCart?.total || 0);
    const exchangeTotal = parseFloat(exchangeCart?.total || 0);

    const netValue = returnTotal + exchangeTotal;
    return (
      <>
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Old Value (Return):</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj"))?.total : cart?.total).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>New Value (Exchange):</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {parseFloat(localStorage.getItem("exchangeCartObj") ? JSON.parse(localStorage.getItem("exchangeCartObj"))?.total : 0).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {netValue}
            </p>
            <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {/* {parseFloat(localStorage.getItem("exchangeCartObj") ? JSON.parse(localStorage.getItem("exchangeCartObj"))?.subTotal : 0).toFixed(pricePrecision)} */}
              {JSON.parse(localStorage.getItem("exchangeCartObj"))?.items?.length || 0} /{" "}
              {parseFloat(JSON.parse(localStorage.getItem("exchangeCartObj"))?.totalQty || 0).toFixed(2)}
            </p>
          </Col>
        </Row>
      </>
    );
  };

  const renderTotalAmountText = () => {
    const returnCart = JSON.parse(localStorage.getItem("cartObj") || "{}");
    const exchangeCart = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");

    const returnTotal = Math.abs(parseFloat(returnCart?.total || 0));
    const exchangeTotal = Math.abs(parseFloat(exchangeCart?.total || 0));

    const isExchangeMode = localStorage.getItem("selectedReturnType") === "EXCHANGE";

    const isRefund = isExchangeMode && returnTotal > exchangeTotal;

    return (
      <p
        style={{
          padding: "0.7vw 0 0 1vw",
          color: "#fff",
          fontSize: "1em",
          fontWeight: "500",
          height: "4.5vh",
        }}
      >
        {isRefund ? "Refund Amount" : "Total Amount To Pay"}
      </p>
    );
  };

  const renderPaymentsData = () => {
    const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj"));
    if (isExchange) {
      return exchangeCartObj?.payments?.map((item) => {
        return (
          <Row style={{ fontSize: "1vw" }}>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "0.8vw",
                fontWeight: "450",
                textAlign: "left",
              }}
            >
              <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" && item.authorization ? `${item.name} - ${item.authorization}` : item.name}</p>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                paddingRight: "1vw",
                textAlign: "right",
                justifyContent: "end",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "0",
                  fontWeight: "500",
                  paddingRight: "1.2vw",
                }}
              >
                {" "}
                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
              </p>
              <img
                src={DeleteProduct}
                onClick={() => handleDeletePayment(item)}
                id="sm-product-delete"
                style={{
                  height: "2.5vh",
                  cursor: "pointer",
                  right: 1,
                  top: "15%",
                }}
              />
            </Col>
          </Row>
        );
      });
    } else {
      return cart.payments.map((item) => {
        return (
          <Row style={{ fontSize: "1vw" }}>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "0.8vw",
                fontWeight: "450",
                textAlign: "left",
              }}
            >
              <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" && item.authorization ? `${item.name} - ${item.authorization}` : item.name}</p>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                paddingRight: "1vw",
                textAlign: "right",
                justifyContent: "end",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  margin: "0",
                  fontWeight: "500",
                  paddingRight: "1.2vw",
                }}
              >
                {" "}
                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
              </p>
              <img
                src={DeleteProduct}
                onClick={() => handleDeletePayment(item)}
                id="sm-product-delete"
                style={{
                  height: "2.5vh",
                  cursor: "pointer",
                  right: 1,
                  top: "15%",
                }}
              />
            </Col>
          </Row>
        );
      });
    }
  };

  const renderReturnAmount = () => {
    return (
      <span
        style={{
          color: "#D32F2F",
          fontWeight: 500,
          fontSize: "0.8em",
        }}
      >
        {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
        {parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")).total : cart.total).toFixed(2)}
        {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
      </span>
    );
  };

  const renderExchangeAmount = () => {
    return (
      <span
        style={{
          color: "#2F8F46",
          fontWeight: 500,
          fontSize: "0.8em",
        }}
      >
        {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
        {parseFloat(localStorage.getItem("exchangeCartObj") ? JSON.parse(localStorage.getItem("exchangeCartObj")).total : 0).toFixed(2)}
        {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
      </span>
    );
  };

  const renderDocumentNo = () => {
    if (posConfig?.showDocNoOnPOS === "Y") {
      return <span>Document No: {cart?.documentno}</span>;
    } else if (posConfig?.disableOfflineBilling === "Y") {
      return "";
    } else {
      return <span>Invoice No: {cart?.documentno}</span>;
    }
  };

  const renderDeliveryDate = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          padding: "3px 6px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          color: "white",
          cursor: "pointer",
          width: "fit-content",
        }}
      >
        <CalendarOutlined
          style={{
            fontSize: "0.85rem",
            cursor: "pointer",
            paddingBottom: "0.1em",
          }}
        />
        <span style={{ fontSize: "0.7rem" }}>{cart?.deliveryDate || "Delivery Date"}</span>
      </div>
    );
  };

  const watermark = () => {
    const receiptlessReturn2Enabled = posConfig?.enableReceiptlessReturn2 === "Y";
    const returnEnabled = receiptlessReturn2Enabled && cart?.isReturn === true && cart?.isBlindReceipt === true;
    if (localStorage.getItem("selectedReturnType") !== "EXCHANGE") {
      return (
        <div
          style={{
            position: "absolute",
            top: "57%",
            left: "30%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "", // Adjusted for larger text
            height: "54px", // Adjusted for 54px font
            zIndex: 10, // Ensure it appears above table
          }}
        >
          <span
            style={{
              fontFamily: "Montserrat",
              fontWeight: "bold",
              fontSize: "50px",
              color: "#000",
              textAlign: "center",
              opacity: "10%",
            }}
          >
            {returnEnabled
              ? "RETURN"
              : posConfig?.showDocNoOnPOS === "Y"
                ? "ORDER"
                : posConfig?.allowLayawaywithoutPayment === "Y" && cart?.layAway === "Y"
                  ? "LAYAWAY"
                  : "INVOICE"}
          </span>
        </div>
      );
    }
  };

  const handleLogout = async () => {
    setLogoutLoading(true);
    let parkedBills = JSON.parse(localStorage.getItem("parkedList"));
    let posConfig = JSON.parse(localStorage.getItem("posConfig"));
    const orders = await db.orders.where("isSynced").equals(0).toArray();
    if (posConfig?.saveParkedBills === "Y") {
      try {
        const dateRange = getCurrentMonthRange();

        const filterBy = JSON.stringify({
          DateRange: dateRange,
        });

        const sortBy = JSON.stringify({
          created: "DESC",
        });

        const response = await cartHistory({
          q: "",
          filter_by: filterBy,
          sort_by: sortBy,
          tillId: tillData?.tillAccess?.cwrTill?.cwrTillID ? tillData?.tillAccess?.cwrTill?.cwrTillID : null,
        });

        if (response?.status === 200) {
          const data = JSON.parse(response?.data?.data?.cartHistory || "[]");

          const parkedBillsFromAPI = data.filter((item) => item?.cartstatus === "DR");

          if (parkedBillsFromAPI.length > 0) {
            message.error(`${t("unlink_till_parked_bill_error")}`);
            setLogoutLoading(false);
            return;
          } else {
            console.log("✅ No parked bills found from API.");
          }
        }
      } catch (error) {
        console.error("Error checking parked bills:", error);
        setLogoutLoading(false);
        return;
      }
    } else {
      if (parkedBills?.length > 0) {
        message.error(`${t("unlink_till_parked_bill_error")}`);
        setLogoutLoading(false);
        return;
      } else {
        console.log("✅ No parked bills in localStorage");
      }
    }

    if (cart?.items?.length > 0) {
      {
        message.error(`${t("unlink_till_cart_error")}`);
      }
      setLogoutLoading(false);
    } else if (orders?.length > 0) {
      handleLogout();
    } else {
      if (posConfigData?.posType === "PRD") {
        const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
        for (let i = 0; i < cookiesToDelete.length; i++) {
          const cookie = cookiesToDelete[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          const domain = "domain=" + domainURL;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
        }
        localStorage.removeItem("tillSession");
        window.location.assign("/");
        setLogoutLoading(false);
      } else {
        removeCutomer();
        openDrawer();
        upsertPOSLog(cart, "LGO");
        console.log("ponscongiffff====", posConfig);
        if (posConfig?.shiftClose === "Y") {
          if (posConfig?.showDenominations === "Y") {
            history.push("/close-till");
          } else if (posConfig?.showDenominations === "N" && posConfig?.showCloseTillPaymentSummary === "Y") {
            console.log("=======================");
            if (!tillSession) return history.push("/");

            let cashStats = { cashIn: 0, cashOut: 0, pettyCashIn: 0, pettyCashOut: 0 };

            try {
              setLoading(true);
              // Fetch cash transactions
              const cashDetails = await db.cashInCashOut.toArray();
              cashDetails.forEach(({ type, amount }) => {
                cashStats[type] += parseFloat(amount || 0);
              });

              // Fetch currency details
              const registrations = await db.tillRegistrations.toArray();
              const currency = registrations[0]?.tillAccess?.[0]?.csBunit?.csCurrency;

              // Fetch orders for the session
              const orders = await db.orders.where("tillSessionId").equals(sessionId).toArray();
              const tillEvent = await db.tillEvents.where("tillSessionId").equals(sessionId).toArray();
              console.log("tillEvent =======>", tillEvent);

              // Process payments
              const updatedPayments = paymentMethodList.map((payment) => {
                let expectedAmount = 0,
                  paymentReturn = 0,
                  transactionCount = 0;

                orders.forEach(({ total, payments = [], paymentData = [], deliveryDate }) => {
                  payments.forEach(({ name, amount }) => {
                    if (payment.name.toLowerCase() === name.toLowerCase()) {
                      const value = parseFloat(amount || 0);
                      total > 0 ? (expectedAmount += value) : (paymentReturn += Math.abs(value));
                      transactionCount++;
                    }
                  });
                  const now = moment();
                  const openingMoment = moment(tillSession.openingTime, "YYYY-MM-DD HH:mm:ss");
                  const orderMoment = moment(deliveryDate, "DD-MM-YYYY HH:mm:ss");
                  if (orderMoment.isSameOrAfter(openingMoment) && orderMoment.isSameOrBefore(now)) {
                    paymentData.forEach(({ name, amount }) => {
                      if (payment.name.toLowerCase() === name.toLowerCase()) {
                        const value = parseFloat(amount || 0);
                        total > 0 ? (expectedAmount += value) : (paymentReturn += Math.abs(value));
                        transactionCount++;
                      }
                    });
                  }
                });

                tillEvent.forEach(({ walletTransactions = [] }) => {
                  walletTransactions?.forEach((transaction) => {
                    if (transaction?.finPaymentmethodID === payment?.finPaymentmethodId) {
                      const value = parseFloat(transaction?.amount || 0);
                      expectedAmount += value;
                      transactionCount++;
                    }
                  });
                });

                return {
                  ...payment,
                  expectedAmount,
                  amount: 0,
                  paymentReturn,
                  difference: Math.abs(paymentReturn) - expectedAmount,
                  transactionCount,
                };
              });

              // Handle cash payments
              const cashPayment = updatedPayments.find((p) => p.name.toLowerCase() === "cash");
              let tempOpeningAmount = 0;
              let tempExpectedAmount = 0;
              if (cashPayment) {
                const { expectedAmount, paymentReturn, transactionCount } = cashPayment;
                const openingAmount = JSON.parse(localStorage.getItem("tillSession"))?.totalOpeningAmount || 0;
                const includeOpening = tillData?.tillAccess?.csBunit?.incDayOpening !== "N";
                tempOpeningAmount = openingAmount;
                tempExpectedAmount = expectedAmount;
                console.log(cashStats, "cashStats");
              }

              // Update till session details
              // const tillEvent = await db.tillEvents.where("tillSessionId").equals(sessionId).toArray();
              if (tillEvent.length > 0 && tillEvent[0]?.cashInOutData) {
                cashStats = tillEvent[0].cashInOutData;
              }

              const updatedTillSession = { ...tillSession };
              const cashIndex = updatedPayments.findIndex((p) => p.name.toLowerCase() === "cash");
              const closingCash = tillSession?.closingCash || 0;
              let updatedAmount = 0;
              if (cashIndex !== -1) {
                updatedAmount =
                  parseFloat(updatedPayments[cashIndex].expectedAmount) + cashStats.cashIn - cashStats.cashOut + (cashStats.pettyCashIn || 0) - (cashStats.pettyCashOut || 0);
                if (tillData?.tillAccess?.csBunit?.incDayOpening !== "N") {
                  updatedAmount += parseFloat(tempOpeningAmount || 0);
                }

                updatedPayments[cashIndex] = {
                  ...updatedPayments[cashIndex],
                  expectedAmount: updatedAmount,
                  amount: closingCash,
                  actualAmount: closingCash,
                  cashSaleAmount: parseFloat(tempExpectedAmount?.toFixed(tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision || 2)),
                  difference: parseFloat(
                    (closingCash - (updatedAmount - updatedPayments[cashIndex].paymentReturn)).toFixed(tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision || 2)
                  ),
                };
              }

              Object.assign(updatedTillSession, {
                closingTime: moment().format("YYYY-MM-DD HH:mm:ss"),
                closingCash,
                closingCashDenominations: [],
                allPaymentsData: updatedPayments,
                totalOrdersCount: orders.length,
              });

              await db.tillEvents.where("tillSessionId").equals(updatedTillSession.tillSessionId).modify(updatedTillSession);
              localStorage.setItem("tillSession", JSON.stringify(updatedTillSession));
              if ((cashIndex === -1 || posConfig?.showDenominations === "N") && posConfig?.showCloseTillPaymentSummary === "Y") {
                history.push("/close-till-all");
              }
              setLoading(false);
            } catch (error) {
              setLoading(false);
              console.error("Error during data fetch:", error);
            }
          } else {
            history.push("/");
          }
        } else {
          history.push("/");
        }
        setLogoutLoading(false);
      }
    }
  };

  // const handleReceiptReprint = async (record, options = {}) => {
  //   const { orderCompleted = false } = options;

  //   const data = orderCompleted ? { ...record, orderCompleted: true } : record;

  //   const { workflowRules, approvers } = await getWorkflowData();

  //   if (workflowRules && workflowRules.length > 0) {
  //     workflowRules.forEach((res) => {
  //       if (res.eventName === "Receipt Reprint Request") {
  //         dispatchEvent(res.eventName, res.ruleName, res.ruleCondition, approvers, (eventData) => {
  //           if (eventData?.approvalGranted) {
  //             ObFlag
  //               ? HCPrint(data, "Duplicate Copy")
  //               : CWHardwareController
  //                 ? CWHCPrint(data, "Duplicate Copy")
  //                 : isPrintModeXML
  //                   ? xmlPrint(data, "Duplicate Copy")
  //                   : htmlPrint(data, "Duplicate Copy");
  //           }
  //         });
  //       }
  //     });
  //   } else {
  //     ObFlag
  //       ? HCPrint(data, "Duplicate Copy")
  //       : CWHardwareController
  //         ? CWHCPrint(data, "Duplicate Copy")
  //         : isPrintModeXML
  //           ? xmlPrint(data, "Duplicate Copy")
  //           : htmlPrint(data, "Duplicate Copy");

  //     upsertPOSLog(data, "RRC");
  //   }
  // };

  const executeReprint = async (data) => {
    const { workflowRules, approvers } = await getWorkflowData();

    if (workflowRules && workflowRules.length > 0) {
      workflowRules.forEach((res) => {
        if (res.eventName === "Receipt Reprint Request") {
          dispatchEvent(res.eventName, res.ruleName, res.ruleCondition, approvers, null, (eventData) => {
            if (eventData?.approvalGranted) {
              ObFlag
                ? HCPrint(data, "Duplicate Copy")
                : CWHardwareController
                  ? CWHCPrint(data, "Duplicate Copy")
                  : isPrintModeXML
                    ? xmlPrint(data, "Duplicate Copy")
                    : htmlPrint(data, "Duplicate Copy");
            }
          });
        }
      });
    } else {
      ObFlag
        ? HCPrint(data, "Duplicate Copy")
        : CWHardwareController
          ? CWHCPrint(data, "Duplicate Copy")
          : isPrintModeXML
            ? xmlPrint(data, "Duplicate Copy")
            : htmlPrint(data, "Duplicate Copy");

      upsertPOSLog(data, "RRC");
    }
  };

  const handleReceiptReprint = async (record, options = {}) => {
    const { orderCompleted = false } = options;
    const data = orderCompleted ? { ...record, orderCompleted: true } : record;
    const reprintRules = posConfig?.reprintRules ? JSON.parse(posConfig?.reprintRules) : {};
    // const hasServiceItem = data?.items?.some((item) => item.type === "S");
    let hasServiceItem = false;

    if (reprintRules?.restrict_reprint === true) {
      const rules = reprintRules?.rules || {};
      const restrictedCategories = rules?.categories || [];
      const restrictedProducts = rules?.products || [];
      const hasRestrictedItem = data?.items?.some((item) => {
        const categoryMatch = restrictedCategories.includes(item?.mProductCategoryId);
        const productMatch = restrictedProducts.includes(item?.productId);
        return categoryMatch || productMatch;
      });

      if (hasRestrictedItem) {
        hasServiceItem = true;
      }
    }

    if (!enableMultiPrintTemplates && printTemplates.length > 0 && hasServiceItem) {
      message.warning("Reprint is not allowed for bills containing Service items.");
      return;
    } else if (printTemplates.length > 0 && hasServiceItem) {
      message.warning("Reprint is not allowed for bills containing Service items.");
      return;
    } else if (printTemplates.length > 0) {
      setPendingReprintRecord(data);
      setSelectedPrintTemplate(printTemplates[0]?.cwr_printtemplate_id || null);
      setShowPrintTemplateModal(true);
    } else {
      await executeReprint(data);
    }
  };

  const handlePrintTemplateConfirm = async () => {
    setShowPrintTemplateModal(false);
    localStorage.setItem("selectedPrintTemplateId", selectedPrintTemplate);
    if (pendingReprintRecord) {
      await executeReprint(pendingReprintRecord);
      setPendingReprintRecord(null);
    }
    setSelectedPrintTemplate(null);
    localStorage.removeItem("selectedPrintTemplateId");
  };

  const handlePrintTemplateCancel = () => {
    setShowPrintTemplateModal(false);
    setPendingReprintRecord(null);
    setSelectedPrintTemplate(null);
  };

  // const handlePayment = async ({
  //   selectedPaymentMethod,
  //   cart,
  //   amount,
  //   posConfig,
  //   tillData,
  //   isOnline,
  //   isExchange,
  //   showConfirm,
  //   requestPayment,
  //   processOrder,
  //   setShowCardPaymnteModal,
  //   setPaymentType,
  //   setCardPaymnetError,
  //   messages,
  //   t,
  //   isCardPaymentFlag = false,
  //   enableGiftCardCheck = false,
  //   enablePoleDisplay = false,
  //   enableSetNumb = false,
  //   setNumb,
  //   CWHardwareController,
  //   CWPoleDisplay,
  //   PoleDisplay,
  // }) => {
  //   const paymentName = selectedPaymentMethod?.name?.toLowerCase();
  //   const parsedAmount = parseFloat(amount || 0);
  //   const cartPaid = parseFloat(cart?.paid || 0);
  //   const cartTotal = parseFloat(cart?.total || 0);

  //   if (isCardPaymentFlag) return;

  //   const cashSaleValidation = retailCustomerRules?.find((rule) => rule.condition === "Cash Sale Validation");

  //   if (paymentName === "cash" && cashSaleValidation?.value && parseFloat(parsedAmount) > parseFloat(cashSaleValidation.value)) {
  //     const limitAmount = parseFloat(cashSaleValidation.value);

  //     const formattedLimit = limitAmount.toLocaleString("en-IN", {
  //       minimumFractionDigits: 0,
  //       maximumFractionDigits: 0,
  //     });

  //     Modal.warning({
  //       title: "Cash Payment Restricted",
  //       content: `Cash payments above ₹${formattedLimit} are not allowed.
  //         Please select another payment method or split the payment.`,
  //       okText: "OK",
  //       cancelButtonProps: { style: { display: "none" } },
  //     });

  //     return;
  //   }

  //   if (paymentName === "cash" && cartPaid + parsedAmount >= cartTotal && posConfig?.showPaymentSummary === "Y") {
  //     const confirmed = await showConfirm();
  //     if (!confirmed) return;
  //   }

  //   if (paymentName === "card" && posConfig?.show_card_payment_popup === "Y") {
  //     if (selectedPaymentMethod?.integratedPayment) {
  //       setShowCardPaymnteModal(true);
  //       return;
  //     } else {
  //       setPaymentType("manual");
  //       setCardPaymnetError(true);
  //       setShowCardPaymnteModal(true);
  //       return;
  //     }
  //   }

  //   const denominations = tillData?.tillAccess?.csBunit?.currencies?.[0]?.denominations?.sort((a, b) => a.value - b.value) || [];

  //   const smallest = denominations?.[0]?.value || 1;
  //   const result = modulo(parsedAmount, smallest);

  //   const isGiftCardOrLoyalty = paymentName !== "loyalty" && paymentName !== "voucher" && paymentName !== "gift card";

  //   if (enableGiftCardCheck && !isGiftCardOrLoyalty) {
  //     return;
  //   }

  //   const isExchangeMode = localStorage.getItem("selectedReturnType") === "EXCHANGE";

  //   const exchangeCartData = isExchangeMode ? JSON.parse(localStorage.getItem("exchangeCartObj") || "{}") : null;

  //   const netForPayment = isExchangeMode ? Math.abs((exchangeCartData?.total || 0) + cartTotal) : Math.abs(cartTotal);

  //   const paidForPayment = isExchangeMode ? exchangeCartData?.paid || 0 : cartPaid;

  //   if (netForPayment > Math.abs(paidForPayment)) {
  //     if (paymentName === "cash" && result !== 0) {
  //       message.warning(messages?.warnings?.payment?.payment_multiple_check ? `${messages.warnings.payment.payment_multiple_check} ${smallest}` : t?.("cash_payment_error"));
  //       return;
  //     }

  //     if (posConfig?.disableOfflineBilling === "Y" && !isOnline) {
  //       message.warning(`${messages?.warnings?.payment?.payment_network_check}`);
  //       return;
  //     }

  //     if (enableSetNumb && setNumb) {
  //       setNumb(0);
  //     }

  //     requestPayment(selectedPaymentMethod, parsedAmount);

  //     if (enablePoleDisplay && Math.abs(cartTotal) > parsedAmount) {
  //       if (CWHardwareController) {
  //         CWPoleDisplay(cart, "Show due payment", parsedAmount);
  //       } else if (PoleDisplay) {
  //         PoleDisplay(cart, "Show due payment", parsedAmount);
  //       }
  //     }
  //   } else if (netForPayment === 0 && isExchange) {
  //     requestPayment(selectedPaymentMethod, parsedAmount);
  //   } else if (cart?.docType !== "Advance") {
  //     processOrder();
  //   }
  // };
  const returnEnable = posConfig?.enableReceiptlessReturn2 === "Y";
  const isReturnDisabled = returnEnable
    ? cart.isReturn || cart.items.length > 0 // wallet mode → only block if already return
    : !(cart.items.length > 0 && !cart.isReturn);
  const shouldShowReturnButton = returnEnable
    ? true // Wallet mode ignores enableReceiptlessReturn
    : posConfig?.enableReceiptlessReturn === "Y";
  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
      {isParkedBill ? (
        posConfig?.saveParkedBills === "Y" ? (
          <div
            style={{
              background: colorVariable ? colorVariable : "#f3f4f9",
              height: "100vh",
            }}
          >
            <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
              <Col span={6}>
                <img
                  src={Back}
                  id="sm-parked-bill-back"
                  onClick={() => {
                    setIsparkedBill(false);
                    setIsInputFocused(false);
                    setParkedBillSearchInput("");
                    setLayoutName("default");
                    setCartHistoryData([]);
                    setExpandedRowKey(null);
                    setActiveTab("pending");
                  }}
                  style={{
                    height: "3vw",
                    paddingBottom: "0.7em",
                    cursor: "pointer",
                  }}
                />
                <span
                  style={{
                    paddingRight: "1vw",
                    fontSize: "1.8em",
                    fontWeight: 500,
                    margin: "0.5em",
                    paddingTop: "0.5em",
                    color: "#0F0718",
                  }}
                >
                  Cart History
                </span>
              </Col>
              <Col
                span={18}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <Input
                  placeholder="Search for customers"
                  allowClear={false}
                  style={{ width: "70%", borderRadius: "5px", border: "none" }}
                  onPressEnter={() => {
                    const status = getStatusForTab(activeTab);
                    fetchCartHistory(status);
                  }}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                  }}
                  value={searchInput}
                />
              </Col>
            </Row>

            <Row style={{ padding: "1em 1.5em" }}>
              <Tabs activeKey={activeTab} onChange={handleTabChange} style={{ width: "100%" }}>
                <TabPane tab="Pending" key="pending">
                  <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
                    {cartHistoryData?.length === 0 && !loadingCart ? (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "3rem",
                          color: "#929098",
                          background: "#fff",
                          borderRadius: "12px",
                        }}
                      >
                        No pending bills found
                      </div>
                    ) : (
                      <div>
                        {/* Table Header */}
                        <Row
                          style={{
                            background: "#fff",
                            padding: "1rem 1.5rem",
                            borderRadius: "12px 12px 0 0",
                            fontWeight: 600,
                            fontSize: "0.9rem",
                            color: "#5D5A66",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                        >
                          <Col span={5}>Parked Sale</Col>
                          <Col span={5}>Document No</Col>
                          <Col span={6}>Customer</Col>
                          <Col span={3}>Qty</Col>
                          <Col span={5}>Status</Col>
                        </Row>

                        {/* Table Rows */}
                        {cartHistoryData?.map((record) => (
                          <div key={record.key}>
                            <Row
                              style={{
                                background: "#fff",
                                padding: "1rem 1.5rem",
                                borderBottom: "1px solid #f0f0f0",
                                cursor: "pointer",
                                alignItems: "center",
                                fontSize: "0.95rem",
                              }}
                              onClick={() => toggleExpand(record.key)}
                            >
                              <Col span={5}>
                                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                  {expandedRowKey === record.key ? (
                                    <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                                  ) : (
                                    <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                                  )}
                                  <span>{moment(record.request_date).format("YYYY-MM-DD HH:mm:ss")}</span>
                                </div>
                              </Col>
                              <Col span={5}>
                                <span style={{ fontWeight: 500 }}>{record.cart_no}</span>
                              </Col>
                              <Col span={6}>{record.cart_items?.customer?.name || "Cash & Carry"}</Col>
                              <Col span={3}>{record.cart_items?.totalQty || 0}</Col>
                              <Col span={5}>
                                <span
                                  style={{
                                    padding: "0.25rem 0.75rem",
                                    borderRadius: "6px",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    background: "#fff4e6",
                                    color: "#fa8c16",
                                  }}
                                >
                                  Parked
                                </span>
                              </Col>
                            </Row>

                            {/* Expanded Content */}
                            {expandedRowKey === record.key && (
                              <div
                                style={{
                                  background: "#fafafa",
                                  padding: "1.5rem",
                                  borderBottom: "1px solid #f0f0f0",
                                }}
                              >
                                {/* Items Table */}
                                <div
                                  style={{
                                    background: "#fff",
                                    borderRadius: "8px",
                                    padding: "1rem",
                                    marginBottom: "1rem",
                                  }}
                                >
                                  <Row
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "0.85rem",
                                      color: "#5D5A66",
                                      padding: "0.5rem 0",
                                      borderBottom: "1px solid #f0f0f0",
                                    }}
                                  >
                                    <Col span={10}>Description</Col>
                                    <Col span={4} style={{ textAlign: "center" }}>
                                      Qty
                                    </Col>
                                    <Col span={5} style={{ textAlign: "right" }}>
                                      Unit Price
                                    </Col>
                                    <Col span={5} style={{ textAlign: "right" }}>
                                      Net Total
                                    </Col>
                                  </Row>

                                  {record.cart_items?.items?.map((item, index) => (
                                    <Row
                                      key={item.lineId || index}
                                      style={{
                                        padding: "0.75rem 0",
                                        borderBottom: index < record.cart_items.items.length - 1 ? "1px solid #f5f5f5" : "none",
                                        fontSize: "0.9rem",
                                      }}
                                    >
                                      <Col span={10}>
                                        <div>{item.value}</div>
                                        {item.name2 && <div style={{ fontSize: "0.8rem", color: "#929098", marginTop: "0.25rem" }}>{item.name2}</div>}
                                      </Col>
                                      <Col span={4} style={{ textAlign: "center" }}>
                                        {item.key + 1}
                                      </Col>
                                      <Col span={5} style={{ textAlign: "right" }}>
                                        {item.unitPrice?.toFixed(2)}
                                      </Col>
                                      <Col span={5} style={{ textAlign: "right", fontWeight: 500 }}>
                                        {item.linenet?.toFixed(2)}
                                      </Col>
                                    </Row>
                                  ))}
                                </div>

                                {/* Summary Section */}
                                <Row>
                                  <Col span={14}></Col>
                                  <Col span={10}>
                                    <div
                                      style={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        padding: "1rem",
                                      }}
                                    >
                                      <Row
                                        style={{
                                          marginBottom: "0.5rem",
                                          fontSize: "0.9rem",
                                        }}
                                      >
                                        <Col span={12}>Subtotal</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.subTotal?.toFixed(2)}
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          marginBottom: "0.75rem",
                                          fontSize: "0.9rem",
                                          paddingBottom: "0.75rem",
                                          borderBottom: "1px solid #f0f0f0",
                                        }}
                                      >
                                        <Col span={12}>Total tax</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.tax?.toFixed(2)}
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          fontWeight: 600,
                                          fontSize: "1rem",
                                        }}
                                      >
                                        <Col span={12}>SALE TOTAL</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.total?.toFixed(2)}
                                        </Col>
                                      </Row>
                                    </div>

                                    {/* Retrieve Button - Only in Pending Tab */}
                                    {record?.status !== "REQ" && (
                                      <button
                                        onClick={() => handleRetrieve(record)}
                                        style={{
                                          width: "100%",
                                          marginTop: "1rem",
                                          padding: "0.75rem",
                                          background: "#1890ff",
                                          color: "#fff",
                                          border: "none",
                                          borderRadius: "8px",
                                          fontSize: "0.95rem",
                                          fontWeight: 500,
                                          cursor: "pointer",
                                        }}
                                      >
                                        Retrieve sale
                                      </button>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </Spin>
                </TabPane>

                <TabPane tab="Processed" key="processed">
                  <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
                    {cartHistoryData?.length === 0 && !loadingCart ? (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "3rem",
                          color: "#929098",
                          background: "#fff",
                          borderRadius: "12px",
                        }}
                      >
                        No processed bills found
                      </div>
                    ) : (
                      <div>
                        {/* Table Header */}
                        <Row
                          style={{
                            background: "#fff",
                            padding: "1rem 1.5rem",
                            borderRadius: "12px 12px 0 0",
                            fontWeight: 600,
                            fontSize: "0.9rem",
                            color: "#5D5A66",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                        >
                          <Col span={5}>Parked Sale</Col>
                          <Col span={5}>Document No</Col>
                          <Col span={6}>Customer</Col>
                          <Col span={3}>Qty</Col>
                          <Col span={5}>Status</Col>
                        </Row>

                        {/* Table Rows */}
                        {cartHistoryData?.map((record) => (
                          <div key={record.key}>
                            <Row
                              style={{
                                background: "#fff",
                                padding: "1rem 1.5rem",
                                borderBottom: "1px solid #f0f0f0",
                                cursor: "pointer",
                                alignItems: "center",
                                fontSize: "0.95rem",
                              }}
                              onClick={() => toggleExpand(record.key)}
                            >
                              <Col span={5}>
                                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                  {expandedRowKey === record.key ? (
                                    <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                                  ) : (
                                    <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                                  )}
                                  <span>{moment(record.request_date).format("YYYY-MM-DD HH:mm:ss")}</span>
                                </div>
                              </Col>
                              <Col span={5}>
                                <span style={{ fontWeight: 500 }}>{record.cart_no}</span>
                              </Col>
                              <Col span={6}>{record.cart_items?.customer?.name || "Cash & Carry"}</Col>
                              <Col span={3}>{record.cart_items?.totalQty || 0}</Col>
                              <Col span={5}>
                                <span
                                  style={{
                                    padding: "0.25rem 0.75rem",
                                    borderRadius: "6px",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    background: "#e6f7ff",
                                    color: "#1890ff",
                                  }}
                                >
                                  Completed
                                </span>
                              </Col>
                            </Row>

                            {/* Expanded Content - View Only (No Retrieve Button) */}
                            {expandedRowKey === record.key && (
                              <div
                                style={{
                                  background: "#fafafa",
                                  padding: "1.5rem",
                                  borderBottom: "1px solid #f0f0f0",
                                }}
                              >
                                {/* Items Table */}
                                <div
                                  style={{
                                    background: "#fff",
                                    borderRadius: "8px",
                                    padding: "1rem",
                                    marginBottom: "1rem",
                                  }}
                                >
                                  <Row
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "0.85rem",
                                      color: "#5D5A66",
                                      padding: "0.5rem 0",
                                      borderBottom: "1px solid #f0f0f0",
                                    }}
                                  >
                                    <Col span={10}>Description</Col>
                                    <Col span={4} style={{ textAlign: "center" }}>
                                      Qty
                                    </Col>
                                    <Col span={5} style={{ textAlign: "right" }}>
                                      Unit Price
                                    </Col>
                                    <Col span={5} style={{ textAlign: "right" }}>
                                      Net Total
                                    </Col>
                                  </Row>

                                  {record.cart_items?.items?.map((item, index) => (
                                    <Row
                                      key={item.lineId || index}
                                      style={{
                                        padding: "0.75rem 0",
                                        borderBottom: index < record.cart_items.items.length - 1 ? "1px solid #f5f5f5" : "none",
                                        fontSize: "0.9rem",
                                      }}
                                    >
                                      <Col span={10}>
                                        <div>{item.value}</div>
                                        {item.name2 && <div style={{ fontSize: "0.8rem", color: "#929098", marginTop: "0.25rem" }}>{item.name2}</div>}
                                      </Col>
                                      <Col span={4} style={{ textAlign: "center" }}>
                                        {item.key + 1}
                                      </Col>
                                      <Col span={5} style={{ textAlign: "right" }}>
                                        {item.unitPrice?.toFixed(2)}
                                      </Col>
                                      <Col span={5} style={{ textAlign: "right", fontWeight: 500 }}>
                                        {item.linenet?.toFixed(2)}
                                      </Col>
                                    </Row>
                                  ))}
                                </div>

                                {/* Summary Section - View Only */}
                                <Row>
                                  <Col span={14}></Col>
                                  <Col span={10}>
                                    <div
                                      style={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        padding: "1rem",
                                      }}
                                    >
                                      <Row
                                        style={{
                                          marginBottom: "0.5rem",
                                          fontSize: "0.9rem",
                                        }}
                                      >
                                        <Col span={12}>Subtotal</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.subTotal?.toFixed(2)}
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          marginBottom: "0.75rem",
                                          fontSize: "0.9rem",
                                          paddingBottom: "0.75rem",
                                          borderBottom: "1px solid #f0f0f0",
                                        }}
                                      >
                                        <Col span={12}>Total tax</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.tax?.toFixed(2)}
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          fontWeight: 600,
                                          fontSize: "1rem",
                                        }}
                                      >
                                        <Col span={12}>SALE TOTAL</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.total?.toFixed(2)}
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </Spin>
                </TabPane>

                <TabPane tab="Cancelled" key="cancelled">
                  <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
                    {cartHistoryData?.length === 0 && !loadingCart ? (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "3rem",
                          color: "#929098",
                          background: "#fff",
                          borderRadius: "12px",
                        }}
                      >
                        No cancelled bills found
                      </div>
                    ) : (
                      <div>
                        {/* Table Header */}
                        <Row
                          style={{
                            background: "#fff",
                            padding: "1rem 1.5rem",
                            borderRadius: "12px 12px 0 0",
                            fontWeight: 600,
                            fontSize: "0.9rem",
                            color: "#5D5A66",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                        >
                          <Col span={5}>Parked Sale</Col>
                          <Col span={5}>Document No</Col>
                          <Col span={6}>Customer</Col>
                          <Col span={3}>Qty</Col>
                          <Col span={5}>Status</Col>
                        </Row>

                        {/* Table Rows */}
                        {cartHistoryData?.map((record) => (
                          <div key={record.key}>
                            <Row
                              style={{
                                background: "#fff",
                                padding: "1rem 1.5rem",
                                borderBottom: "1px solid #f0f0f0",
                                cursor: "pointer",
                                alignItems: "center",
                                fontSize: "0.95rem",
                              }}
                              onClick={() => toggleExpand(record.key)}
                            >
                              <Col span={5}>
                                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                  {expandedRowKey === record.key ? (
                                    <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                                  ) : (
                                    <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                                  )}
                                  <span>{moment(record.request_date).format("YYYY-MM-DD HH:mm:ss")}</span>
                                </div>
                              </Col>
                              <Col span={5}>
                                <span style={{ fontWeight: 500 }}>{record.cart_no}</span>
                              </Col>
                              <Col span={6}>{record.cart_items?.customer?.name || "Cash & Carry"}</Col>
                              <Col span={3}>{record.cart_items?.totalQty || 0}</Col>
                              <Col span={5}>
                                <span
                                  style={{
                                    padding: "0.25rem 0.75rem",
                                    borderRadius: "6px",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    background: "#fff1f0",
                                    color: "#ff4d4f",
                                  }}
                                >
                                  Cancelled
                                </span>
                              </Col>
                            </Row>

                            {/* Expanded Content - View Only (No Retrieve Button) */}
                            {expandedRowKey === record.key && (
                              <div
                                style={{
                                  background: "#fafafa",
                                  padding: "1.5rem",
                                  borderBottom: "1px solid #f0f0f0",
                                }}
                              >
                                {/* Items Table */}
                                <div
                                  style={{
                                    background: "#fff",
                                    borderRadius: "8px",
                                    padding: "1rem",
                                    marginBottom: "1rem",
                                  }}
                                >
                                  <Row
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "0.85rem",
                                      color: "#5D5A66",
                                      padding: "0.5rem 0",
                                      borderBottom: "1px solid #f0f0f0",
                                    }}
                                  >
                                    <Col span={10}>Description</Col>
                                    <Col span={4} style={{ textAlign: "center" }}>
                                      Qty
                                    </Col>
                                    <Col span={5} style={{ textAlign: "right" }}>
                                      Unit Price
                                    </Col>
                                    <Col span={5} style={{ textAlign: "right" }}>
                                      Net Total
                                    </Col>
                                  </Row>

                                  {record.cart_items?.items?.map((item, index) => (
                                    <Row
                                      key={item.lineId || index}
                                      style={{
                                        padding: "0.75rem 0",
                                        borderBottom: index < record.cart_items.items.length - 1 ? "1px solid #f5f5f5" : "none",
                                        fontSize: "0.9rem",
                                      }}
                                    >
                                      <Col span={10}>
                                        <div>{item.value}</div>
                                        {item.name2 && <div style={{ fontSize: "0.8rem", color: "#929098", marginTop: "0.25rem" }}>{item.name2}</div>}
                                      </Col>
                                      <Col span={4} style={{ textAlign: "center" }}>
                                        {item.key + 1}
                                      </Col>
                                      <Col span={5} style={{ textAlign: "right" }}>
                                        {item.unitPrice?.toFixed(2)}
                                      </Col>
                                      <Col span={5} style={{ textAlign: "right", fontWeight: 500 }}>
                                        {item.linenet?.toFixed(2)}
                                      </Col>
                                    </Row>
                                  ))}
                                </div>

                                {/* Summary Section - View Only */}
                                <Row>
                                  <Col span={14}></Col>
                                  <Col span={10}>
                                    <div
                                      style={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        padding: "1rem",
                                      }}
                                    >
                                      <Row
                                        style={{
                                          marginBottom: "0.5rem",
                                          fontSize: "0.9rem",
                                        }}
                                      >
                                        <Col span={12}>Subtotal</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.subTotal?.toFixed(2)}
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          marginBottom: "0.75rem",
                                          fontSize: "0.9rem",
                                          paddingBottom: "0.75rem",
                                          borderBottom: "1px solid #f0f0f0",
                                        }}
                                      >
                                        <Col span={12}>Total tax</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.tax?.toFixed(2)}
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          fontWeight: 600,
                                          fontSize: "1rem",
                                        }}
                                      >
                                        <Col span={12}>SALE TOTAL</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {record.cart_items?.total?.toFixed(2)}
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </Spin>
                </TabPane>
              </Tabs>
            </Row>
          </div>
        ) : (
          <div
            style={{
              background: colorVariable ? colorVariable : "#f3f4f9",
              height: "100vh",
            }}
          >
            <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
              <Col span={6}>
                <img
                  src={Back}
                  id="sm-parked-bill-back"
                  onClick={() => {
                    setIsparkedBill(false);
                    setIsInputFocused(false);
                    setParkedBillSearchInput("");
                    setLayoutName("default");
                    setFilterdParkedList(parkedList);
                  }}
                  style={{
                    height: "3vw",
                    paddingBottom: "0.7em",
                    cursor: "pointer",
                  }}
                />
                <span
                  style={{
                    paddingRight: "1vw",
                    fontSize: "1.8em",
                    fontWeight: 500,
                    margin: "0.5em",
                    paddingTop: "0.5em",
                    color: "#0F0718",
                  }}
                >
                  Parked Bills
                </span>
              </Col>
              <Col
                span={18}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <Input
                  placeholder={`Search for customers`}
                  ref={parkedBillRef}
                  prefix={<img src={CustomerSearch} style={{ width: "1.5em" }} alt="" />}
                  allowClear={false}
                  style={{ width: "70%", borderRadius: "5px", border: "none" }}
                  onPressEnter={() => {
                    searchParkedBill(parkedBillSearchInput);
                  }}
                  onChange={(e) => {
                    onChangeParkedBill(e.target.value);
                    keyboard?.current?.setInput(e.target.value);
                  }}
                  id="sm-parked-bill-customer"
                  onFocus={() => {
                    setTimeout(() => {
                      setInputName("parkedBill");
                      setOpen(true);
                      keyboard?.current?.setInput(parkedBillSearchInput);
                    }, 300);
                  }}
                  onBlur={() => {
                    setIsInputFocused(false);
                  }}
                  value={parkedBillSearchInput}
                  className="parkedCustomer-sm"
                  width={700}
                />
              </Col>
            </Row>
            <br />
            <Row style={{ padding: "0 1em" }}>
              <Table
                style={{
                  width: "100%",
                  overflowY: "auto",
                  border: "none",
                  fontSize: "1vw",
                  borderRadius: "10px",
                  padding: "0 1em",
                  height: "83vh",
                  background: themeJSON.productTableBGColor || "#fff",
                  //   boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
                }}
                pagination={false}
                columns={columns}
                dataSource={filterdParkedList}
                // scroll={{ y: "53vh" }}
                rowClassName={(record) => (selectedKeys[0] === record.key ? "tableSelectedBlue" : "tableNonSelectedWhite")}
                className="sm-cart-table"
                expandable={{
                  expandedRowKeys,
                  onExpand: handleExpandPerkedData,
                  expandedRowRender: (record) => (
                    <div
                      style={{
                        padding: "1% 4% 1% 4%",
                        backgroundColor: "#f3f4f9",
                      }}
                    >
                      <Row>
                        <Col span={21}>
                          <Row>
                            <Col span={12} className="td-nested-title-sm">
                              Description
                            </Col>
                            <Col span={3} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                              Qty
                            </Col>
                            <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                              Unit Price
                            </Col>
                            <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "right" }}>
                              Net Total
                            </Col>
                          </Row>
                          <Row style={{ paddingBottom: "0.5vw", fontSize: "1vw" }}>
                            {record.parkedCart.items.map((e) => {
                              return (
                                <>
                                  {/* <Col span={12} className="td-nested-description-sm"> */}
                                  <Col span={12} className="td-nested-title-sm" style={{ fontSize: "1.2em" }}>
                                    {e.name}
                                  </Col>
                                  <Col
                                    span={3}
                                    style={{
                                      textAlign: "center",
                                      fontWeight: "400",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {e.weight}
                                  </Col>
                                  <Col span={1} style={{ textAlign: "center" }} />
                                  <Col
                                    span={3}
                                    style={{
                                      textAlign: "right",
                                      fontWeight: "400",
                                      paddingRight: "1vw",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {e.realPrice}
                                  </Col>
                                  <Col span={1} style={{ textAlign: "right" }} />
                                  <Col
                                    span={3}
                                    style={{
                                      textAlign: "right",
                                      marginLeft: "6vw",
                                      fontWeight: "400",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {e.nettotal.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)}
                                  </Col>
                                </>
                              );
                            })}
                          </Row>
                          <p
                            style={{
                              width: "96%",
                              marginLeft: "0%",
                              borderTop: "1.3px solid rgba(52, 40, 44, 0.55)",
                              marginBottom: "0px",
                            }}
                          />
                          <Row style={{ paddingTop: "5px" }}>
                            <Col span={3} offset={17} className="td-subtotal">
                              <span className="td-subTotalText">Subtotal</span>
                              <span className="td-subTotalText">Total tax</span>
                            </Col>
                            <Col span={3} className="td-subtotal" style={{ textAlign: "right" }}>
                              <span className="td-subTotalText">{(record.parkedCart.total - record.parkedCart.tax).toFixed(pricePrecision)}</span>
                              <span className="td-subTotalText">{record.parkedCart.tax.toFixed(pricePrecision)}</span>
                            </Col>
                          </Row>
                          <Row style={{ marginBottom: "1%" }}>
                            <Col span={3} offset={17} className="td-subtotal" style={{ padding: "4px 0" }}>
                              <span className="td-total">SALE TOTAL</span>
                            </Col>
                            <Col
                              span={3}
                              className="td-subtotal"
                              style={{
                                borderBottom: "1px solid rgba(52, 40, 44, 0.55)",
                                textAlign: "right",
                                paddingTop: "4px",
                              }}
                            >
                              <span className="td-total">{record.parkedCart.total}</span>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={3} className="td-bottons">
                          <p
                            style={{
                              cursor: "pointer",
                              padding: "5.5% 12%",
                              borderRadius: "3px",
                              border: "1px solid #fff",
                              background: "#fff",
                              fontSize: "1em",
                            }}
                            onClick={() => {
                              setTableValue("POS");
                              //setIsparkedBill(false);
                              retrieveParkedData(record); // this now includes sale type logic
                              upsertPOSLog(cart, "OPK", "Retrieved");
                            }}
                            id="sm-parked-bill-retrieve"
                          >
                            <img
                              src={Retrieve}
                              style={{
                                height: "1vw",
                                paddingRight: "0.4vw",
                                cursor: "pointer",
                              }}
                            />
                            Retrieve sale
                          </p>
                          <p
                            style={{
                              cursor: "pointer",
                              padding: "5.5% 13%",
                              borderRadius: "3px",
                              border: "1px solid #fff",
                              background: "#fff",
                              fontSize: "1em",
                            }}
                            onClick={() => {
                              setParkedBill(record);
                              discardMessage("Discard Sale", "Are you sure you want to discard the sale!", record);
                            }}
                            id="sm-parked-bill-discard"
                          >
                            <img src={Cancel} style={{ height: "1.1vw", paddingRight: "0.4vw" }} />
                            Discard sale
                          </p>
                        </Col>
                      </Row>
                    </div>
                  ),
                  expandIcon: ({ expanded, onExpand, record }) => (
                    <span id="sm-parked-bill-expand" onClick={(e) => onExpand(record, e)}>
                      {expanded ? <DownOutlined style={{ color: "#929098" }} /> : <RightOutlined style={{ color: "#929098" }} />}
                    </span>
                  ),
                }}
                onRow={(record) => ({
                  onClick: () => handleExpandPerkedData(record), // Handle row click to expand
                })}
                onExpand={handleExpandPerkedData}
              />
            </Row>
          </div>
        )
      ) : isEstimatesFlag ? (
        <div
          style={{
            background: colorVariable ? colorVariable : "#f3f4f9",
            height: "100vh",
          }}
        >
          {/* ================= HEADER ================= */}
          <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
            <Col span={6}>
              <img
                src={Back}
                onClick={() => {
                  setIsEstimatesFlag(false);
                  setExpandedEstimatesRowKey(null);
                  setActiveEstimatesTab("pending");
                  setSearchEstimatesInput("");
                  setEstimatesData([]);
                }}
                style={{
                  height: "3vw",
                  paddingBottom: "0.7em",
                  cursor: "pointer",
                }}
              />

              <span
                style={{
                  paddingRight: "1vw",
                  fontSize: "1.8em",
                  fontWeight: 500,
                  margin: "0.5em",
                  paddingTop: "0.5em",
                  color: "#0F0718",
                }}
              >
                Estimates
              </span>
            </Col>

            <Col
              span={18}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <Input
                placeholder="Search estimates"
                style={{ width: "70%", borderRadius: "5px", border: "none" }}
                onPressEnter={() => {
                  const status = getStatusForEstimatesTab(activeEstimatesTab);
                  fetchEstimates(status);
                }}
                onChange={(e) => setSearchEstimatesInput(e.target.value)}
                value={searchEstimatesInput}
              />
            </Col>
          </Row>
          {(() => {
            const getStatusConfig = (status) => {
              switch (status) {
                case "pending":
                  return {
                    code: "PE",
                    label: "Pending",
                    bg: "#fff4e6",
                    color: "#fa8c16",
                    empty: "No pending estimates found",
                  };
                case "processed":
                  return {
                    code: "CO",
                    label: "Completed",
                    bg: "#e6f7ff",
                    color: "#1890ff",
                    empty: "No processed estimates found",
                  };
                case "cancelled":
                  return {
                    code: "CL",
                    label: "Cancelled",
                    bg: "#fff1f0",
                    color: "#ff4d4f",
                    empty: "No cancelled estimates found",
                  };
                default:
                  return {};
              }
            };

            const renderEstimateList = (status) => {
              const config = getStatusConfig(status);

              return (
                <Spin spinning={loadingEstimates}>
                  {estimatesData?.length === 0 && !loadingEstimates ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "3rem",
                        background: "#fff",
                        borderRadius: "12px",
                        color: "#929098",
                      }}
                    >
                      {config.empty}
                    </div>
                  ) : (
                    <div>
                      {/* HEADER */}
                      <Row
                        style={{
                          background: "#fff",
                          padding: "1rem 1.5rem",
                          borderRadius: "12px 12px 0 0",
                          fontWeight: 600,
                          fontSize: "0.9rem",
                          color: "#5D5A66",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        <Col span={5}>Date</Col>
                        <Col span={5}>Document No</Col>
                        <Col span={6}>Customer</Col>
                        <Col span={3}>Qty</Col>
                        <Col span={5}>Status</Col>
                      </Row>

                      {estimatesData.map((record) => {
                        let parsedJson = {};
                        try {
                          parsedJson = JSON.parse(record.estimate_json || "{}");
                        } catch (err) {
                          parsedJson = {};
                        }
                        return (
                          <div key={record.key}>
                            {/* MAIN ROW */}
                            <Row
                              style={{
                                background: "#fff",
                                padding: "1rem 1.5rem",
                                borderBottom: "1px solid #f0f0f0",
                                cursor: "pointer",
                                alignItems: "center",
                              }}
                              onClick={() => setExpandedEstimatesRowKey(expandedEstimatesRowKey === record.key ? null : record.key)}
                            >
                              <Col span={5}>
                                {expandedEstimatesRowKey === record.key ? (
                                  <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                                ) : (
                                  <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                                )}{" "}
                                {moment(record.created).format("YYYY-MM-DD HH:mm:ss")}
                              </Col>

                              <Col span={5} style={{ fontWeight: 500 }}>
                                {record.documentno}
                              </Col>

                              <Col span={6}>{parsedJson?.customer?.name || "Walkin Customer"}</Col>
                              <Col span={3}>{parsedJson?.totalQty || 0}</Col>

                              <Col span={5}>
                                <span
                                  style={{
                                    padding: "0.25rem 0.75rem",
                                    borderRadius: "6px",
                                    background: config.bg,
                                    color: config.color,
                                    fontWeight: 500,
                                  }}
                                >
                                  {config.label}
                                </span>
                              </Col>
                            </Row>

                            {/* EXPANDED AREA */}
                            {expandedEstimatesRowKey === record.key && (
                              <div
                                style={{
                                  background: "#fafafa",
                                  padding: "1.5rem",
                                }}
                              >
                                {/* ITEMS */}
                                <div
                                  style={{
                                    background: "#fff",
                                    borderRadius: "8px",
                                    padding: "1rem",
                                  }}
                                >
                                  <Row
                                    style={{
                                      fontWeight: 600,
                                      borderBottom: "1px solid #f0f0f0",
                                      paddingBottom: "0.5rem",
                                    }}
                                  >
                                    <Col span={10}>Description</Col>
                                    <Col span={4} style={{ textAlign: "center" }}>
                                      Qty
                                    </Col>
                                    <Col span={5} style={{ textAlign: "right" }}>
                                      Unit Price
                                    </Col>
                                    <Col span={5} style={{ textAlign: "right" }}>
                                      Net Total
                                    </Col>
                                  </Row>

                                  {parsedJson?.items?.map((item, index) => (
                                    <Row
                                      key={index}
                                      style={{
                                        padding: "0.75rem 0",
                                        borderBottom: index < parsedJson?.items.length - 1 ? "1px solid #f5f5f5" : "none",
                                      }}
                                    >
                                      <Col span={10}>{item?.name}</Col>
                                      <Col span={4} style={{ textAlign: "center" }}>
                                        {item?.weight}
                                      </Col>
                                      <Col span={5} style={{ textAlign: "right" }}>
                                        {item?.realPrice}
                                      </Col>
                                      <Col span={5} style={{ textAlign: "right" }}>
                                        {item?.nettotal}
                                      </Col>
                                    </Row>
                                  ))}
                                </div>

                                {/* SUMMARY */}
                                <Row style={{ marginTop: "1.5rem" }}>
                                  <Col span={14}></Col>

                                  <Col span={10}>
                                    <div
                                      style={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        padding: "1rem",
                                      }}
                                    >
                                      <Row>
                                        <Col span={12}>Subtotal</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {parsedJson?.subTotal}
                                        </Col>
                                      </Row>

                                      {parsedJson?.discount > 0 && (
                                        <Row>
                                          <Col span={12} style={{ color: "#ff4d4f" }}>
                                            Discount
                                          </Col>
                                          <Col
                                            span={12}
                                            style={{
                                              textAlign: "right",
                                              color: "#ff4d4f",
                                            }}
                                          >
                                            - {parsedJson?.discount?.toFixed(2)}
                                          </Col>
                                        </Row>
                                      )}

                                      <Row>
                                        <Col span={12}>Tax</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {parsedJson?.tax?.toFixed(2)}
                                        </Col>
                                      </Row>

                                      <Row
                                        style={{
                                          fontWeight: 600,
                                          marginTop: "0.5rem",
                                          borderTop: "1px solid #f0f0f0",
                                          paddingTop: "0.5rem",
                                        }}
                                      >
                                        <Col span={12}>TOTAL</Col>
                                        <Col span={12} style={{ textAlign: "right" }}>
                                          {parsedJson?.total?.toFixed(2)}
                                        </Col>
                                      </Row>
                                    </div>

                                    {/* RETURN SALE BUTTON ONLY FOR PENDING */}
                                    {status === "pending" && (
                                      <button
                                        onClick={() => handleRetrieveEstimate(record)}
                                        style={{
                                          width: "100%",
                                          marginTop: "1rem",
                                          padding: "0.75rem",
                                          background: "#1890ff",
                                          color: "#fff",
                                          border: "none",
                                          borderRadius: "8px",
                                          fontWeight: 500,
                                          cursor: "pointer",
                                        }}
                                      >
                                        Retrieve sale
                                      </button>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </Spin>
              );
            };

            return (
              <Row style={{ padding: "1em 1.5em" }}>
                <Tabs
                  activeKey={activeEstimatesTab}
                  onChange={(key) => {
                    setActiveEstimatesTab(key);
                    setExpandedEstimatesRowKey(null);
                    const status = getStatusForEstimatesTab(key);
                    fetchEstimates(status);
                  }}
                  style={{ width: "100%" }}
                >
                  <TabPane tab="Pending" key="pending">
                    {renderEstimateList("pending")}
                  </TabPane>

                  <TabPane tab="Processed" key="processed">
                    {renderEstimateList("processed")}
                  </TabPane>

                  <TabPane tab="Cancelled" key="cancelled">
                    {renderEstimateList("cancelled")}
                  </TabPane>
                </Tabs>
              </Row>
            );
          })()}
        </div>
      ) : isCashMangement ? (
        <div
          style={{
            background: colorVariable ? colorVariable : "#f3f4f9",
            height: "100vh",
            fontSize: "1vw",
          }}
        >
          <Row style={{ padding: "1.5em 1.5em 0 1.5em" }}>
            <Col span={6}>
              <img
                src={Back}
                id="sm-cash-management-back"
                onClick={() => {
                  setIsCashManagement(false);
                }}
                style={{
                  height: "3.1vw",
                  paddingBottom: "0.7em",
                  cursor: "pointer",
                }}
              />
              <span
                style={{
                  paddingRight: "1vw",
                  color: "#0F0718",
                  fontSize: "1.8em",
                  fontWeight: 500,
                  marginLeft: "0.5em",
                }}
              >
                {/* <img src={DownloadIcon} style={{ height: "1.3vw", paddingRight: "4px" }} /> */}
                Cash Management
              </span>
            </Col>
            <Col
              span={18}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {posConfig?.enableRemoveCash === "Y" && (
                <Button
                  style={{
                    width: "10.3vw",
                    height: "5.5vh",
                    // border: "1px solid #0F0718",
                    borderRadius: "4px",
                    fontWeight: "500",
                    marginRight: "1.4vw",
                    fontSize: "1em",
                    color: "#fff",
                    background: "#2F3856",
                  }}
                  id="sm-cash-management-remove"
                  onClick={() => {
                    setAddCashFlag(true);
                    setCashAddInFlag(true);
                  }}
                >
                  Remove Cash
                </Button>
              )}
              {posConfig?.enableAddCash === "Y" && (
                <Button
                  id="sm-cash-management-add"
                  style={{
                    width: "10.3vw",
                    height: "5.5vh",
                    borderRadius: "4px",
                    fontWeight: "500",
                    fontSize: "1em",
                    color: "#fff",
                    background: "#2F3856",
                  }}
                  onClick={() => {
                    setAddCashFlag(true);
                    setCashAddInFlag(false);
                  }}
                >
                  Add Cash
                </Button>
              )}
            </Col>
          </Row>
          <br />
          <Row style={{ padding: "0 1.5em" }}>
            <Table
              style={{
                width: "100%",
                overflowY: "auto",
                border: "none",
                fontSize: "1.5vw",
                borderRadius: "10px",
                padding: "0 1em",
                height: "83vh",
                background: themeJSON.productTableBGColor || "#fff",
                // boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
              }}
              pagination={false}
              columns={cashManagementColumn}
              className="sm-cashmanagement-table"
              // className="sm-cart-table"
              dataSource={cashManagementData}
            />
          </Row>
          <RetailModals
            {...props}
            selectBagRef={selectBagRef}
            offersDrawerOpen={offersDrawerOpen}
            setOffersDrawerOpen={setOffersDrawerOpen}
            setOnlineBatches={setOnlineBatches}
            onlineBatches={onlineBatches}
            fetchOnlineBatches={fetchOnlineBatches}
          />
        </div>
      ) : isQuotation ? (
        <QuotationComponent
          formattedDateTime={formattedDateTime}
          setShowProductionOrder={setShowProductionOrder}
          removeProductModal={removeProductModal}
          deleteProductModal={deleteProductModal}
          setTillLink={setTillLink}
          setIsQuotation={setIsQuotation}
          onChangeInput={onChangeInput}
          setOpen={setOpen}
          productSearchInputRef={productSearchInputRef}
          {...props}
        />
      ) : isPurchaseReturn ? (
        <div
          style={{
            background: colorVariable ? colorVariable : "#f3f4f9",
            height: "100vh",
          }}
        >
          {!showReturnPurchase ? (
            <>
              <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
                <Col span={6}>
                  <img
                    src={Back}
                    id="sm-salesHistory-back"
                    onClick={() => {
                      setIsPurchaseReturn(false);
                      setStartRowData({ startRow: "0", endRow: "10" });
                      setOrderHistoryDetails([]);
                      setExpandedRowKeys([]);
                      setDateRange([]);
                      setFiltersFlag(false);
                      setIsInputFocused(false);
                      setSearchhistoryInput("");
                      setLayoutName("default");
                    }}
                    style={{
                      height: "3vw",
                      paddingBottom: "0.7em",
                      cursor: "pointer",
                    }}
                  />
                  <span
                    style={{
                      paddingRight: "1vw",
                      color: "#0F0718",
                      fontSize: "1.8em",
                      fontWeight: 500,
                      marginLeft: "0.5em",
                    }}
                  >
                    {/* <img src={DownloadIcon} style={{ height: "1.3vw", paddingRight: "4px" }} /> */}
                    Sales History
                  </span>
                </Col>
                <Col
                  span={8}
                  offset={2}
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Input
                    ref={searchCustomersRef}
                    placeholder="Search for Customers/Document Number/Contact"
                    prefix={<img src={CustomerSearch} style={{ width: "1.4em" }} alt="" />}
                    allowClear={false}
                    onPressEnter={(e) => {
                      if (e.target.value !== "") {
                        searchOrderHistory("customer", e.target.value, 0, dateRange?.length > 0 ? true : false);
                      }
                    }}
                    onBlur={() => {
                      setIsInputFocused(false);
                    }}
                    value={searchHistoryInput}
                    id="sm-salesHistory-customer"
                    onFocus={() => {
                      setOpen(true);
                      setIsInputFocused(true);
                      setInputName("salesHistoryInput");
                      keyboard?.current?.setInput(searchHistoryInput);
                    }}
                    className="salesHistory-input-sm"
                    onChange={async (e) => {
                      let inputVal = e.target.value;
                      setSearchhistoryInput(inputVal);
                      keyboard?.current?.setInput(inputVal);
                      if (inputVal === "" && dateRange?.length === 0) {
                        setOrderHistoryDetails([]);
                      } else if (e.target.value === "" && dateRange?.length !== 0) {
                        await setSearchhistoryInput("");
                        searchOrderHistory("orderDateSearchKey", dateRange, 0, false);
                      }
                    }}
                  />
                </Col>

                <Col
                  span={8}
                  style={{
                    paddingRight: "",
                    paddingLeft: "1.5vw",
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Popover content={content} trigger="click" visible={isPopoverVisible} onVisibleChange={(visible) => setPopoverVisible(visible)}>
                    <Button
                      icon={<CalendarOutlined />}
                      style={{
                        border: "none",
                        width: "27vw",
                        display: "flex",
                        alignItems: "center",
                        color: "#929098",
                        fontWeight: 400,
                        fontSize: "1em",
                        fontFamily: "Inter",
                      }}
                      onClick={handleButtonClick}
                      ref={dateRef}
                    >
                      {getDisplayDate()}
                    </Button>
                  </Popover>

                  {filtersFlag ? (
                    <Button
                      onClick={() => {
                        setOrderHistoryDetails(ordersCopy);
                        setFiltersFlag(false);
                        setDateRange([]);
                        setSearchhistoryInput("");
                        setDateRange(null);
                        setTimeout(() => {
                          setInputName("salesHistoryInput");
                          setOpen(false);
                          keyboard?.current?.setInput("");
                        }, 300);
                      }}
                      style={{ border: "none", padding: "4px 10px" }}
                    >
                      <img src={clearFilters} alt="clear" />
                    </Button>
                  ) : null}
                </Col>
              </Row>
              <br />
              <Row style={{ padding: "0 1.5em" }}>
                <Table
                  className="sm-cart-table"
                  ref={tableBodyRef}
                  style={{
                    width: "100%",
                    overflowY: "auto",
                    border: "none",
                    fontSize: "1.5vw",
                    borderRadius: "7px",
                    height: "84vh",
                    padding: "0 1em",
                    background: themeJSON.productTableBGColor || "#fff",
                    boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
                  }}
                  onRow={(record) => ({
                    onClick: () => handleExpand(record), // Handle row click to expand
                  })}
                  pagination={false}
                  columns={orderHistoryColumns}
                  dataSource={orderHistoryDetails}
                  rowClassName={(record) => (selectedKeys[0] === record.key ? "tableSelectedBlue" : "tableNonSelectedWhite")}
                  onExpand={handleExpand}
                  expandable={{
                    expandedRowKeys,
                    onExpand: handleExpand,
                    expandedRowRender: (record) => (
                      <div
                        style={{
                          padding: "1% 4% 1% 4%",
                          backgroundColor: "#f3f4f9",
                        }}
                      >
                        <Row>
                          <Col span={21}>
                            <Row>
                              <Col span={12} className="td-nested-title-sm">
                                Description
                              </Col>
                              <Col span={3} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                                Qty
                              </Col>
                              <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                                Unit Price
                              </Col>
                              <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "right" }}>
                                Net Total
                              </Col>
                            </Row>
                            <Row style={{ paddingBottom: "0.5vw" }}>
                              {record.items.map((e) => {
                                return (
                                  <>
                                    <Col span={12} className="td-nested-description">
                                      {e.name}
                                    </Col>
                                    <Col
                                      span={3}
                                      style={{
                                        textAlign: "center",
                                        fontWeight: "400",
                                      }}
                                    >
                                      {e.weight}
                                    </Col>
                                    <Col
                                      span={1}
                                      style={{
                                        textAlign: "center",
                                        fontWeight: "400",
                                      }}
                                    />
                                    <Col
                                      span={3}
                                      style={{
                                        textAlign: "right",
                                        fontWeight: "400",
                                      }}
                                    >
                                      {e && typeof e.salePrice === "number" && e.salePrice.toFixed(pricePrecision)}
                                    </Col>
                                    <Col span={2} style={{ textAlign: "center" }} />
                                    <Col
                                      span={3}
                                      style={{
                                        textAlign: "right",
                                        fontWeight: "400",
                                      }}
                                    >
                                      {e.nettotal.toFixed(pricePrecision)}
                                    </Col>
                                  </>
                                );
                              })}
                            </Row>
                            <p
                              style={{
                                width: "96%",
                                marginLeft: "0%",
                                borderTop: "1.3px solid rgba(52, 40, 44, 0.55)",
                                marginBottom: "0px",
                              }}
                            />
                            <Row style={{ paddingTop: "5px" }}>
                              <Col span={14}>
                                {record?.paymentData?.length > 0 && (
                                  <Row>
                                    <Col span={8} style={{ textAlign: "left" }}>
                                      <p style={{ margin: "0", fontWeight: "500", textAlign: "left" }}>Payment method</p>
                                    </Col>
                                    <Col span={5}>
                                      <p style={{ margin: "0", fontWeight: "500", textAlign: "left" }}>Amount</p>
                                    </Col>
                                    <Col span={8}>
                                      <p style={{ margin: "0", fontWeight: "500", textAlign: "left" }}>Advance Payment</p>
                                    </Col>
                                  </Row>
                                )}

                                {record?.paymentData?.map((ele, ind) => (
                                  <Row>
                                    <Col span={8} style={{ textAlign: "left" }}>
                                      {ele.name}
                                    </Col>
                                    <Col span={5}>{ele.amount}</Col>
                                    {ind === 0 && <Col span={5}>{record.advancePayment > 0 && record.layAway === "Y" ? record.advancePayment : 0}</Col>}
                                  </Row>
                                ))}
                              </Col>
                              <Col span={3} offset={3} className="td-subtotal">
                                <span className="td-subTotalText">Subtotal</span>
                                <span className="td-subTotalText">Total tax</span>
                              </Col>
                              <Col span={3} className="td-subtotal" style={{ textAlign: "right" }}>
                                <span className="td-subTotalText">{(record.total - record.tax).toFixed(pricePrecision)}</span>
                                <span className="td-subTotalText">{record.tax.toFixed(pricePrecision)}</span>
                              </Col>
                            </Row>
                            <Row style={{ marginBottom: "1%" }}>
                              <Col span={3} offset={17} className="td-subtotal" style={{ padding: "4px 0" }}>
                                <span className="td-total">SALE TOTAL</span>
                              </Col>
                              <Col
                                span={3}
                                style={{
                                  fontSize: "1em",
                                  borderBottom: "1px solid rgba(52, 40, 44, 0.55)",
                                  textAlign: "right",
                                  paddingTop: "4px",
                                }}
                              >
                                <span className="td-total">{parseFloat(record.total).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)}</span>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={3} className="td-bottons" style={{ fontSize: "1vw" }}>
                            {isReturn ? (
                              reconstructedObject?.ReturnPrint === "N" ? null : (
                                <p
                                  id="sm-salesHistory-printer"
                                  style={{
                                    cursor: "pointer",
                                    padding: "5.5% 12%",
                                    borderRadius: "5px",
                                    border: "1px solid #fff",
                                    backgroundColor: "#fff",
                                    fontSize: "1em",
                                    fontWeight: 500,
                                    color: "#0F0718",
                                  }}
                                  onClick={() => handleReceiptReprint(record)}
                                >
                                  <img
                                    src={printerIcon}
                                    style={{
                                      height: "1.4vw",
                                      paddingRight: "0.4vw",
                                      cursor: "pointer",
                                    }}
                                  />
                                  Print receipt
                                </p>
                              )
                            ) : reconstructedObject?.Reprint === "N" || record.total === 0 || record.total === "0.00" ? null : (
                              <p
                                id="sm-salesHistory-printer"
                                style={{
                                  cursor: "pointer",
                                  padding: "5.5% 12%",
                                  borderRadius: "5px",
                                  border: "1px solid #fff",
                                  backgroundColor: "#fff",
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                }}
                                onClick={() => handleReceiptReprint(record, { orderCompleted: true })}
                              >
                                <img
                                  src={printerIcon}
                                  style={{
                                    height: "1.4vw",
                                    paddingRight: "0.4vw",
                                    cursor: "pointer",
                                  }}
                                />
                                Print receipt
                              </p>
                            )}
                            {parseFloat(record.total) > 0 && posConfig?.showSalesReturn === "Y" && record.layAway === "N" && record.paid !== 0 ? (
                              <p
                                style={{
                                  cursor: "pointer",
                                  padding: "5.5% 13%",
                                  borderRadius: "5px",
                                  border: "1px solid #fff",
                                  backgroundColor: "#fff",
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                }}
                                id="sm-sales-return"
                                onClick={() => {
                                  const isAlreadyParked = filterdParkedList.some((item) => item.parkedOrderID === record.sOrderID);
                                  if (isAlreadyParked) {
                                    Modal.error({
                                      title: "This return order is already parked. Please access it from the bill parking area to continue.",
                                    });
                                  } else {
                                    prevHistoryRef.current = orderHistoryDetails;
                                    setCheckedKeys([]);
                                    searchReturnHistory(record.documentno, record);
                                    setOrderHistoryDetails([]);
                                    localStorage.setItem("salesReturn", "Y");
                                  }
                                }}
                              >
                                <img
                                  src={Discard}
                                  style={{
                                    height: "1.1vw",
                                    paddingRight: "0.4vw",
                                  }}
                                />
                                Sales Return
                              </p>
                            ) : record.layAway === "Y" && posConfig?.enablePreOrder !== "Y" ? (
                              <p
                                style={{
                                  cursor: "pointer",
                                  padding: "5.5% 13%",
                                  borderRadius: "5px",
                                  border: "1px solid #fff",
                                  backgroundColor: "#fff",
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                }}
                                id="sm-sales-return"
                                onClick={async () => {
                                  const storedParkedList = JSON.parse(localStorage.getItem("parkedList"));
                                  const isDocnoInList = storedParkedList?.some((item) => item.parkedDocNo === record.documentno);
                                  if (isDocnoInList) {
                                    Modal.info({
                                      title: "This layaway order is already parked. Please access it from the bill parking area to continue.",
                                      icon: null,
                                      cancelText: "No",
                                      okText: "Okay",
                                      autoFocusButton: null,
                                      okButtonProps: { style: { display: "inline-block" } },
                                    });
                                  } else {
                                    setIsPurchaseReturn(false);
                                    const advanceItem = record.items.find(
                                      (item) =>
                                        item.type === "S" &&
                                        item.weight > 0 &&
                                        posConfig?.AllowServiceItemsinAdvanceOrderCompletion === "N" &&
                                        !posConfig?.AllowServiceItemsinAdvanceOrderCompletion
                                    );
                                    record.docType = "Advance";
                                    retrieveLayaway(record);
                                    setSelectedDocumentType("Advance");
                                    setOrderHistoryDetails([]);
                                    const saleData = await db.posSaletypes.toArray();
                                    saleData.map((item) => {
                                      if (item.cwrSaletype.cwrSaletypeId === record.saleType.cwrSaletypeId) {
                                        setSelectedSaleTypeData(item);
                                        localStorage.setItem("saleTypeData", JSON.stringify(item));
                                        setSelectedSaleType(item?.cwrSaletype?.name);
                                      }
                                    });
                                    let paymentDetails = getFilteredPaymentMethods(record?.saleType?.cwrSaletypeId || null);
                                    if (
                                      !advanceItem &&
                                      posConfig?.allowLayawaywithoutPayment !== "Y" &&
                                      !record.items.some((item) => item.type === "S" && item?.productSegment === "AD" && item.weight > 0)
                                    ) {
                                      paymentDetails = [
                                        ...paymentDetails,
                                        ...(posConfig?.enablePreOrder !== "Y"
                                          ? [
                                              {
                                                cWRPaymentMethodID: "",
                                                sequenceNo: 9999,
                                                finPaymentmethodId: "",
                                                finFinancialAccountId: "",
                                                finDayCloseAccountId: null,
                                                name: "Complete Order",
                                                integratedPayment: false,
                                                isloyalty: false,
                                                paymentProvider: null,
                                                iscredit: false,
                                                isGiftCard: false,
                                                isDefault: "N",
                                                csCurrencyId: "",
                                                isoCode: "AED",
                                                isactive: true,
                                                salesType: [],
                                              },
                                            ]
                                          : []),
                                      ];
                                    }
                                    let payments =
                                      paymentDetails.length > 5
                                        ? _.sortBy(paymentDetails, "sequenceNo").slice(
                                            0,
                                            tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === record?.customer?.cwrCustomerId && paymentDetails.length === 5 ? 4 : 4
                                          )
                                        : paymentDetails;
                                    setStartIndex(payments.length);
                                    setShowPayments(payments);
                                  }
                                }}
                              >
                                <img
                                  src={layAwayIcon}
                                  style={{
                                    height: "1vw",
                                    paddingRight: "0.4vw",
                                  }}
                                />
                                Retrieve Sale
                              </p>
                            ) : record.creditSale === "Y" ? (
                              <p
                                style={{
                                  cursor: "pointer",
                                  padding: "5.5% 13%",
                                  borderRadius: "5px",
                                  border: "1px solid #fff",
                                  backgroundColor: "#fff",
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                }}
                                id="sm-sales-return"
                                onClick={async () => {
                                  const storedParkedList = JSON.parse(localStorage.getItem("parkedList"));
                                  const isDocnoInList = storedParkedList?.some((item) => item.parkedDocNo === record.documentno);
                                  if (isDocnoInList) {
                                    Modal.info({
                                      title: "This order is already parked. Please access it from the bill parking area to continue.",
                                      icon: null,
                                      cancelText: "No",
                                      okText: "Okay",
                                      autoFocusButton: null,
                                      okButtonProps: { style: { display: "inline-block" } },
                                    });
                                  } else {
                                    setIsPurchaseReturn(false);
                                    record.isCreditSale = "Y";
                                    const advanceItem = record.items.find(
                                      (item) =>
                                        item.type === "S" &&
                                        item.weight > 0 &&
                                        posConfig?.AllowServiceItemsinAdvanceOrderCompletion === "N" &&
                                        !posConfig?.AllowServiceItemsinAdvanceOrderCompletion
                                    );
                                    retrieveLayaway(record);
                                    // setSelectedDocumentType("Advance");
                                    setOrderHistoryDetails([]);
                                    const saleData = await db.posSaletypes.toArray();
                                    saleData.map((item) => {
                                      if (item.cwrSaletype.cwrSaletypeId === record.saleType.cwrSaletypeId) {
                                        setSelectedSaleTypeData(item);
                                        localStorage.setItem("saleTypeData", JSON.stringify(item));
                                        setSelectedSaleType(item?.cwrSaletype?.name);
                                      }
                                    });
                                    let paymentDetails = getFilteredPaymentMethods(record?.saleType?.cwrSaletypeId || null);
                                    let payments =
                                      paymentDetails.length > 5
                                        ? _.sortBy(paymentDetails, "sequenceNo").slice(
                                            0,
                                            tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === record?.customer?.cwrCustomerId && paymentDetails.length === 5 ? 4 : 4
                                          )
                                        : paymentDetails;
                                    setStartIndex(payments.length);
                                    setShowPayments(payments);
                                  }
                                }}
                              >
                                <img
                                  src={layAwayIcon}
                                  style={{
                                    height: "1vw",
                                    paddingRight: "0.4vw",
                                  }}
                                />
                                Retrieve Credit Sale
                              </p>
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                    ),
                    rowExpandable: (record) => record.name !== "Not Expandable",
                    expandIcon: ({ expanded, onExpand, record }) => (
                      <span id="sm-salesHistory-expand" onClick={(e) => onExpand(record, e)}>
                        {expanded ? <DownOutlined style={{ color: "#929098" }} /> : <RightOutlined style={{ color: "#929098" }} />}
                      </span>
                    ),
                  }}
                />
              </Row>
            </>
          ) : (
            <>
              <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
                <Col span={6}>
                  <img
                    src={Back}
                    id="sm-salesReturn"
                    onClick={() => {
                      setOrderHistoryDetails(ordersCopy);
                      setShowReturnPurchase(!showReturnPurchase);
                      setSearchhistoryInput("");
                      setDateRange("");
                      setFiltersFlag(false);
                    }}
                    // style={{ height: "3.5vw", paddingBottom: "0.5em", cursor: "pointer" }}
                    style={{
                      height: "3vw",
                      paddingBottom: "0.7em",
                      cursor: "pointer",
                    }}
                  />
                  <span
                    style={{
                      paddingRight: "1vw",
                      color: "",
                      fontSize: "1.8em",
                      fontWeight: 500,
                      marginLeft: "0.5em",
                      color: "#0F0718",
                    }}
                  >
                    {/* <img src={DownloadIcon} style={{ height: "1.3vw", paddingRight: "4px" }} /> */}
                    Return Purchase
                  </span>
                </Col>
              </Row>
              <br />
              <Row style={{ padding: "0 1.5em 1.5em 1.5em", fontSize: "1vw" }}>
                <Col span={6} style={styles.screenStyles.returnPurchase.docNo}>
                  Document No: {selectedReturnOrder.documentno}
                </Col>
                <Col span={6} style={styles.screenStyles.returnPurchase.docNo}>
                  Date : {selectedReturnOrder.dateordered}
                </Col>
                <Col span={6} style={styles.screenStyles.returnPurchase.docNo}>
                  Total : {selectedReturnOrder.grosstotal}
                </Col>
                <Col span={6} style={styles.screenStyles.returnPurchase.docNo}>
                  Discount : {parseFloat(selectedReturnOrder.discAmount).toFixed(pricePrecision)}
                </Col>
              </Row>
              <Row style={{ padding: "0 1.5em", fontSize: "1vw" }}>
                <Table
                  className="sm-cart-table-return"
                  style={{
                    width: "100%",
                    overflowY: "auto",
                    border: "none",
                    fontSize: "1.1vw",
                    borderRadius: "7px",
                    height: "43vh",
                    padding: "0 1em",
                    background: themeJSON.productTableBGColor || "#fff",
                    boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
                  }}
                  pagination={false}
                  dataSource={dataSource}
                  components={{
                    body: {
                      row: EditableRow,
                      cell: EditableCell,
                    },
                  }}
                  setModalEditState={setModalEditState}
                  setIsInputFocused={setIsInputFocused}
                  columns={columns1.map((col) => ({
                    ...col,
                    onCell: (record) => ({
                      record,
                      editable: col.dataIndex === "qtyToReturn" && record.product.returnable,
                      dataIndex: col.dataIndex,
                      title: col.title,
                      handleSave: handleSave,
                      setModalEditState: setModalEditState,
                      setIsInputFocused: setIsInputFocused,
                    }),
                  }))}
                />
              </Row>
              <Row style={{ paddingTop: "2vh" }}>
                <Col span={9}></Col>
                <Col span={4} />
                <Col span={11}>
                  <Row style={{ fontSize: "1vw" }}>
                    <Col span={11} offset={1}>
                      <p style={styles.screenStyles.returnPurchase.returnItems}>Return Items / Qty: </p>
                      <p style={styles.screenStyles.returnPurchase.returnAmount}>Return Amount Total:</p>
                    </Col>
                    <Col span={11} style={{ textAlign: "right" }}>
                      <p style={styles.screenStyles.returnPurchase.returnItems}>
                        {" "}
                        {selectedReturnOrder.itemsToReturn ? selectedReturnOrder.itemsToReturn : "0"} /{" "}
                        {selectedReturnOrder.itemsQtyToReturn ? parseFloat(selectedReturnOrder.itemsQtyToReturn).toFixed(2) : "0.00"}
                      </p>
                      <p style={styles.screenStyles.returnPurchase.returnAmount}>
                        {" "}
                        {selectedReturnOrder.returnAmountTotal ? parseFloat(selectedReturnOrder.returnAmountTotal).toFixed(pricePrecision) : "0.00"}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10vh", fontSize: "1vw" }}>
                    <Col span={8} />
                    <Col span={8}>
                      <Button
                        style={{
                          width: "85%",
                          height: "5.5vh",
                          fontSize: "1.2em",
                          fontWeight: "500",
                          borderColor: "#fff",
                          color: "#0F0718",
                          borderRadius: "7px",
                          border: "1px solid rgba(146, 144, 152, 0.5)",
                          marginLeft: "2.5vw",
                        }}
                        onClick={() => {
                          // setOrderHistoryDetails(ordersCopy);
                          setShowReturnPurchase(!showReturnPurchase);
                          // setIsPurchaseReturn(false);
                          setOrderHistoryDetails(prevHistoryRef.current);
                          // setShowReturnPurchase(false);
                        }}
                        disabled={loader}
                      >
                        Cancel
                      </Button>
                    </Col>
                    <Col span={1} />
                    <Col span={8}>
                      <Button
                        style={{
                          width: "85%",
                          height: "5.5vh",
                          fontSize: "1.2em",
                          fontWeight: "500",
                          backgroundColor: "#2F3856",
                          color: "#fff",
                          borderRadius: "7px",
                          // borderColor: "#0F0718",
                          marginLeft: "1vw",
                        }}
                        ref={returnProcessRef}
                        onClick={(e) => {
                          const filteredKeys = checkedKeys.filter((key) => key !== null && key !== undefined);
                          if (filteredKeys.length > 0) {
                            if (posConfig?.allowReturnRefund === "Y" || posConfig?.allowReturnCreditNote === "Y" || posConfig?.allowReturnExchange === "Y") {
                              setShowReturnOptions(true);
                            } else {
                              setLoading(true);
                              setIsPurchaseReturn(false);
                              setStartRowData({ startRow: "0", endRow: "10" });
                              setIsInputFocused(true);
                              addSelectedReturnProductsToCart(e);
                            }
                          }
                        }}
                        className="focusDashboardCard"
                      >
                        Return
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}
        </div>
      ) : !syncLoad ? (
        <>
          <div style={mainDivStyles}>
            <Row
              style={{
                padding: "0.8% 0",
                height: "9vh",
                alignItems: "center",
                fontSize: "1vw",
              }}
            >
              <Col
                onClick={() => {
                  setTillLink(true);
                  setProductSearchInput("");
                }}
                style={{ cursor: "pointer" }}
                span={1}
              >
                <img src={sideMenu} style={{ paddingLeft: "1rem", height: "2vw" }} />
              </Col>
              <Col span={5}>
                <img src={themeJSON.logoURL || POSLogo} style={{ height: "2.5vw", paddingLeft: "0.4vw" }} />
              </Col>
              <Col
                span={2}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {showSaleType === true ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#0F0718",
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "13px",
                      paddingLeft: "1vw",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (cart.layAway !== "Y") {
                        setProductSearchInput("");
                        setIsSaleTypeFlag(true);
                      }
                    }}
                  >
                    {selectedSaleType}
                  </span>
                ) : (
                  ""
                )}
              </Col>
              {selectedRevenueCategoryName ? (
                <Col
                  span={4}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#0F0718",
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "13px",
                      paddingLeft: "1vw",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (cart.layAway !== "Y") {
                        setProductSearchInput("");
                        setIsRevenueCategoryFlag(true);
                      }
                    }}
                  >
                    {selectedRevenueCategoryName}
                  </span>
                </Col>
              ) : (
                <Col span={4}></Col>
              )}
              <Col span={1} />
              <Col
                span={5}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1em",
                    color: themeJSON.dateTimeTextColor || "#929098",
                    marginLeft: "7vw",
                  }}
                >
                  {" "}
                  {formattedDateTime}
                </span>
              </Col>
              <Col
                span={2}
                style={{
                  textAlign: "center",
                  color: themeJSON.orderNoTextColor || "#0F0718",
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "1.1em",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => {
                  // let filtredDocument = documentTypes?.filter((element) => element.type !== selectedDocumentType && element.isVisible);
                  // if (cart?.docType !== "Advance" && filtredDocument.length > 0) {
                  //   setShowDocumentPopup(true);
                  // }
                }}
              >
                {posConfig?.enableProductGrouping === "Y" && (
                  <CodeSandboxOutlined
                    style={{ fontSize: "18px", cursor: "pointer" }}
                    onClick={() => {
                      if (cart?.preOrder === "Y") {
                        Modal.confirm({
                          title: <div style={{ fontWeight: "500", fontSize: "1.2em", color: "#0F0718" }}>Cart Editing Restricted</div>,
                          content: (
                            <div style={{ fontSize: "14px", color: "#0F0718", marginTop: "8px" }}>
                              <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em" }}>
                                This is a pre-order with advance payment. Cart items cannot be modified at this stage. Please proceed to complete the transaction.
                              </p>
                            </div>
                          ),
                          icon: null,
                          icon: <WarningOutlined />,
                          okText: "Ok",
                          okButtonProps: { style: { display: "inline-block" } },
                          cancelButtonProps: { style: { display: "none" } },
                          // autoFocusButton: null,
                          modalRender: (node) => <div className="custom-confirm-modal-wrapper">{node}</div>,

                          onOk() {
                            const productSearchInput = document.getElementById("sm-product-search");
                            if (productSearchInput) {
                              setTimeout(() => {
                                productSearchInput.focus();
                              }, 300);
                            }
                          },
                        });

                        return;
                      }
                      setShowCustomMix(true);
                      localStorage.setItem("customMix", "CM");
                      setProductSearchInput("");
                      // localStorage.setItem("productSegment", "CB");
                    }}
                  />
                  // <img
                  //   src={GroupItemImg}
                  //   style={{ height: "6.5vh", width: "4vw", cursor: "pointer" }}
                  //   onClick={() => {
                  //     setShowCustomMix(true);
                  //     localStorage.setItem("customMix", "CM");
                  //     // localStorage.setItem("productSegment", "CB");
                  //   }}
                  // />
                )}
              </Col>
              {/* <Col
                span={4}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  paddingleft: "2vw",
                }}
              > */}
              {/* <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: themeJSON.orderNoTextColor || "#0F0718",
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1em",
                    paddingLeft: "1vw",
                  }}
                >
                  Order No:{cart?.documentno}
                </span> */}

              {/* <EditOutlined onClick={()=>{setNotesPopup(true); setIsInputFocused(true)}} style={{lineHeight:"3.5vh",fontSize:"1.5vw",cursor:"pointer"}}/> */}
              {/* </Col> */}
              <Col
                span={5}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  // paddingRight: "1%",
                }}
              >
                {/* <img
                  src={NotesImage}
                  onClick={() => {
                    setNotesPopup(true);
                    if (cart.description && cart.description.trim() !== "") {
                      setNotesValue(cart.description);
                    }
                    setIsInputFocused(true);
                  }}
                  style={{
                    fontSize: "1.5vw",
                    cursor: "pointer",
                    height: "2.4vh",
                    marginRight: "0.7rem",
                  }}
                  alt=""
                /> */}

                <img
                  onClick={() => {
                    if (isOnline) {
                      setIsLocked(true);
                    } else {
                      errorMessage("Sync Failed", "Please check your network connection and try again");
                    }
                  }}
                  src={LockIcon}
                  style={{ height: "3vh", cursor: "pointer", marginRight: "0.7rem" }}
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "center",
                    padding: "0.5vw",
                    border: "1px solid #3C424B",
                    borderRadius: "50%",
                  }}
                >
                  <img src={userIcon} style={{ height: "2.7vh" }} />
                </div>
                <div
                  style={{
                    marginLeft: "1vw",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span
                    style={{
                      color: themeJSON.orderNoTextColor || "#0F0718",
                      fontSize: "1em",
                      fontFamily: "Inter",
                      fontWeight: "500",
                      wordWrap: "break-word",
                    }}
                  >
                    {userData.user}
                  </span>
                  <span
                    style={{
                      color: themeJSON.orderNoTextColor || "#0F0718",
                      fontSize: "0.8em",
                      fontFamily: "Inter",
                      fontWeight: "500",
                      wordWrap: "break-word",
                    }}
                  >
                    Till ID : {JSON.parse(localStorage.getItem("tillValue"))?.name}
                  </span>
                </div>
                <div style={{ marginLeft: "3%" }}>
                  <img
                    src={Online}
                    style={{
                      display: !isOnline && "none",
                      height: "2.5vh",
                      cursor: "pointer",
                      paddingBottom: "0.5vh",
                    }}
                  />{" "}
                  <img
                    src={Ofline}
                    style={{
                      display: isOnline && "none",
                      height: "2.5vh",
                      cursor: "pointer",
                      paddingBottom: "0.5vh",
                    }}
                  />{" "}
                </div>
              </Col>
            </Row>

            {barcodeFlag ? (
              posConfig?.noFocus === "Y" ? (
                <BarCodeComponentForNoFocus onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />
              ) : (
                <BarCodeComponentForRetail onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />
              )
            ) : null}

            {/* {barcodeFlag && <BarCodeComponentForRetail onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />} */}

            <div style={{ display: "flex", height: "91vh" }}>
              {/* Left side UI */}
              <div style={{ width: "63.9%" }}>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: "0 0 0 1.7%",
                  }}
                >
                  <div style={{ width: "93%" }}>
                    <RenderInput
                      posConfig={posConfig}
                      options={options}
                      productMap={productMap}
                      pickProduct={pickProduct}
                      productSearchInput={productSearchInput}
                      setProductSearchInput={setProductSearchInput}
                      setOptions={setOptions}
                      keyboard={keyboard}
                      filterDrawer={filterDrawer}
                      searchInputRef={searchInputRef}
                      clearProductSearchResults={clearProductSearchResults}
                      onChangeInput={onChangeInput}
                      setOpen={setOpen}
                      setInputName={setInputName}
                      setIsInputFocused={setIsInputFocused}
                      onBarcodeInput={onBarcodeInput}
                      productSearchInputRef={productSearchInputRef}
                    />
                  </div>
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "4.5%",
                      margin: "0 0.2vw 0 0.8vw",
                      borderRadius: "7px",
                      height: "inherit",
                      borderColor: "#fff",
                    }}
                    onClick={() => setIsProductsFilter(true)}
                  >
                    <img src={ScanIcon} style={{ height: "2.7vh" }} />
                  </Button>
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "4.5%",
                      margin: "0 1vw 0 0.5vw",
                      borderRadius: "7px",
                      height: "inherit",
                      borderColor: "#fff",
                    }}
                    id="sm-product-drawer"
                    // onClick={() => setIsProductsFilter(true)}
                    onClick={() => {
                      setFilterDrawer(true);
                    }}
                  >
                    <img src={FilterIcon} style={{ height: "2.7vh" }} />
                  </Button>
                </div>
                <div style={{ padding: "1.5%", display: "flex", gap: "1rem", width: "100%" }}>
                  <div style={{ width: localStorage.getItem("selectedReturnType") === "EXCHANGE" ? "50%" : "100%" }}>
                    {cart.layAway === "Y" && posConfig?.advanceLayaway === "Y" ? (
                      <div
                        style={{
                          position: "absolute",
                          bottom: "29vh",
                          left: "56vw",
                        }}
                      >
                        <span style={{ opacity: "0.5" }}>ADVANCE</span>
                      </div>
                    ) : null}
                    {watermark()}
                    {localStorage.getItem("selectedReturnType") === "EXCHANGE" ? (
                      <div
                        style={{
                          width: "100%",
                          height: "6vh",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#FDEAEA",
                          padding: "0 1rem",
                          borderTopLeftRadius: "8px",
                          borderTopRightRadius: "8px",
                          border: "1px solid #f5c2c7",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <span
                            style={{
                              backgroundColor: "#E53935",
                              color: "#fff",
                              fontWeight: 600,
                              fontSize: "0.6em",
                              padding: "2px 6px",
                              borderRadius: "4px",
                            }}
                          >
                            RETURN
                          </span>
                          <span
                            style={{
                              fontSize: "0.8em",
                              fontWeight: 600,
                              color: "#2F3856",
                            }}
                          >
                            Returned Items
                          </span>
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                          <Button
                            size="small"
                            icon={<UserOutlined />}
                            style={{
                              borderRadius: "6px",
                              fontWeight: 500,
                              fontSize: "0.8em",
                            }}
                            disabled={true}
                            // onClick={() => {
                            //   setDisplayCustomerSearch(true);
                            // }}
                          >
                            Change Customer
                          </Button>

                          {/* Amount */}
                          {renderReturnAmount()}
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          height: "6vh",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          textAlign: "center",
                          backgroundColor: "#7A92AC",
                          padding: "1vw 0.5rem",
                          borderTopLeftRadius: "5px",
                          borderTopRightRadius: "5px",
                          color: "#fff",
                        }}
                      >
                        {renderInvoice()}
                        <span style={{ fontSize: "0.7rem", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          {renderDocumentNo()}
                          <img
                            src={NotesAdd}
                            onClick={() => {
                              setNotesPopup(true);
                              if (cart.description && cart.description.trim() !== "") {
                                setNotesValue(cart.description);
                              }
                              setIsInputFocused(true);
                            }}
                            style={{ height: "0.85rem", paddingLeft: "0.7rem", cursor: "pointer", paddingRight: "0.3rem" }}
                          />
                        </span>
                      </div>
                    )}
                    <Table
                      className={localStorage.getItem("selectedReturnType") === "EXCHANGE" ? "sm-cart-table-return-pos" : "sm-cart-table-pos"}
                      style={{
                        width: "100%",
                        overflowY: "auto",
                        border: "none",
                        // fontSize: "1vw",
                        borderRadius: "7px",
                        padding: localStorage.getItem("selectedReturnType") === "EXCHANGE" ? "0px" : "0px 7px",
                        // border: "1px solid rgba(146, 144, 152, 0.4)",
                        height: "50.5vh",
                        background: themeJSON.productTableBGColor || "#fff",
                      }}
                      pagination={false}
                      dataSource={
                        // Filter the data where weight is greater than 0
                        (parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
                          (item) => item.weight !== 0
                        )
                      }
                      sticky
                      id="sm-cart-table"
                      rowKey="lineId"
                      rowClassName={(record) => (selectedProductInCart.lineId === record.lineId ? "tableRowSelectedBlue" : "tableRowNonSelectedWhite")}
                      columns={[
                        {
                          title: "Item Name",
                          dataIndex: "name",
                          key: "name",
                          width: "28%",
                          render: (text, record, index) => {
                            return (
                              <>
                                <div className="offerName" style={{ display: "flex", alignItems: "center" }}>
                                  {posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? (
                                    <>
                                      {record.salesRepName ? (
                                        <>
                                          <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                                          <span>{record.salesRepName}</span>
                                        </>
                                      ) : (
                                        cart.salesRepName && (
                                          <>
                                            <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                                            <span>{cart.salesRepName}</span>
                                          </>
                                        )
                                      )}
                                    </>
                                  ) : null}
                                </div>

                                <div
                                  onClick={() => {
                                    if (cart.type !== "Layaway") {
                                      selectProductInCart(record);
                                      selectedRowKeys.length > 0 && selectedProductInCart.productId === record.productId ? setShowPaymentMethods(false) : "";
                                    }
                                  }}
                                  id="sm-product-name"
                                  className="tableRow"
                                  style={{
                                    textAlign: "left",
                                    // paddingLeft: record.groupedItems ? "40px" : "0px",
                                    // paddingleft: record.children && record.children.length > 0 ? "40px" : "0px",
                                    marginLeft: 0,
                                  }}
                                >
                                  {record.name}
                                </div>

                                <div
                                  className="offerName"
                                  style={
                                    {
                                      // paddingLeft: record.children?.[0]?.groupedItems ? "40px" : "0px",
                                    }
                                  }
                                >
                                  <p style={{ margin: 0 }}>{record.cardNo ? record.cardNo : record.value}</p>
                                  {/* {record?.customText ? <p style={{ margin: 0, padding: 0, color: "#FFA500" }}>{record?.customText}</p> : ""} */}
                                  {record.newCustomAttributes &&
                                    record.newCustomAttributes.length > 0 &&
                                    Object.entries(record.newCustomAttributes[0]).map(([key, value]) => {
                                      return (
                                        value && (
                                          <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>
                                            {key} - {value}
                                          </p>
                                        )
                                      );
                                    })}

                                  {record.selectedAddons &&
                                    record.selectedAddons.length > 0 &&
                                    record.selectedAddons.map((item) => {
                                      return item?.name && <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>{item.name}</p>;
                                    })}
                                  {record.batchedProduct === "Y" && record.batchedForSale === "Y" && record.batchno && (
                                    <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>Batch: {record.batchno}</p>
                                  )}
                                  {/* {(record?.uomData?.[0]?.name || record?.uom_name) && (
                                    <p style={{ margin: 0, padding: 0, paddingBottom: "0.4vh", color: "#8c92ac", fontStyle: "italic" }}>
                                      {record?.uomData?.[0]?.name || record?.uom_name}
                                    </p>
                                  )} */}

                                  {Math.abs(record.discount) > 0 && record.discountName && (
                                    <span
                                      style={{
                                        background: Math.abs(record.discount) > 0 ? "#F8C519" : "",
                                        padding: "0.25vw",
                                        display: record.discountName ? "" : "none",
                                      }}
                                    >
                                      {Math.abs(record.discount) > 0 ? (
                                        record.discountName ? (
                                          <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} />
                                        ) : (
                                          ""
                                        )
                                      ) : (
                                        ""
                                      )}{" "}
                                      {Math.abs(record.discount) > 0 ? record.discountName || "" : ""}{" "}
                                    </span>
                                  )}
                                </div>
                              </>
                            );
                          },
                        },
                        {
                          title: "Qty",
                          dataIndex: "weight",
                          key: "weight",
                          width: "11%",
                          render: (text, record, index) => {
                            const wt = parseFloat(text);
                            if (Number.isInteger(wt)) {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {/* <div style={{ margin: "0 3px", fontWeight: "500", fontSize: "1.1vw" }}>{wt.toFixed(record.isQtyDesimal)}</div> */}
                                  <div className="tableRow">{wt.toFixed(record.isQtyDesimal)}</div>
                                </div>
                              );
                            } else {
                              return (
                                <>
                                  <div>{parseFloat(text).toFixed(record.isQtyDesimal)}</div>
                                  <div className="offerName">
                                    {record.salesRepName && posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? record.salesRepName : ""}
                                  </div>
                                </>
                              );
                            }
                          },
                          align: "center",
                        },
                        localStorage.getItem("selectedReturnType") !== "EXCHANGE" && {
                          title: "Discount",
                          dataIndex: "discount",
                          key: "discount",
                          width: "11%",
                          render: (text) => <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>,
                          align: "center",
                        },
                        {
                          title: "Tax",
                          dataIndex: "taxAmount",
                          key: "taxAmount",
                          width: "11%",
                          render: (text, record) => {
                            return (
                              <div>
                                <span className="tableRow">
                                  {text?.toFixed(pricePrecision).length < 8 ? parseFloat(text)?.toFixed(pricePrecision) : `${text?.toString().substring(0, 8)}`}
                                </span>
                              </div>
                            );
                          },
                          align: "center",
                        },
                        {
                          title: "Price",
                          dataIndex: "realPrice",
                          key: "realPrice",
                          width: "10%",
                          render: (text, record) => {
                            return (
                              <div>
                                <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
                              </div>
                            );
                          },
                          align: "center",
                        },
                        {
                          title: "Total",
                          dataIndex: "nettotal",
                          key: "nettotal",
                          width: "15%",
                          render: (text, record) => {
                            return (
                              <div style={{ position: "relative" }}>
                                <span className="tableRow" style={{ width: "12%", left: "0" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                  &nbsp;
                                  {
                                    // text.toString().length < 9 ?
                                    parseFloat(text).toFixed(pricePrecision)
                                    // :
                                    // `${text.toString().substring(0, 5)}...`
                                  }
                                  &nbsp;
                                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                </span>
                              </div>
                            );
                          },
                          align: "center",
                        },
                        {
                          title: "",
                          dataIndex: "",
                          key: "",
                          width: "10%",
                          render: (text, record) => {
                            if (record.groupedItems === true) return null;
                            if (record?.companion_product_id) return null;
                            return (
                              <div style={{ position: "relative", display: "flex", justifyContent: "space-evenly" }}>
                                <img
                                  src={DeleteProduct}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    clearSelectedProductInCart();
                                    removeProductModal(record);
                                    setIsInputFocused(false);
                                    setShowInputFields(false);
                                    setCustomMixItems([]);
                                    setGroupQty(1);
                                    setActiveInput("search");
                                    if (searchInputRef?.current) {
                                      searchInputRef?.current.focus();
                                    }
                                  }}
                                  id="sm-product-delete"
                                  style={{
                                    height: "2.5vh",
                                    cursor: "pointer",
                                    right: 1,
                                    top: "15%",
                                  }}
                                  // style={{ height: "18px", width: "18px", cursor: "pointer", right: 1, top: "15%", paddingRight: "3px" }}
                                />
                                {localStorage.getItem("selectedReturnType") !== "EXCHANGE" && (
                                  <>
                                    <img
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        clearSelectedProductInCart();
                                        setNotesPopup(true);
                                        setIsInputFocused(true);
                                        setNotesValue(record.notes);
                                        setSelectedProductForNotes(record);
                                        selectProductInCart(record);
                                        setIsInputFocused(false);
                                      }}
                                      src={NotesImage}
                                      alt=""
                                      style={{
                                        height: "14px",
                                        width: "14px",
                                        cursor: "pointer",
                                        paddingleft: "0.8vw",
                                      }}
                                    />
                                    {posConfig?.showLineSalesRep === "Y" && (
                                      <img
                                        // src={userIcon}
                                        src={userAddIcon}
                                        style={{ height: "2.3vh", cursor: "pointer", paddingTop: "1px" }}
                                        alt=""
                                        onClick={() => {
                                          setOpenSalesRep({ flag: true, level: "line" });
                                        }}
                                      />
                                    )}
                                  </>
                                )}
                              </div>
                            );
                          },
                          align: "center",
                        },
                      ].filter(Boolean)}
                      {...(hasExpandableRows && {
                        expandable: {
                          expandedRowRender: (record) => (record.children && record.children.length > 0 ? <div></div> : null),
                          rowExpandable: (record) => record.children && record.children.length > 0,
                        },
                      })}
                      onRow={(record) => ({
                        onClick: () => {
                          // if (cart.type !== "Layaway") {
                          if (cart?.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
                            message.info("This order cannot be edited!");
                          } else {
                            if (cart?.preOrder === "Y") {
                              Modal.confirm({
                                title: <div style={{ fontWeight: "500", fontSize: "1.2em", color: "#0F0718" }}>Cart Editing Restricted</div>,
                                content: (
                                  <div style={{ fontSize: "14px", color: "#0F0718", marginTop: "8px" }}>
                                    <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em" }}>
                                      This is a pre-order with advance payment. Cart items cannot be modified at this stage. Please proceed to complete the transaction.
                                    </p>
                                  </div>
                                ),
                                icon: null,
                                icon: <WarningOutlined />,
                                okText: "Ok",
                                okButtonProps: { style: { display: "inline-block" } },
                                cancelButtonProps: { style: { display: "none" } },
                                // autoFocusButton: null,
                                modalRender: (node) => <div className="custom-confirm-modal-wrapper">{node}</div>,

                                onOk() {
                                  const productSearchInput = document.getElementById("sm-product-search");
                                  if (productSearchInput) {
                                    setTimeout(() => {
                                      productSearchInput.focus();
                                    }, 300);
                                  }
                                },
                              });

                              return;
                            }
                            if (cart?.couponInput?.length > 0) {
                              Modal.confirm({
                                title: <div style={{ fontWeight: "500", fontSize: "1.2em", color: "#0F0718" }}>Cart Editing Restricted</div>,
                                content: (
                                  <div style={{ fontSize: "14px", color: "#0F0718", marginTop: "8px" }}>
                                    <p style={{ marginBottom: 0 }}>Coupon applied to this order. Do you want to remove the coupon and continue editing the cart?</p>
                                  </div>
                                ),
                                icon: <WarningOutlined />,
                                okText: "Yes",
                                cancelText: "No",
                                autoFocusButton: null,
                                okButtonProps: { style: { display: "inline-block" } },
                                onOk: async () => {
                                  if (cart?.couponInput?.length > 0) {
                                    for (const coupon of cart.couponInput) {
                                      await removeCoupon(coupon);
                                    }
                                  }
                                },

                                onCancel() {
                                  const productSearchInput = document.getElementById("sm-product-search");
                                  if (productSearchInput) {
                                    setTimeout(() => {
                                      productSearchInput.focus();
                                    }, 300);
                                  }
                                },
                              });

                              return;
                            }
                            qtyInputRef?.current?.focus();
                            setActiveInput("qty");
                            // setTimeout(() => {
                            //   qtyInputRef?.current?.select();
                            // }, 50);
                            if (record.posPriceEdit === "Y") {
                              qtyInputRef?.current?.focus();
                              setShowInputFields(true);
                              setRealPrice(record.weight);
                              setFirstInputValue(true);
                            } else {
                              setShowInputFields(false);
                            }
                            if (record.children && record.children.length > 0) {
                              setSelectedCustomMix(record);
                              setCustomMixItems(record.children);
                              setGroupName(record.name);
                              setGroupQty(record.weight);
                              setExistingGroupItems(true);
                            }
                            setIsInputFocused(false);
                            setOverPayedAmount(0);
                            setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
                            selectProductInCart(record);
                            setSelectedRowKeys([record.key]);
                            setQtyNumberFlag(0);
                            setShowPaymentMethods(false);
                            setSelectedProductInCart(record);
                            setStockList([]);
                          }
                        },
                      })}
                    />
                  </div>
                  {localStorage.getItem("selectedReturnType") === "EXCHANGE" ? (
                    <div style={{ width: "50%" }}>
                      <div
                        style={{
                          width: "100%",
                          height: "6vh",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#E6F4EA",
                          padding: "0 1rem",
                          borderTopLeftRadius: "8px",
                          borderTopRightRadius: "8px",
                          border: "1px solid #A5D6A7",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <span
                            style={{
                              backgroundColor: "#2F8F46",
                              color: "#fff",
                              fontWeight: 600,
                              fontSize: "0.6em",
                              padding: "2px 6px",
                              borderRadius: "4px",
                            }}
                          >
                            NEW ITEM
                          </span>
                          <span
                            style={{
                              fontSize: "0.8em",
                              fontWeight: 600,
                              color: "#2F3856",
                            }}
                          >
                            Exchange Items
                          </span>
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                          <Button
                            size="small"
                            icon={<UserOutlined />}
                            style={{
                              borderRadius: "6px",
                              fontWeight: 500,
                              fontSize: "0.75em",
                              padding: "0 4px",
                              height: "22px",
                              lineHeight: "22px",
                            }}
                            // disabled={true}
                            onClick={() => {
                              setDisplayCustomerSearch(true);
                              setCloseCustomerFlag(true);
                              setProductSearchInput("");
                            }}
                          >
                            {/* Change Customer */}
                            {tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === JSON.parse(localStorage.getItem("exchangeCartObj"))?.customer?.cwrCustomerId
                              ? "Change Customer"
                              : JSON.parse(localStorage.getItem("exchangeCartObj") || "{}")?.customer?.name || "Change Customer"}
                          </Button>

                          {renderExchangeAmount()}
                        </div>
                      </div>
                      <Table
                        // className="sm-cart-table-pos"
                        className={localStorage.getItem("selectedReturnType") === "EXCHANGE" ? "sm-cart-table-exchange-pos" : "sm-cart-table-pos"}
                        style={{
                          width: localStorage.getItem("selectedReturnType") === "EXCHANGE" ? "100%" : "100%",
                          overflowY: "auto",
                          border: "none",
                          // fontSize: "1vw",
                          borderRadius: "7px",
                          padding: localStorage.getItem("selectedReturnType") === "EXCHANGE" ? "0px" : "0px 7px",
                          // border: "1px solid rgba(146, 144, 152, 0.4)",
                          height: "50.5vh",
                          background: themeJSON.productTableBGColor || "#fff",
                        }}
                        pagination={false}
                        dataSource={
                          // Filter the data where weight is greater than 0
                          (JSON.parse(localStorage.getItem("exchangeCartObj"))?.items ? JSON.parse(localStorage.getItem("exchangeCartObj")).items : []).filter(
                            (item) => item.weight !== 0
                          )
                        }
                        // dataSource={(JSON.parse(localStorage.getItem("exchangeCartObj") || "{}")?.items || []).filter((item) => item.weight !== 0)}
                        sticky
                        id="sm-cart-table"
                        rowKey="lineId"
                        rowClassName={(record) => (selectedProductInCart.lineId === record.lineId ? "tableRowSelectedBlue" : "tableRowNonSelectedWhite")}
                        columns={[
                          {
                            title: "Item Name",
                            dataIndex: "name",
                            key: "name",
                            width: "28%",
                            render: (text, record, index) => {
                              return (
                                <>
                                  <div className="offerName" style={{ display: "flex", alignItems: "center" }}>
                                    {posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? (
                                      <>
                                        {record.salesRepName ? (
                                          <>
                                            <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                                            <span>{record.salesRepName}</span>
                                          </>
                                        ) : (
                                          JSON.parse(localStorage.getItem("exchangeCartObj"))?.salesRepName && (
                                            <>
                                              <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                                              <span>{JSON.parse(localStorage.getItem("exchangeCartObj")).salesRepName}</span>
                                            </>
                                          )
                                        )}
                                      </>
                                    ) : null}
                                  </div>

                                  <div
                                    onClick={() => {
                                      if (cart.type !== "Layaway") {
                                        selectProductInCart(record);
                                        selectedRowKeys.length > 0 && selectedProductInCart.productId === record.productId ? setShowPaymentMethods(false) : "";
                                      }
                                    }}
                                    id="sm-product-name"
                                    className="tableRow"
                                    style={{
                                      textAlign: "left",
                                      // paddingLeft: record.groupedItems ? "40px" : "0px",
                                      // paddingleft: record.children && record.children.length > 0 ? "40px" : "0px",
                                      marginLeft: 0,
                                    }}
                                  >
                                    {record.name}
                                  </div>

                                  <div
                                    className="offerName"
                                    style={
                                      {
                                        // paddingLeft: record.children?.[0]?.groupedItems ? "40px" : "0px",
                                      }
                                    }
                                  >
                                    <p style={{ margin: 0 }}>{record.cardNo ? record.cardNo : record.value}</p>

                                    {record.newCustomAttributes &&
                                      record.newCustomAttributes.length > 0 &&
                                      Object.entries(record.newCustomAttributes[0]).map(([key, value]) => {
                                        return (
                                          value && (
                                            <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>
                                              {key} - {value}
                                            </p>
                                          )
                                        );
                                      })}

                                    {record.selectedAddons &&
                                      record.selectedAddons.length > 0 &&
                                      record.selectedAddons.map((item) => {
                                        return item?.name && <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>{item.name}</p>;
                                      })}
                                    {record.batchedProduct === "Y" && record.batchedForSale === "Y" && record.batchno && (
                                      <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>Batch: {record.batchno}</p>
                                    )}
                                    {(record?.uomData?.[0]?.name || record?.uom_name) && (
                                      <p style={{ margin: 0, padding: 0, paddingBottom: "0.4vh", color: "#8c92ac", fontStyle: "italic" }}>
                                        {record?.uomData?.[0]?.name || record?.uom_name}
                                      </p>
                                    )}

                                    <span
                                      style={{
                                        background: Math.abs(record.discount) > 0 ? "#F8C519" : "",
                                        padding: "0.25vw",
                                        display: record.discountName ? "" : "none",
                                      }}
                                    >
                                      {Math.abs(record.discount) > 0 ? (
                                        record.discountName ? (
                                          <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} />
                                        ) : (
                                          ""
                                        )
                                      ) : (
                                        ""
                                      )}{" "}
                                      {Math.abs(record.discount) > 0 ? record.discountName || "" : ""}{" "}
                                    </span>
                                  </div>
                                </>
                              );
                            },
                          },
                          {
                            title: "Qty",
                            dataIndex: "weight",
                            key: "weight",
                            width: "11%",
                            render: (text, record, index) => {
                              const wt = parseFloat(text);
                              if (Number.isInteger(wt)) {
                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <div className="tableRow">{wt.toFixed(record.isQtyDesimal)}</div>
                                  </div>
                                );
                              } else {
                                return (
                                  <>
                                    <div>{parseFloat(text).toFixed(record.isQtyDesimal)}</div>
                                    <div className="offerName">
                                      {record.salesRepName && posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? record.salesRepName : ""}
                                    </div>
                                  </>
                                );
                              }
                            },
                            align: "center",
                          },
                          localStorage.getItem("selectedReturnType") !== "EXCHANGE" && {
                            title: "Discount",
                            dataIndex: "discount",
                            key: "discount",
                            width: "11%",
                            render: (text) => <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>,
                            align: "center",
                          },
                          {
                            title: "Tax",
                            dataIndex: "taxAmount",
                            key: "taxAmount",
                            width: "11%",
                            render: (text, record) => {
                              return (
                                <div>
                                  <span className="tableRow">
                                    {text?.toFixed(pricePrecision).length < 8 ? parseFloat(text)?.toFixed(pricePrecision) : `${text?.toString().substring(0, 8)}`}
                                  </span>
                                </div>
                              );
                            },
                            align: "center",
                          },
                          {
                            title: "Price",
                            dataIndex: "realPrice",
                            key: "realPrice",
                            width: "10%",
                            render: (text, record) => {
                              return (
                                <div>
                                  <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
                                </div>
                              );
                            },
                            align: "center",
                          },
                          {
                            title: "Total",
                            dataIndex: "nettotal",
                            key: "nettotal",
                            width: "15%",
                            render: (text, record) => {
                              return (
                                <div style={{ position: "relative" }}>
                                  <span className="tableRow" style={{ width: "12%", left: "0" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                    &nbsp;
                                    {
                                      // text.toString().length < 9 ?
                                      parseFloat(text).toFixed(pricePrecision)
                                      // :
                                      // `${text.toString().substring(0, 5)}...`
                                    }
                                    &nbsp;
                                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                  </span>
                                </div>
                              );
                            },
                            align: "center",
                          },
                          {
                            title: "",
                            dataIndex: "",
                            key: "",
                            width: "10%",
                            render: (text, record) => {
                              if (record.groupedItems === true) return null;
                              if (record?.companion_product_id) return null;
                              return (
                                <div style={{ position: "relative", display: "flex", justifyContent: "space-evenly" }}>
                                  <img
                                    src={DeleteProduct}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      clearSelectedProductInCart();
                                      removeProductModal(record);
                                      setIsInputFocused(false);
                                      setShowInputFields(false);
                                      setCustomMixItems([]);
                                      setGroupQty(1);
                                      setActiveInput("search");
                                      if (searchInputRef?.current) {
                                        searchInputRef?.current.focus();
                                      }
                                    }}
                                    id="sm-product-delete"
                                    style={{
                                      height: "2.5vh",
                                      cursor: "pointer",
                                      right: 1,
                                      top: "15%",
                                    }}
                                    // style={{ height: "18px", width: "18px", cursor: "pointer", right: 1, top: "15%", paddingRight: "3px" }}
                                  />
                                  {localStorage.getItem("selectedReturnType") !== "EXCHANGE" && (
                                    <>
                                      <img
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          clearSelectedProductInCart();
                                          setNotesPopup(true);
                                          setIsInputFocused(true);
                                          setNotesValue(record.notes);
                                          setSelectedProductForNotes(record);
                                          selectProductInCart(record);
                                          setIsInputFocused(false);
                                        }}
                                        src={NotesImage}
                                        alt=""
                                        style={{
                                          height: "14px",
                                          width: "14px",
                                          cursor: "pointer",
                                          paddingleft: "0.8vw",
                                        }}
                                      />
                                      {posConfig?.showLineSalesRep === "Y" && (
                                        <img
                                          // src={userIcon}
                                          src={userAddIcon}
                                          style={{ height: "2.3vh", cursor: "pointer", paddingTop: "1px" }}
                                          alt=""
                                          onClick={() => {
                                            setOpenSalesRep({ flag: true, level: "line" });
                                          }}
                                        />
                                      )}
                                    </>
                                  )}
                                </div>
                              );
                            },
                            align: "center",
                          },
                        ].filter(Boolean)}
                        {...(hasExpandableRows && {
                          expandable: {
                            expandedRowRender: (record) => (record.children && record.children.length > 0 ? <div></div> : null),
                            rowExpandable: (record) => record.children && record.children.length > 0,
                          },
                        })}
                        onRow={(record) => ({
                          onClick: () => {
                            // if (cart.type !== "Layaway") {
                            if (cart?.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
                              message.info("This order cannot be edited!");
                            } else {
                              if (cart?.preOrder === "Y") {
                                Modal.confirm({
                                  title: <div style={{ fontWeight: "500", fontSize: "1.2em", color: "#0F0718" }}>Cart Editing Restricted</div>,
                                  content: (
                                    <div style={{ fontSize: "14px", color: "#0F0718", marginTop: "8px" }}>
                                      <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em" }}>
                                        This is a pre-order with advance payment. Cart items cannot be modified at this stage. Please proceed to complete the transaction.
                                      </p>
                                    </div>
                                  ),
                                  icon: null,
                                  icon: <WarningOutlined />,
                                  okText: "Ok",
                                  okButtonProps: { style: { display: "inline-block" } },
                                  cancelButtonProps: { style: { display: "none" } },
                                  // autoFocusButton: null,
                                  modalRender: (node) => <div className="custom-confirm-modal-wrapper">{node}</div>,

                                  onOk() {
                                    const productSearchInput = document.getElementById("sm-product-search");
                                    if (productSearchInput) {
                                      setTimeout(() => {
                                        productSearchInput.focus();
                                      }, 300);
                                    }
                                  },
                                });

                                return;
                              }
                              qtyInputRef?.current?.focus();
                              setActiveInput("qty");
                              // setTimeout(() => {
                              //   qtyInputRef?.current?.select();
                              // }, 50);
                              if (record.posPriceEdit === "Y") {
                                qtyInputRef?.current?.focus();
                                setShowInputFields(true);
                                setRealPrice(record.weight);
                                setFirstInputValue(true);
                              } else {
                                setShowInputFields(false);
                              }
                              if (record.children && record.children.length > 0) {
                                setSelectedCustomMix(record);
                                setCustomMixItems(record.children);
                                setGroupName(record.name);
                                setGroupQty(record.weight);
                                setExistingGroupItems(true);
                              }
                              setIsInputFocused(false);
                              setOverPayedAmount(0);
                              setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
                              selectProductInCart(record);
                              setSelectedRowKeys([record.key]);
                              setQtyNumberFlag(0);
                              setShowPaymentMethods(false);
                              setSelectedProductInCart(record);
                              setStockList([]);
                            }
                          },
                        })}
                      />
                    </div>
                  ) : null}
                </div>
                <div style={{ padding: "0 1.5% 0 1.5%", display: "flex" }}>
                  <div
                    style={{
                      background: themeJSON.taxAndDiscountSectionBGColor || "#fff",
                      height: "23.5vh",
                      width: "60%",
                      marginRight: "1%",
                      border: "1px solid #fff",
                      borderRadius: "7px",
                      padding: "0.5vh",
                      fontSize: "1vw",
                      position: "relative",
                    }}
                  >
                    <>
                      {!isExchange ? (
                        <>
                          {tempSaleTypeData?.length > 0 && (
                            <ArrowsAltOutlined
                              style={{
                                position: "absolute",
                                top: "0px",
                                right: "1px",
                                cursor: "pointer",
                                fontSize: "1.2vw", // optional: to scale appropriately
                                zIndex: 1, // ensures it's above content
                              }}
                              onClick={() => {
                                setExpandTotals(true);
                              }}
                            />
                          )}
                          <ArrowsAltOutlined
                            style={{
                              position: "absolute",
                              top: "0px",
                              right: "1px",
                              cursor: "pointer",
                              fontSize: "1.2vw", // optional: to scale appropriately
                              zIndex: 1, // ensures it's above content
                            }}
                            onClick={() => {
                              setExpandTotals(true);
                            }}
                          />
                          <Row style={{ height: "4.5vh" }}>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "0.8vw",
                                textAlign: "left",
                                fontWeight: "500",
                                color: "#0F0718",
                              }}
                            >
                              <p style={styles.screenStyles.mainScreen.subTotalText}>Subtotal:</p>
                            </Col>
                            {/* <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "0.8vw", textAlign: "right", justifyContent: "end", color: "#0F0718" }}> */}
                            <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;
                              <p
                                style={{
                                  textAlign: "right",
                                  margin: "0",
                                  fontWeight: "500",
                                  color: "#0F0718",
                                }}
                              >
                                {/* {(
                            parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj"))?.total : cart.total).toFixed(2) -
                            parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj"))?.tax : cart.tax).toFixed(2)
                          ).toFixed(2)} */}
                                {parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj"))?.subTotal : cart.subTotal).toFixed(pricePrecision)}
                              </p>
                              <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                            </Col>
                          </Row>

                          <Row style={{ height: "4.4vh" }}>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "0.8vw",
                                fontWeight: "500",
                                textAlign: "left",
                              }}
                            >
                              <p style={styles.screenStyles.mainScreen.subTotalText}>Discount:</p>
                            </Col>
                            <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;
                              <p
                                style={{
                                  textAlign: "right",
                                  margin: "0",
                                  fontWeight: "500",
                                  color: "#0F0718",
                                }}
                              >
                                {parseFloat(cart.discount ? cart.discount : 0).toFixed(pricePrecision)}
                              </p>
                              <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                            </Col>
                          </Row>
                          <Row style={{ height: "4.5vh" }}>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "0.8vw",
                                fontWeight: "500",
                                textAlign: "left",
                              }}
                            >
                              <p style={styles.screenStyles.mainScreen.subTotalText}>Tax:</p>
                            </Col>
                            <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;
                              <p
                                style={{
                                  textAlign: "right",
                                  margin: "0",
                                  fontWeight: "500",
                                  color: "#0F0718",
                                }}
                              >
                                {parseFloat(cart.tax).toFixed(pricePrecision)}
                              </p>
                              <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                            </Col>
                          </Row>
                          <Row style={{ height: "4.5vh" }}>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "0.8vw",
                                fontWeight: "500",
                                textAlign: "left",
                              }}
                            >
                              <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
                            </Col>
                            <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;
                              <p
                                style={{
                                  textAlign: "right",
                                  margin: "0",
                                  fontWeight: "500",
                                  color: "#0F0718",
                                }}
                              >
                                {parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")).total : cart.total)?.toFixed(pricePrecision)}
                              </p>
                              <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                            </Col>
                          </Row>

                          <Row style={{ height: "4.5vh" }}>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "0.8vw",
                                fontWeight: "500",
                                textAlign: "left",
                              }}
                            >
                              <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items / Total Qty:</p>
                            </Col>
                            <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                              <p
                                style={{
                                  textAlign: "right",
                                  margin: "0",
                                  fontWeight: "500",
                                  color: "#0F0718",
                                }}
                              >
                                {cart.items.length} / {parseFloat(cart.totalQty).toFixed(2)}
                              </p>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>{renderExchangeDiv()}</>
                      )}
                    </>
                  </div>
                  <div style={{ height: "23.7vh", width: "40%", fontSize: "1vw" }}>
                    <div
                      id="sm-cart-total"
                      // onClick={handleCartTotalClick}
                      onClick={verifyStock}
                      style={{
                        height: "18.2vh",
                        position: "relative",
                        background: themeJSON.totalAmountToPaySectionBGColor || "#2F3856",
                        borderRadius: "7px",
                        cursor: "pointer",
                      }}
                    >
                      {renderTotalAmountText()}
                      {cart.total !== undefined ? (
                        <p
                          style={{
                            textAlign: "center",
                            color: "#fff",
                            fontSize: "2.5em",
                            fontWeight: "500",
                            height: "14.4vh",
                            width: "100%",
                          }}
                        >
                          {" "}
                          {/* {parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")).total : cart.total)?.toFixed(pricePrecision)} */}
                          {(
                            parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")).total : cart.total) +
                            parseFloat(localStorage.getItem("exchangeCartObj") ? JSON.parse(localStorage.getItem("exchangeCartObj")).total : 0)
                          ).toFixed(pricePrecision)}
                        </p>
                      ) : (
                        <p
                          style={{
                            textAlign: "center",
                            color: "#fff",
                            fontSize: "2.5em",
                            fontWeight: "500",
                            height: "14.4vh",
                            width: "100%",
                          }}
                        >
                          {" "}
                          0.00
                        </p>
                      )}
                    </div>
                    <Row gutter={[8, 0]} style={{ marginTop: "0.8vh" }}>
                      <Col span={12} onClick={openDisplayParkedBillModal}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "500",
                            textAlign: "left",
                            border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                            height: "4.8vh",
                            borderRadius: "5px",
                            cursor: "pointer",
                            backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                          }}
                        >
                          <img src={Hold} style={{ height: "2.5vh" }} />
                          <span
                            style={{
                              margin: "0",
                              textAlign: "center",
                              color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                              paddingLeft: "0.5vw",
                              fontSize: "1em",
                              fontWeight: 500,
                            }}
                          >
                            Hold
                          </span>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",

                            fontWeight: "500",
                            justifyContent: "center",
                            border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                            height: "4.8vh",
                            borderRadius: "5px",
                            cursor: "pointer",
                            backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                          }}
                          id="sm-delete-cart"
                          onClick={deleteProductModal}
                        >
                          <img src={Cancel} style={{ height: "2.5vh" }} />
                          <span
                            style={{
                              textAlign: "center",
                              margin: "0",
                              color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                              paddingLeft: "0.5vw",
                              fontSize: "1em",
                              fontWeight: 500,
                            }}
                          >
                            Cancel
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              {/* Right side UI */}
              <div
                style={{
                  width: "35.6%",
                  padding: "0% 0% 0 0.4%",
                  borderRadius: "10px",
                  paddingBottom: "0",
                  height: "89vh",
                  marginRight: "1%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {(tillData && cart && tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId) ||
                  (!cart?.customer?.cwrCustomerId && retailCustomerFields?.length > 0) ? (
                    <Input
                      className="productSearch-sm"
                      id="sm-customer-search"
                      style={{
                        borderRadius: "0.5vw",
                        height: "4.9vh",
                        borderColor: "#fff",
                      }}
                      placeholder="Enter customer number/name"
                      prefix={<img src={CustomerSearch} alt="" style={{ height: "2.7vh" }} />}
                      onClick={() => {
                        if (cart.isReturn !== true) {
                          setDisplayCustomerSearch(true);
                          setCloseCustomerFlag(true);
                          setProductSearchInput("");
                        }
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        padding: "0.7vh 1.3vh",
                        border: "none",
                        background: "#fff",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        height: "5vh",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        <img src={CustomerIcon} style={{ height: "3.5vh" }}></img>{" "}
                        <span style={{ fontSize: "1vw" }}>
                          {cart?.customer?.name} - {cart?.customer?.b2cCustomerSegment?.name}
                        </span>
                      </span>
                      <span>
                        <img
                          src={View}
                          style={{
                            height: "3vh",
                            paddingBottom: "0.1em",
                            cursor: "pointer",
                          }}
                          id="sm-customer-view"
                          onClick={() => {
                            if (cart.isReturn !== true) {
                              if (retailCustomerFields && retailCustomerFields?.length > 0) {
                                const mappedCustomer = convertMetaDataToKeyValue(cart?.customer);
                                const loyaltyBalanceField = retailCustomerFields.find((f) => f.name?.toLowerCase().includes("loyalty balance"));
                                const loyaltyBalance = toCamelCase(loyaltyBalanceField?.name);
                                customerForm.setFieldsValue({
                                  ...mappedCustomer,
                                  mobileno: mappedCustomer?.mobileNo,
                                  lastname: mappedCustomer?.lastName,
                                  lastvisitdate: mappedCustomer?.lastVisitDate,
                                  cardnumber: mappedCustomer?.cardNumber,
                                  city: mappedCustomer?.customerAddress?.city,
                                  taxID: mappedCustomer?.taxId,
                                  anniversaryDate: mappedCustomer?.anniversaryDate?.split(" ")[0],
                                  birthday: mappedCustomer?.birthday?.split(" ")[0],
                                  validity: mappedCustomer?.validity?.split(" ")[0],
                                  loyaltyLevel: mappedCustomer?.loyaltyLevel?.cwrLoyaltyLevelId || null,
                                  [loyaltyBalance]: mappedCustomer?.retlLoyaltyBalance,
                                });
                                autoEnablePanCustomer(mappedCustomer);
                                autoEnableNriBilling(mappedCustomer);
                                setViewCustomerValues(mappedCustomer);
                                setSelectedEditOldCustomer(cart?.customer);
                                setDisplayEditOldCustomer(true);
                                setDisplayAddNewCustomer(false);
                                setIsViewMode(true);
                                console.log("mappedCustomer", mappedCustomer);
                                console.log("ViewCustomerValues", viewCustomerValues);
                              } else {
                                showEditOldCustomerFields(cart?.customer);
                                setIsViewMode(true);
                              }
                              // showEditOldCustomerFields(cart?.customer);
                            }
                          }}
                        />{" "}
                        &#124;{" "}
                        <EditOutlined
                          style={{ cursor: "pointer" }}
                          id="sm-customer-edit"
                          onClick={() => {
                            if (cart.isReturn !== true) {
                              // showEditOldCustomerFields(cart?.customer);
                              const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
                              if (retailCustomerFields && retailCustomerFields?.length > 0) {
                                const mappedCustomer = convertMetaDataToKeyValue(cartDetails?.customer);
                                const loyaltyBalanceField = retailCustomerFields.find((f) => f.name?.toLowerCase().includes("loyalty balance"));
                                const loyaltyBalance = toCamelCase(loyaltyBalanceField?.name);
                                customerForm.setFieldsValue({
                                  ...mappedCustomer,
                                  mobileno: mappedCustomer?.mobileNo,
                                  lastname: mappedCustomer?.lastName,
                                  taxID: mappedCustomer?.taxId,
                                  lastvisitdate: mappedCustomer?.lastVisitDate,
                                  cardnumber: mappedCustomer?.cardNumber,
                                  city: (() => {
                                    const addr = mappedCustomer?.customerAddress;
                                    if (!addr) return "";
                                    if (typeof addr === "string") {
                                      try {
                                        return JSON.parse(addr)?.city || "";
                                      } catch (e) {
                                        console.error("Invalid customerAddress JSON:", addr, e);
                                        return "";
                                      }
                                    }
                                    return addr.city || "";
                                  })(),

                                  taxID: mappedCustomer?.taxId,
                                  anniversaryDate: mappedCustomer?.anniversaryDate?.split(" ")[0],
                                  birthday: mappedCustomer?.birthday?.split(" ")[0],
                                  validity: mappedCustomer?.validity?.split(" ")[0],
                                  loyaltyLevel: mappedCustomer?.loyaltyLevel?.cwrLoyaltyLevelId || null,
                                  [loyaltyBalance]: mappedCustomer?.retlLoyaltyBalance,
                                });
                                // autoEnablePanCustomer(mappedCustomer);
                                autoEnableNriBilling(mappedCustomer);
                                setViewCustomerValues(mappedCustomer);
                                setSelectedEditOldCustomer(cartDetails?.customer);
                                console.log("selectededitoldcystomer", setSelectedEditOldCustomer);
                                setDisplayEditOldCustomer(true);
                                setDisplayAddNewCustomer(false);
                                setIsViewMode(false);
                                setEditFlag(true);
                              } else {
                                showEditOldCustomerFields(cartDetails?.customer);
                                setIsViewMode(false);
                                setEditFlag(true);
                              }
                            }
                          }}
                        />{" "}
                        &#124;{" "}
                        <CloseOutlined
                          style={{ fontSize: "2vh" }}
                          onClick={() => {
                            if (cart.isReturn !== true) {
                              removeCutomer();
                            }
                          }}
                        ></CloseOutlined>
                      </span>
                    </div>
                  )}
                  <img
                    src={AddUser}
                    style={{
                      height: "1.6vw",
                      paddingLeft: "1vw",
                      cursor: "pointer",
                      display: cart?.customer?.cwrCustomerId === customerId ? "" : "none",
                    }}
                    onClick={() => {
                      if (cart.isReturn !== true) {
                        (showAddNewCustomerFields(cart.customer), setProductSearchInput(""));
                      }
                    }}
                  />
                </div>
                <div style={{ display: "flex", fontSize: "1vw" }}>
                  <div
                    style={{
                      width: "18%",
                      paddingTop: "3%",
                      display: "flex",
                      flexDirection: "column-reverse",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.01rem",
                        display: tillAccessData?.productSync === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-product-sync"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          let parkedBills = JSON.parse(localStorage.getItem("parkedList"));

                          if (cart.items.length > 0) {
                            openDisplayParkedBillModal();
                          } else if (parkedBills?.length > 0) {
                            // Navigate to Parked Bills screen
                            handleKeyvalue("parked-bill");
                            setIsparkedBill(true);
                          } else {
                            if (isOnline) {
                              handleKeyvalue("4"); // Proceed to product sync
                            } else {
                              errorMessage("Sync Failed", "Please check your network connection and try again");

                              // Navigate to Parked Bills screen
                              //handleKeyvalue("parked-bill");
                              //setIsparkedBill(true);
                            }
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            fontSize: "1vw",
                          }}
                        >
                          <img src={SyncIcon} style={{ height: "2.5vh" }} color={"#fff"} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Product Sync</span>
                        </div>
                      </button>
                    </div>
                    <div style={{ width: "100%", display: "none" }}>
                      <button
                        className="cartMenuItems"
                        id="sm-pos"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        // onClick={() => {
                        //   handleKeyvalue("0");
                        //   setTableValue("POS");
                        // }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <POSIcon color={"#fff"} />
                          <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                            Point of Sale
                          </span>
                        </div>
                      </button>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={information} style={{ height: "2.7vh" }} color={"#fff"} />
                          <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                            Information
                          </span>
                        </div>
                      </button>
                    </div>

                    <div style={{ width: "100%", marginBottom: "0.37rem", display: tillAccessData?.manualDiscount === "Y" ? "block" : "none" }}>
                      <button
                        className="cartMenuItems"
                        id="sm-discount"
                        style={{ backgroundColor: "#2F3856", border: "1px solid #2F3856", borderRadius: "7px", height: "9.5vh" }}
                        onClick={async () => {
                          console.log("selectedProductInCart =====--------->", selectedProductInCart);
                          const exchangeCartData = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
                          const selectedReturnTypeLocal = localStorage.getItem("selectedReturnType");
                          const activeCart = selectedReturnTypeLocal === "EXCHANGE" && exchangeCartData?.items?.length > 0 ? exchangeCartData : cart;
                          if (selectedProductInCart) {
                            const pr = await db.pricingRules.toArray();
                            const index = pr.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId && md.manualDiscount === "Y");
                            if (index !== -1) {
                              const pricingRule = pr[index];
                              if (pricingRule.type !== "TD") {
                                let discountValue =
                                  pricingRule.discountType === "V"
                                    ? selectedProductInCart.discount
                                    : ((selectedProductInCart.discount / (selectedProductInCart?.realPrice * selectedProductInCart?.weight)) * 100).toFixed(pricePrecision);
                                manualDiscountForm.setFieldsValue({ discountName: pricingRule.mPricingrulesId, discountValue: discountValue });
                                setManualDiscountInput(discountValue);
                                setSelectedManualDiscountTypeValue(pricingRule);
                              } else {
                                const matchedPricingRule = activeCart?.manualDiscountData?.totalLevelDiscount?.findIndex(
                                  (item) => item.pricingRule === pricingRule.mPricingrulesId
                                );
                                manualDiscountForm.setFieldsValue({
                                  discountName: pricingRule.mPricingrulesId,
                                  discountValue: activeCart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
                                });
                                setManualDiscountInput(activeCart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
                                setSelectedManualDiscountTypeValue(pricingRule);
                              }
                            } else {
                              manualDiscountForm.resetFields();
                              setManualDiscountInput("");
                              setSelectedManualDiscountTypeValue("");
                            }
                          }
                          parseInt(activeCart?.total) > 0 && setManualDiscountModalVisible(true);
                          setProductSearchInput("");
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                          <img src={discount} style={{ height: "2.6vh" }} color={"#fff"} />
                          <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                            Manual Discount
                          </span>
                        </div>
                      </button>
                    </div>
                    {renderAdditionalChargesButton()}

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: "none",
                        fontSize: "1vw",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-return"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          if (cart.items.length > 0) {
                            openDisplayParkedBillModal();
                          } else {
                            handleKeyvalue("3");
                            setReturnFlag(true);
                            setIsPurchaseReturn(true);
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={ReturnIcon} style={{ height: "2.5vh" }} color={"#fff"} />
                          <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                            Return
                          </span>
                        </div>
                      </button>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: tillAccessData?.cashManagement === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-cash-management"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          if (isOnline) {
                            if (cart.items.length > 0) {
                              openDisplayParkedBillModal();
                            } else {
                              handleKeyvalue("2");
                              setIsCashManagement(true);
                            }
                          } else {
                            errorMessage("Sync Failed", "Please check your network connection and try again");
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <CashManagementIcon color={"#fff"} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Cash Management</span>
                        </div>
                      </button>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: tillAccessData?.giftCard === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-sales-history"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          if (!isOnline) {
                            errorMessage("Sync Failed", "Please check your network connection and try again");
                            return;
                          }
                          if (posConfig?.showGiftCardSaleInInvoice === "Y") {
                            setGiftCardType("Gift Card");
                            setIsGiftCardFlag(true);
                            setProductSearchInput("");
                          } else {
                            const selectedCustomer = cartObj?.customer?.cwrCustomerId !== matchedSaleType && cartObj?.customer?.mobileNo !== null;
                            if (!selectedCustomer) {
                              message.warning("Please update customer mobile number to proceed with Gift Card");
                              return;
                            }
                            setIsNewGiftCardFlag(true);
                            setProductSearchInput("");
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <SalesHistoryIcon color={"#fff"} />
                          {/* <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}> */}
                          <span style={styles.screenStyles.mainScreen.posIcon}>Gift Card</span>
                        </div>
                      </button>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: posConfig?.showBags === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-discount"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          setAddToBagFlag(true);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={giftVoucher} style={{ height: "2.6vh" }} color={"#fff"} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Bag</span>
                        </div>
                      </button>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: posConfig?.showOrderSalesRep === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-parked-bill"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          setOpenSalesRep({ flag: true, level: "order" });
                          setProductSearchInput("");
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={user_add} style={{ color: "#fff", height: "2.5vh" }} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Sales Representative</span>
                        </div>
                      </button>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: tillAccessData?.parkedBills === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-parked-bill"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                          cursor: isStoreCredit ? "not-allowed" : "pointer",
                        }}
                        disabled={isStoreCredit}
                        onClick={() => {
                          if (isStoreCredit) return;
                          handleKeyvalue("parked-bill");
                          setIsparkedBill(true);
                          setParkedBillSearchInput("");
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <ParkedBillIcon color={"#fff"} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Parked Bills</span>
                        </div>
                      </button>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: tillAccessData?.salesHistory === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-sales-history"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          if (cart.items.length > 0) {
                            clearReturnCartData();
                          } else {
                            if (isOnline) {
                              handleKeyvalue("3");
                              setDateRange("");
                              setIsPurchaseReturn(true);
                              setReturnFlag(false);
                              setShowReturnPurchase(false);
                              setExpandedRowKeys([]);
                              setSearchhistoryInput("");
                              setOrderHistoryDetails([]);
                              setFiltersFlag(false);
                              let dateValue = [moment(new Date()), moment(new Date())];
                              // setDateRange(dateValue);
                              searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
                            } else {
                              errorMessage("Sync Failed", "Please check your network connection and try again");
                            }
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <SalesHistoryIcon color={"#fff"} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Sales History</span>
                        </div>
                      </button>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: posConfig?.showEstimates === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-sales-history"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          setIsEstimatesFlag(true);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <FileTextOutlined style={{ fontSize: "16px" }} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Estimates</span>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "81.5%",
                      paddingTop: "3%",
                      display: showPaymentMethods && "none",
                    }}
                  >
                    <div
                      style={{
                        background: "#fff",
                        height: "41vh",
                        width: "95%",
                        margin: "0% 1% 2.7% 3.5%",
                        border: "1px solid #fff",
                        borderRadius: "7px",
                        visibility: shouldShowPanel ? "visible" : "hidden",
                      }}
                    >
                      {stockList.length > 0 ? (
                        <div>
                          <img
                            src={Back}
                            onClick={() => setStockList([])}
                            id="sm-parked-bill-back"
                            style={{
                              height: "2vw",
                              paddingBottom: "0.5em",
                              cursor: "pointer",
                              marginLeft: "10px",
                              marginTop: "0.7em",
                            }}
                          />
                          <Table
                            style={{
                              width: "100%",
                              overflowY: "auto",
                              borderRadius: "10px",
                              padding: "0",
                              height: "36vh",
                              background: "#fff",
                              maxHeight: "34vh",
                              display: "block",
                            }}
                            size="small"
                            locale={{ emptyText: "No data" }}
                            pagination={false}
                            dataSource={[...stockList]}
                            className="sm-stock-table"
                            columns={[
                              {
                                title: "Store",
                                dataIndex: "store",
                                key: "store",
                                render: (text, record) => <div>{record?.warehouse?.name || ""}</div>,
                              },
                              {
                                title: "In Stock",
                                dataIndex: "stock",
                                key: "stock",
                                render: (text, record) => <div>{record?.warehouse?.storageBin?.totalQty || 0}</div>,
                                align: "right",
                              },
                            ]}
                          />
                        </div>
                      ) : selectedProductInCart?.productSegment === "CB" && selectedProductInCart?.childItems?.length > 0 ? (
                        <div style={{ position: "relative", padding: "0.5rem", borderRadius: "6px", backgroundColor: "#fff", height: "100%" }}>
                          {/* Title at the top */}
                          {/* Header Row */}
                          <Row
                            style={{ padding: "0.1rem 0.75rem", fontSize: "0.75rem", fontWeight: 600, color: "#2F3856", borderBottom: "1px solid #e8e8e8", marginBottom: "0.5rem" }}
                          >
                            <Col span={8}>Name</Col>
                            <Col span={6} style={{ textAlign: "right" }}>
                              Unit Price
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                              Qty
                            </Col>
                            <Col span={6} style={{ textAlign: "right" }}>
                              Total Price
                            </Col>
                          </Row>

                          {/* Item Details */}
                          <Scrollbars style={{ height: "28vh" }}>
                            {selectedProductInCart.childItems.map((item) => {
                              const unitPrice = parseFloat(item.sunitprice) || 0;
                              // const quantity = parseFloat(item.weight * selectedProductInCart.weight) || 0;
                              const quantity = parseFloat(item.rawWeight * selectedProductInCart.weight) || 1;
                              const totalPrice = unitPrice * quantity;
                              const stdPrecision = item?.uomData[0]?.stdPrecision || 0;

                              return (
                                <Row
                                  key={item.id || item.name}
                                  style={{
                                    padding: "0 0.75rem",
                                    width: "100%",
                                    marginBottom: "0.4rem",
                                    height: "auto",
                                    alignItems: "center",
                                  }}
                                >
                                  <Col span={8}>
                                    <p
                                      title={item.name}
                                      style={{
                                        margin: 0,
                                        fontSize: "0.65rem",
                                        fontWeight: 500,
                                        color: "#333",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      {item.name}
                                    </p>
                                  </Col>
                                  <Col span={6} style={{ textAlign: "right" }}>
                                    <p
                                      style={{
                                        margin: 0,
                                        fontSize: "0.6rem",
                                        color: "#2F3856",
                                      }}
                                    >
                                      {unitPrice.toLocaleString("en-IN")}
                                    </p>
                                  </Col>
                                  <Col span={4} style={{ textAlign: "right" }}>
                                    <p
                                      style={{
                                        margin: 0,
                                        fontSize: "0.6rem",
                                        color: "#2F3856",
                                      }}
                                    >
                                      {quantity}
                                    </p>
                                  </Col>
                                  <Col span={6} style={{ textAlign: "right" }}>
                                    <p
                                      style={{
                                        margin: 0,
                                        fontSize: "0.6rem",
                                        color: "#2F3856",
                                      }}
                                    >
                                      {totalPrice.toLocaleString("en-IN")}
                                    </p>
                                  </Col>
                                </Row>
                              );
                            })}
                          </Scrollbars>

                          {/* Modify button at bottom right */}
                          <Button
                            style={{
                              position: "absolute",
                              bottom: "0.5rem",
                              right: "0.5rem",
                              backgroundColor: "#2F3856",
                              color: "#fff",
                              width: "7vw",
                              height: "4.5vh",
                              borderRadius: "3px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "none",
                              fontSize: "0.75rem",
                            }}
                            onClick={modifyProductList}
                          >
                            Modify
                          </Button>
                        </div>
                      ) : (
                        <Row gutter={[16]} style={{ paddingTop: "3vh" }}>
                          <Col span={7} style={{ height: "24vh" }}>
                            <img
                              style={{
                                width: "100%",
                                height: "27vh",
                                objectFit: "contain",
                                borderRadius: "5px",
                                paddingTop: "1vh",
                                alignSelf: "center",
                                padding: "1vh 0 1vh 0.8vw",
                              }}
                              src={selectedProductInCart.imageurl || DefaultProductImage}
                              alt=""
                            />
                          </Col>
                          <Col span={17} style={{ height: "24vh", position: "relative" }}>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                                fontFamily: "Inter",
                              }}
                            >
                              {selectedProductInCart["name"]?.toString().substring(0, 27)}...
                            </p>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                                fontFamily: "Inter",
                              }}
                            >
                              {selectedProductInCart["productBrandName"]}
                            </p>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "2.5em",
                                fontFamily: "Inter",
                              }}
                            >
                              {currenciesList[0].symbolRightSide === "N"
                                ? `${currenciesList[0].currSymbol}`
                                : currenciesList[0].symbolRightSide === "Y"
                                  ? `${currenciesList[0].currSymbol}`
                                  : ""}{" "}
                              {Number(selectedProductInCart["realPrice"]).toFixed(pricePrecision)}
                            </p>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                                fontFamily: "Inter",
                              }}
                            >
                              Quantity : {selectedProductInCart["weight"]}
                            </p>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                                fontFamily: "Inter",
                              }}
                            >
                              Uom : {selectedProductInCart?.uomData?.[0]?.name}
                            </p>
                            {stockList.length > 0 ? (
                              <CloseCircleOutlined
                                onClick={() => setStockList([])}
                                style={{
                                  position: "absolute",
                                  top: "25vh",
                                  left: "18vw",
                                  cursor: "pointer",
                                }}
                              />
                            ) : null}
                            {selectedProductInCart?.notes && selectedProductInCart?.notes.trim() !== "" && (
                              <p
                                style={{
                                  margin: 0,
                                  fontWeight: "400",
                                  color: "#0F0718",
                                  fontSize: "0.95em",
                                  fontFamily: "Inter",
                                  marginTop: "0.5vh",
                                }}
                              >
                                Notes : {selectedProductInCart?.notes}
                              </p>
                            )}
                            {posConfig?.showViewStockInCartSection === "Y" && (
                              <button
                                onClick={handleViewStockClick}
                                style={{
                                  backgroundColor: "#046307C2",
                                  border: "1px solid #fff",
                                  borderRadius: "7px",
                                  height: "5vh",
                                  width: "7vw",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "row",
                                    color: "#fff",
                                    fontSize: "1em",
                                    fontWeight: 500,
                                    fontFamily: "Inter",
                                  }}
                                >
                                  View Stock
                                </div>
                              </button>
                            )}
                            {stockList.map((record) => (
                              <p
                                key={record.id || record.name}
                                style={{
                                  margin: 0,
                                  fontWeight: "500",
                                  fontSize: "1em",
                                  color: "#0F0718",
                                  fontFamily: "Inter",
                                }}
                              >
                                {record?.name || ""} stock : {record?.warehouse?.storageBin?.totalQty || 0}
                              </p>
                            ))}
                          </Col>
                        </Row>
                      )}
                      {stockList.length < 0 ? (
                        <div style={{ padding: "1vh 1vw" }}>
                          <p
                            style={{
                              margin: 0,
                              textAlign: "left",
                              color: "#0F0718",
                              fontWeight: "500",
                            }}
                          >
                            Description:
                          </p>
                          <p
                            style={{
                              margin: 0,
                              textAlign: "left",
                              color: "#2F3856",
                              fontSize: "1em",
                              fontWeight: "500",
                            }}
                          >
                            {selectedProductInCart["description"]?.substring(0, 180)?.concat("....")}
                          </p>
                        </div>
                      ) : null}
                    </div>
                    <></>
                    {!showInputFields ? (
                      <div>
                        <Row style={{ margin: " 2% 0 0 0 " }}>
                          <Input
                            className="productSearch sm-payment-search totalQtyInput"
                            style={{
                              borderRadius: "0.5vw",
                              height: "8.3vh",
                              margin: "0 1% 2.7% 3.5%",
                              borderRadius: "5px",
                              textAlign: "right",
                              fontWeight: "500",
                              fontSize: "2.5em",
                              borderColor: "#fff",
                              color: "#2F3856",
                              fontFamily: "Inter",
                            }}
                            ref={qtyInputRef}
                            // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
                            value={selectedProductInCart.weight}
                            id="sm-amount-input"
                            // type="number"
                            onChange={(e) => {
                              if (cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0) {
                                // onChangeTotalQuantity(e.target.value?.replace(/[^\d.]/g, ""));
                                let value = e.target.value;
                                value = value.replace(/[^0-9.]/g, "");
                                const parts = value.split(".");
                                if (parts.length > 2) {
                                  value = parts[0] + "." + parts.slice(1).join("");
                                }
                                onChangeTotalQuantity(value);
                              }
                            }}
                            readOnly={cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0 ? false : true}
                            placeholder="Enter Quantity"
                            onFocus={() => {
                              setIsInputFocused(true);
                            }}
                            onBlur={() => {
                              setIsInputFocused(false);
                              setActiveInput("search");
                            }}
                            // ref={quantityInputRef}
                            onPressEnter={(e) => {
                              e.preventDefault();
                              enterTotalQty();
                            }}
                          />
                        </Row>
                        <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                          <Col span={6}>
                            <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                              1
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                              2
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                              3
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleTotalQty("x")}>
                              <img src={CancelArrow} alt="back space" width={25} height={15} />
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                              4
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                              5
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                              6
                            </button>
                          </Col>
                          <Col span={6}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <button
                                id="sm-amount-addQuantity"
                                onClick={() => {
                                  if (Object.keys(selectedProductInCart).length > 0) {
                                    decreaseProductQty(selectedProductInCart);
                                  }
                                }}
                                className="amt-dial-btn-market-qty"
                              >
                                -
                              </button>
                              <button
                                id="sm-amount-addQuantity"
                                onClick={async () => {
                                  if (Object.keys(selectedProductInCart).length > 0) {
                                    increaseProductQty(selectedProductInCart);
                                    // if(selectedProductInCart?.bundleId !== undefined){
                                    //   const productItem = await getProductData(selectedProductInCart.productId);
                                    //   productItem.weight = 1;
                                    //   productItem.isReturn = false;
                                    //   increaseProductQty(productItem);
                                    // }else{
                                    //   increaseProductQty(selectedProductInCart);
                                    // }
                                  }
                                }}
                                className="amt-dial-btn-market-qty"
                              >
                                +
                              </button>
                            </div>
                          </Col>
                          <Col span={18}>
                            <Row gutter={[8, 6]}>
                              <Col span={8}>
                                <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                                  7
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                                  8
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                                  9
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                                  0
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                                  .
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                                  Clear
                                </button>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                              Enter
                            </button>
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      <div>
                        <Tabs
                          defaultActiveKey="1"
                          className="custom-tabs"
                          // style={{ padding: "0 1% 0 3.5%" }}
                          onChange={(key) => {
                            if (key === "2") {
                              setTimeout(() => {
                                realPriceRef?.current?.focus();
                              }, 10);
                            } else if (key === "1") {
                              setTimeout(() => {
                                qtyInputRef?.current?.focus();
                              }, 10);
                            }
                          }}
                          style={{
                            // position: "absolute",
                            // top: "52%",
                            // left: "71.2%",
                            marginTop: "-11%",
                            marginLeft: "4%",
                            width: "94%",
                            height: "auto",
                            // background: "rgba(255, 255, 255, 0.95)",
                            zIndex: 1000,
                            transition: "top 0.5s ease",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                          }}
                        >
                          <TabPane tab="Qty" key="1" className="custom-tabpane" style={{ marginRight: "1vw" }}>
                            <Row style={{ margin: "0 0 0 0 " }}>
                              <Input
                                className="productSearch sm-payment-search totalQtyInput"
                                value={selectedProductInCart.weight}
                                style={{
                                  borderRadius: "0.5vw",
                                  height: "6.5vh",
                                  margin: "0% 1% 1% 0%",
                                  borderRadius: "5px",
                                  textAlign: "right",
                                  fontWeight: "500",
                                  fontSize: "2.5em",
                                  color: "#2F3856",
                                  borderColor: "#fff",
                                }}
                                ref={qtyInputRef}
                                onChange={(e) => {
                                  if (cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0) {
                                    onChangeTotalQuantity(e.target.value?.replace(/[^\d.]/g, ""));
                                  }
                                }}
                                onPressEnter={enterTotalQty}
                                id="sm-amount-input"
                                placeholder="Enter Quantity"
                              />
                            </Row>
                            <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
                              <Col span={6}>
                                <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                                  1
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                                  2
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                                  3
                                </button>
                              </Col>
                              <Col span={6}>
                                <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleTotalQty("x")}>
                                  <img src={CancelArrow} alt="back space" width={25} height={15} />
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                                  4
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                                  5
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                                  6
                                </button>
                              </Col>
                              <Col span={6}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <button
                                    id="sm-amount-addQuantity"
                                    onClick={() => {
                                      if (Object.keys(selectedProductInCart).length > 0) {
                                        decreaseProductQty(selectedProductInCart);
                                      }
                                    }}
                                    className="amt-dial-btn-market-qty"
                                  >
                                    -
                                  </button>
                                  <button
                                    id="sm-amount-addQuantity"
                                    onClick={async () => {
                                      if (Object.keys(selectedProductInCart).length > 0) {
                                        increaseProductQty(selectedProductInCart);
                                        // if(selectedProductInCart?.bundleId !== undefined){
                                        //   const productItem = await getProductData(selectedProductInCart.productId);
                                        //   productItem.weight = 1;
                                        //   productItem.isReturn = false;
                                        //   increaseProductQty(productItem);
                                        // }else{
                                        //   increaseProductQty(selectedProductInCart);
                                        // }
                                      }
                                    }}
                                    className="amt-dial-btn-market-qty"
                                  >
                                    +
                                  </button>
                                </div>
                              </Col>
                              <Col span={18}>
                                <Row gutter={[8, 6]}>
                                  <Col span={8}>
                                    <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                                      7
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                                      8
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                                      9
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                                      0
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                                      .
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                                      Clear
                                    </button>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                                  Enter
                                </button>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane
                            tab="Price"
                            key="2"
                            className="custom-tabpane"
                            style={{ marginRight: "1vw" }}
                            onClick={() => {
                              setTimeout(() => {
                                realPriceRef.current.focus();
                              }, 10);
                            }}
                          >
                            <Row style={{ margin: "0 0 0 0 " }}>
                              <Input
                                className="productSearch sm-payment-search totalQtyInput"
                                // value={selectedProductInCart.realPrice}
                                ref={realPriceRef}
                                value={realPrice}
                                onChange={(e) => {
                                  setRealPrice(e.target.value);
                                }}
                                onPressEnter={enterRealPrice}
                                style={{
                                  borderRadius: "0.5vw",
                                  height: "6.5vh",
                                  margin: "0% 1% 1% 0%",
                                  borderRadius: "5px",
                                  textAlign: "right",
                                  fontWeight: "500",
                                  fontSize: "2.5em",
                                  color: "#2F3856",
                                  borderColor: "#fff",
                                }}
                                id="sm-amount-input"
                                placeholder="Enter Price"
                              />
                            </Row>
                            <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
                              <Col span={6}>
                                <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleRealPrice("1")}>
                                  1
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleRealPrice("2")}>
                                  2
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleRealPrice("3")}>
                                  3
                                </button>
                              </Col>
                              <Col span={6}>
                                <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleRealPrice("x")}>
                                  <img src={CancelArrow} alt="back space" style={{ width: "20px", height: "15px" }} />
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleRealPrice("4")}>
                                  4
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleRealPrice("5")}>
                                  5
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleRealPrice("6")}>
                                  6
                                </button>
                              </Col>
                              <Col span={6}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <button
                                    id="sm-amount-addQuantity"
                                    className="amt-dial-btn-market-qty"
                                    onClick={() => {
                                      setRealPrice((prev) => {
                                        const numeric = parseFloat(prev) || 0;
                                        const newValue = Math.max(numeric - 1, 1);
                                        return newValue.toString();
                                      });
                                    }}
                                  >
                                    -
                                  </button>
                                  <button
                                    id="sm-amount-addQuantity"
                                    className="amt-dial-btn-market-qty"
                                    onClick={() => {
                                      setRealPrice((prev) => {
                                        const numeric = parseFloat(prev) || 0;
                                        return (numeric + 1).toString();
                                      });
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              </Col>
                              <Col span={18}>
                                <Row gutter={[8, 6]}>
                                  <Col span={8}>
                                    <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleRealPrice("7")}>
                                      7
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleRealPrice("8")}>
                                      8
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("9")}>
                                      9
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("0")}>
                                      0
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleRealPrice("00")}>
                                      00
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleRealPrice(".")}>
                                      .
                                    </button>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterRealPrice}>
                                  Enter
                                </button>
                              </Col>
                            </Row>
                          </TabPane>
                          {/* <TabPane
                            className="custom-tabpane"
                            tab={
                              <>
                                <CloseOutlined
                                  style={{
                                    marginLeft: "0.5rem",
                                    cursor: "pointer",
                                    fontSize: "17px",
                                    color: "#2F3856",
                                  }}
                                />
                              </>
                            }
                            key="3"
                          ></TabPane> */}
                        </Tabs>
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      width: "81.5%",
                      paddingTop: "3%",
                      display: !showPaymentMethods && "none",
                    }}
                  >
                    <Row style={{ padding: "0 1% 0 3.5%", height: "18.5vh" }} gutter={5}>
                      {_.sortBy(showPayments, "sequenceNo").map((pm, ind) => {
                        if (
                          (posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty") ||
                          (!cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.name === "Loyalty") ||
                          (!cart.customer.iscredit && pm.name === "Credit" && localStorage.getItem("isCreditSale") !== "true") ||
                          pm.name.toLowerCase() === "cafe tips" ||
                          (!cart?.customer?.cwrWallet?.wallet_Id && pm.isWallet === "Y")
                        ) {
                          return null;
                        }
                        return (
                          <Col span={8} key={pm.finPaymentmethodId}>
                            <button
                              onClick={async () => {
                                const panRule = customerConfigData?.conditionalRules?.find((rule) => rule.action === "Request PAN");
                                const exchangeCartData = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
                                const selectedReturnTypeLocal = localStorage.getItem("selectedReturnType");
                                const activeCart = selectedReturnTypeLocal === "EXCHANGE" && exchangeCartData?.items?.length > 0 ? exchangeCartData : cart;
                                const isPanMandatoryNow = panRule && Number(activeCart?.total) > Number(panRule.value) && !isNriBilling;
                                const enteredPAN = activeCart?.customer?.panCard || activeCart?.customer?.metaData?.find((m) => m.key?.toLowerCase().startsWith("pan"))?.value;
                                if (retailCustomerFields && retailCustomerFields.length > 0 && isPanMandatoryNow && (!enteredPAN || enteredPAN.trim() === "")) {
                                  const checkPanValidation = await verifyStock();
                                  if (!checkPanValidation) {
                                    return;
                                  }
                                }
                                if (exchangeCartData && exchangeCartData?.items?.length > 0) {
                                  const exchangeTotal = exchangeCartData?.total;

                                  const returnTotal = Math.abs(cart?.total || 0);

                                  if (exchangeTotal < returnTotal) {
                                    message.warning("Exchange value must be equal to or greater than Return value.");
                                    return;
                                  }
                                }
                                if (cart.items.length > 0 && pm.name !== "Complete Order") {
                                  setNumb(0);
                                  let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
                                    orderStartTime: "",
                                    orderEndTime: "",
                                    paymentStartTime: "",
                                  };
                                  if (orderTimeDetails.paymentStartTime === "") {
                                    orderTimeDetails = {
                                      ...orderTimeDetails,
                                      paymentStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
                                    };
                                    localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
                                  }
                                  const currenciesList = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

                                  // let originalAmount = Math.abs(cart.total) - cart.paid ?? 0;
                                  const cartObjStored = JSON.parse(localStorage.getItem("cartObj")) || cart;
                                  let originalAmount = Math.abs(cartObjStored.total) - (cartObjStored.paid ?? 0);

                                  // Get the smallest denomination (assuming sorted list)
                                  const smallestDenomination = currenciesList.length > 0 ? currenciesList[0].value : 1;

                                  // Round the amount to the nearest multiple of the smallest denomination
                                  let roundedAmount = Math.ceil(originalAmount / smallestDenomination) * smallestDenomination;

                                  // Calculate overpayment
                                  let overpayment = (roundedAmount - originalAmount).toFixed(precision);
                                  setOverPayedAmount(pm.roundOffForPos === "Y" && pm.integratedPayment === false ? overpayment : 0);
                                  // setAmount(
                                  //   pm.roundOffForPos === "Y" && pm.integratedPayment === false ? roundedAmount.toFixed(precision) : parseFloat(originalAmount).toFixed(precision)
                                  // );
                                  setAmount(
                                    localStorage.getItem("selectedReturnType") === "EXCHANGE"
                                      ? (
                                          parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")).total : cart.total) +
                                          parseFloat(localStorage.getItem("exchangeCartObj") ? JSON.parse(localStorage.getItem("exchangeCartObj")).total : 0)
                                        ).toFixed(precision)
                                      : pm.roundOffForPos === "Y" && pm.integratedPayment === false
                                        ? roundedAmount.toFixed(precision)
                                        : parseFloat(originalAmount).toFixed(precision)
                                  );
                                  setSelectedPaymentMethod(pm);
                                  if (pm.isWallet === "Y") {
                                    walletFunc();
                                  }
                                  if (pm.isBankTransfer === "Y") {
                                    bankTransferFunc();
                                  }
                                  if (
                                    pm.name.toLowerCase() === "card" &&
                                    !pm.integratedPayment &&
                                    posConfig?.enablePaymentData === "Y" &&
                                    posConfig?.show_card_payment_popup !== "Y"
                                  ) {
                                    setIsCardPaymentFlag(true);
                                  }
                                  // const currenciesList = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                  // const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

                                  // // let originalAmount = Math.abs(cart.total) - cart.paid ?? 0;
                                  // let originalAmount = Math.abs(cart.total) - (cart.paid ?? 0);

                                  // // Get the smallest denomination (assuming sorted list)
                                  // const smallestDenomination = currenciesList.length > 0 ? currenciesList[0].value : 1;

                                  // // Round the amount to the nearest multiple of the smallest denomination
                                  // let roundedAmount = Math.ceil(originalAmount / smallestDenomination) * smallestDenomination;

                                  // // Calculate overpayment
                                  // let overpayment = (roundedAmount - originalAmount).toFixed(precision);
                                  // setOverPayedAmount(pm.roundOffForPos === "Y" && pm.integratedPayment === false ? overpayment : 0);
                                  // // setAmount(
                                  // //   pm.roundOffForPos === "Y" && pm.integratedPayment === false ? roundedAmount.toFixed(precision) : parseFloat(originalAmount).toFixed(precision)
                                  // // );
                                  // setAmount(
                                  //   localStorage.getItem("selectedReturnType") === "EXCHANGE"
                                  //     ? (
                                  //         parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")).total : cart.total) +
                                  //         parseFloat(localStorage.getItem("exchangeCartObj") ? JSON.parse(localStorage.getItem("exchangeCartObj")).total : 0)
                                  //       ).toFixed(precision)
                                  //     : pm.roundOffForPos === "Y" && pm.integratedPayment === false
                                  //       ? roundedAmount.toFixed(precision)
                                  //       : parseFloat(originalAmount).toFixed(precision)
                                  // );
                                  // setSelectedPaymentMethod(pm);
                                  paymentModalInputRef?.current?.focus();
                                  setTimeout(() => {
                                    paymentModalInputRef?.current?.select();
                                  }, 50);
                                } else if (pm.name === "Complete Order" && cart.paid >= cart.total) {
                                  processOrder();
                                }
                                setShowInputFields(false);
                              }}
                              id={`sm-payment-${pm.name.toLowerCase()}`}
                              ref={ind === 0 ? paymentCardRef : null}
                              style={{
                                backgroundColor: pm.name === "Complete Order" ? "#2F3856" : themeJSON.paymentMethodsBGColor || "#046307C2",
                                border: `1px solid ${themeJSON.paymentMethodsBGColor || "#fff"}`,
                                borderRadius: "7px",
                                height: "8.6vh",
                                width: "100%",
                                cursor: "pointer",
                              }}
                              tabIndex={0}
                              onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "row",
                                  position: "relative",
                                  fontSize: "1vw",
                                }}
                              >
                                {pm?.finPaymentmethodId === selectedPaymentMethod?.finPaymentmethodId ? (
                                  <img
                                    src={ticSelect}
                                    style={{
                                      top: "-2vh",
                                      right: "0",
                                      height: "2.1vh",
                                      position: "absolute",
                                    }}
                                  />
                                ) : null}
                                <span className="payment" style={{ color: "#fff", fontSize: "1em" }}>
                                  {pm.name.toLowerCase() === "cash" ? (
                                    <>
                                      {currenciesList[0] ? currenciesList[0].currSymbol : ""}
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "card" ? (
                                    <>
                                      <img src={cardType} style={{ height: "2.5vh" }} color={"#fff"} />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "upi" ? (
                                    <>
                                      <img src={UPI} style={{ height: "2.5vh" }} color={"#fff"} />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "credit" ? (
                                    <>
                                      <img src={Credit} style={{ height: "2.5vh" }} color={"#fff"} />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "loyalty" ? (
                                    <>
                                      <img
                                        src={Loyality}
                                        style={{
                                          height: "2.5vh",
                                          left: "0.5em",
                                        }}
                                        color={"#fff"}
                                      />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "gift card" ? (
                                    <>
                                      <img
                                        src={Gift}
                                        style={{
                                          height: "2.5vh",
                                          marginBottom: "0.2em",
                                        }}
                                        color={"#fff"}
                                      />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "voucher" ? (
                                    <>
                                      <img
                                        src={giftVoucher}
                                        style={{
                                          height: "2.5vh",
                                          marginBottom: "0.2em",
                                        }}
                                        color={"#fff"}
                                      />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "credit note" ? (
                                    <>
                                      <img src={creditNote} style={{ height: "2.5vh" }} color={"#fff"} />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.isWallet === "Y" ? (
                                    <>
                                      <img
                                        src={walletWhite}
                                        style={{
                                          height: "2.5vh",
                                          marginBottom: "0.2em",
                                        }}
                                        color={"#fff"}
                                      />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : (
                                    <>{pm.name}</>
                                  )}
                                </span>
                              </div>
                            </button>
                          </Col>
                        );
                      })}

                      {cart?.layAway === "Y" && posConfig?.advanceLayaway === "Y" && cart?.preOrder !== "Y" && posConfig?.enablePreOrder !== "Y" ? (
                        <Col
                          span={8}
                          onClick={() => {
                            if (posConfig?.requirePaymentForAdvance === "Y" && cart.paid <= 0) {
                              message.warning(`${messages.warnings.payment.payment_required}`);
                              return;
                            }
                            if (cart.paid <= cart.total) {
                              cart.statusType = "layAway";
                              localStorage.setItem("cartObj", JSON.stringify(cart));
                              const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                              const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);

                              const isCashPayment = selectedPaymentMethod?.name?.toLowerCase() === "cash";
                              const isValidCashAmount = parseFloat(amount) % 0.25 === 0;

                              if (cart?.advancePayment > 0 && parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                                if (result !== 0 && isCashPayment) {
                                  message.warning(`${t("cash_payment_error")}`);
                                } else {
                                  processOrder("layaway");
                                }
                              } else {
                                processOrder("layaway");
                              }
                            }
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "#2F3856",
                              border: "1px solid #fff",
                              borderRadius: "7px",
                              height: "8.6vh",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",
                                color: "#fff",
                              }}
                            >
                              Create Advance
                            </div>
                          </button>
                        </Col>
                      ) : null}

                      {showPayments.length < filteredPaymentMethods.length && (
                        <Col span={8}>
                          <button
                            onClick={isShowingAll ? showPreviousItems : showMoreItems}
                            style={{
                              backgroundColor: "#046307C2",
                              border: "1px solid #fff",
                              borderRadius: "7px",
                              height: "8.6vh",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",
                              }}
                            >
                              <img style={{ height: "2.5vh", left: "0.5em" }} color={"#fff"} />
                              <span className="payment" style={{ color: "#fff", marginLeft: "0.25em" }}>
                                ...
                              </span>
                            </div>
                          </button>
                        </Col>
                      )}
                    </Row>
                    <div
                      style={{
                        background: "#fff",
                        height: "23vh",
                        width: "95%",
                        margin: "0.75% 1% 2.7% 3.5%",
                        border: "1px solid #fff",
                        borderRadius: "7px",
                      }}
                    >
                      <Row
                        style={{
                          height: "3vh",
                          marginTop: "3%",
                          fontSize: "1vw",
                        }}
                      >
                        <Col span={12} style={styles.screenStyles.mainScreen.card}>
                          <p style={{ margin: "0" }}>Amount Tendered</p>
                        </Col>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "1vw",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                              fontSize: "1em",
                            }}
                          >
                            {/* {parseFloat(cart.total).toFixed(pricePrecision)} */}
                            {(() => {
                              const isExchangeMode = localStorage.getItem("selectedReturnType") === "EXCHANGE";
                              if (isExchangeMode) {
                                const exchangeCartData = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
                                return parseFloat(exchangeCartData?.paid || 0).toFixed(pricePrecision);
                              }
                              return parseFloat(cart.total).toFixed(pricePrecision);
                            })()}
                          </p>
                        </Col>
                      </Row>

                      <Row style={{ height: "3vh", fontSize: "1vw" }}>
                        <Col span={12} style={styles.screenStyles.mainScreen.card}>
                          <p style={{ margin: "0" }}>Change</p>
                        </Col>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "1vw",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                              fontSize: "1em",
                            }}
                          >
                            {(cart.paid ?? 0) + parseFloat(amount) - Math.abs(cart.total) > 0
                              ? ((cart.paid ?? 0) + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                              : cart?.change <= 0
                                ? "0.00"
                                : cart?.change}
                          </p>
                        </Col>
                      </Row>

                      <Row style={{ height: "3vh", fontSize: "1vw" }}>
                        <Col span={12} style={styles.screenStyles.mainScreen.card}>
                          <p style={{ margin: "0" }}>Overpayment</p>
                        </Col>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "1vw",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                              fontSize: "1em",
                            }}
                          >
                            {Math.abs(overPayedAmount).toFixed(pricePrecision)}
                          </p>
                        </Col>
                      </Row>

                      <Row style={{ height: "3vh", fontSize: "1vw" }}>
                        <Col span={12} style={styles.screenStyles.mainScreen.card}>
                          <p style={{ margin: "0" }}>Remaining Due</p>
                        </Col>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "1vw",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                              fontSize: "1em",
                            }}
                          >
                            {/* {parseFloat(Math.abs(cart.total)) >= parseFloat(cart.paid) ? parseFloat(Math.abs(cart.total) - cart.paid).toFixed(pricePrecision) : 0} */}
                            {(() => {
                              const effectiveTotal = isExchange
                                ? Math.abs((JSON.parse(localStorage.getItem("exchangeCartObj") || "{}")?.total || 0) + (cart?.total || 0)) // net of exchange + return
                                : Math.abs(cart.total);
                              const effectivePaid = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj") || "{}")?.paid || 0 : cart.paid;
                              return effectiveTotal >= effectivePaid ? parseFloat(effectiveTotal - effectivePaid).toFixed(pricePrecision) : 0;
                            })()}
                          </p>
                        </Col>
                      </Row>
                      <hr style={{ margin: "1vh 1vw" }} />
                      <Scrollbars style={{ height: "6.3vh" }}>
                        {cart?.advancePayment > 0 &&
                          cart.layAway === "Y" &&
                          cart?.paymentData?.map((item) => {
                            return (
                              <Row style={{ fontSize: "1vw" }}>
                                <Col
                                  span={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingLeft: "0.8vw",
                                    fontWeight: "450",
                                    textAlign: "left",
                                  }}
                                >
                                  <p style={{ margin: "0" }}>
                                    {item.name.toLowerCase() === "card" && item.authorizationCode ? `${item.name} - ${item.authorizationCode}` : item.name}
                                  </p>
                                </Col>
                                <Col
                                  span={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingRight: "1vw",
                                    textAlign: "right",
                                    justifyContent: "end",
                                  }}
                                >
                                  {/* {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                          &nbsp; */}
                                  <p
                                    style={{
                                      textAlign: "right",
                                      margin: "0",
                                      fontWeight: "500",
                                      paddingRight: "1.2vw",
                                    }}
                                  >
                                    {" "}
                                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                    &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                  </p>
                                </Col>
                              </Row>
                            );
                          })}
                        {renderPaymentsData()}
                      </Scrollbars>
                    </div>
                    <Row style={{ margin: "0 0 0 0 " }}>
                      <Input
                        className="productSearch sm-payment-search totalInput"
                        style={{
                          borderRadius: "0.5vw",
                          height: "7.3vh",
                          margin: "0 1% 2.7% 3.5%",
                          borderRadius: "5px",
                          textAlign: "right",
                          fontWeight: "500",
                          fontSize: "2.5em",
                          borderColor: "#fff",
                          color: "#2F3856",
                        }}
                        // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
                        value={amount}
                        // type="number"
                        id="sm-total-amount-input"
                        onChange={onChangeAmount}
                        placeholder="Enter Amount"
                        ref={paymentModalInputRef}
                        onFocus={() => {
                          setIsInputFocused(true);
                        }}
                        onBlur={() => {
                          setIsInputFocused(false);
                        }}
                        readOnly={cart.items.length > 0 ? false : true}
                        disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : false}
                        onPressEnter={() =>
                          handlePayment({
                            selectedPaymentMethod,
                            cart,
                            amount,
                            posConfig,
                            tillData,
                            isOnline,
                            isExchange,
                            showConfirm,
                            requestPayment,
                            processOrder,
                            setShowCardPaymnteModal,
                            setPaymentType,
                            setCardPaymnetError,
                            messages,
                            isCardPaymentFlag,
                            enableGiftCardCheck: false,
                            enablePoleDisplay: false,
                            enableSetNumb: false,
                          })
                        }
                      />
                    </Row>
                    {denaminationsKeyboard && selectedPaymentMethod?.name?.toLowerCase() === "cash" ? (
                      <Row style={{ padding: "0 1% 0 3.5%" }}>
                        <Col span={18}>
                          <Row gutter={[8, 5]} style={{ display: "flex", flexDirection: "row-reverse" }}>
                            {currenciesData.map((currency) => (
                              <Col span={8}>
                                <button
                                  id={`sm-amount-button${currenciesData.indexOf(currency) + 1}`}
                                  className="amt-dial-btn-market"
                                  onClick={() => handleCashPayment(currency.value)}
                                  disabled={currency.value === 999999}
                                  style={{
                                    color: currency.value !== 999999 ? "#0f0718" : "transparent",
                                  }}
                                >
                                  {currency.value}
                                </button>
                              </Col>
                            ))}
                          </Row>
                        </Col>

                        <Col span={6}>
                          <Row style={{ padding: "0 0 7% 7%" }}>
                            <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                              <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                            </button>
                          </Row>
                          <Row style={{ padding: "0 0 7% 7%" }}>
                            <button id="sm-amount-buttonClear" className="amt-dial-btn-market" onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}>
                              1,2,3...
                            </button>
                          </Row>
                          <Row style={{ padding: "0 0 0 7%" }}>
                            <button
                              id="sm-amount-buttonEnter"
                              className="amt-dial-btn-market2"
                              onClick={() =>
                                handlePayment({
                                  selectedPaymentMethod,
                                  cart,
                                  amount,
                                  posConfig,
                                  tillData,
                                  isOnline,
                                  isExchange,
                                  showConfirm,
                                  requestPayment,
                                  processOrder,
                                  setShowCardPaymnteModal,
                                  setPaymentType,
                                  setCardPaymnetError,
                                  messages,
                                  enableGiftCardCheck: true,
                                  enablePoleDisplay: true,
                                  CWHardwareController,
                                  CWPoleDisplay,
                                  PoleDisplay,
                                })
                              }
                            >
                              Enter
                            </button>
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                        <Col span={6}>
                          <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("1")}>
                            1
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("2")}>
                            2
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("3")}>
                            3
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                            <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("4")}>
                            4
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("5")}>
                            5
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("6")}>
                            6
                          </button>
                        </Col>
                        <Col span={6}>
                          <button
                            id="sm-amount-buttonClear"
                            className="amt-dial-btn-market"
                            style={{ background: themeJSON?.keyBoardColor }}
                            onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}
                          >
                            1,2,3...
                          </button>
                        </Col>
                        <Col span={18}>
                          <Row gutter={[8, 6]}>
                            <Col span={8}>
                              <button id="sm-amount-button7" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("7")}>
                                7
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button8" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("8")}>
                                8
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("9")}>
                                9
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("0")}>
                                0
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button00" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("00")}>
                                00
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button." className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount(".")}>
                                .
                              </button>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={6}>
                          <button
                            id="sm-amount-buttonEnter"
                            className="amt-dial-btn-market2"
                            style={{ background: themeJSON?.keyBoardColor }}
                            onClick={() =>
                              handlePayment({
                                selectedPaymentMethod,
                                cart,
                                amount,
                                posConfig,
                                tillData,
                                isOnline,
                                isExchange,
                                showConfirm,
                                requestPayment,
                                processOrder,
                                setShowCardPaymnteModal,
                                setPaymentType,
                                setCardPaymnetError,
                                messages,
                                t,
                                enableGiftCardCheck: true,
                                enablePoleDisplay: false,
                                enableSetNumb: true,
                                setNumb,
                              })
                            }
                          >
                            Enter
                          </button>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Modal
              visible={expandTotals}
              onCancel={() => setExpandTotals(false)}
              closable={true}
              closeIcon={<CloseOutlined style={{ fontSize: "18px" }} />}
              footer={null}
              width="35%"
              title={
                <div
                  style={{
                    fontSize: "1.5vw",
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  Bill Summary
                </div>
              }
              centered
              bodyStyle={{
                padding: "20px",
                background: "#f5f5f5",
                borderRadius: "0 0 8px 8px",
              }}
              maskClosable={false}
            >
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  style={{
                    background: themeJSON.taxAndDiscountSectionBGColor || "#fff",
                    width: "100%",
                    border: "1px solid #e8e8e8",
                    borderRadius: "8px",
                    padding: "15px",
                    fontSize: "1vw",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {[
                    {
                      label: "Subtotal",
                      value: parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj"))?.subTotal : cart.subTotal).toFixed(2),
                    },
                    { label: "Discount", value: parseFloat(cart.discount ? cart.discount : 0).toFixed(2) },
                    { label: "Tax", value: parseFloat(cart.tax).toFixed(2) },
                    {
                      label: "TCS",
                      value: toFixedTruncate(JSON.parse(localStorage.getItem("cartObj"))?.tcs || 0),
                    },
                    // { label: "Service Charges", value: toFixedTruncate(serviceChargeAmount, pricePrecision) },
                    // { label: "Tip", value: toFixedTruncate(tipTotal, pricePrecision) },
                    // { label: "Delivery Charges", value: toFixedTruncate(deliveryChargeAmount, pricePrecision) },
                    // { label: "Packing Charges", value: toFixedTruncate(packingChargeAmount, pricePrecision) },
                    { label: "Net Value", value: parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")).total : cart.total).toFixed(2) },
                    { label: "Total Items / Total Qty", value: `${cart.items.length} / ${parseFloat(cart.totalQty).toFixed(2)}`, noCurrency: true },
                  ].map((item, index) => (
                    <Row key={index} style={{ padding: "10px 0", borderBottom: index < 8 ? "1px solid #e8e8e8" : "none" }}>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "10px",
                          textAlign: "left",
                          fontWeight: "500",
                          color: "#0F0718",
                          fontSize: "1vw",
                        }}
                      >
                        <p style={{ margin: 0, ...styles.screenStyles.mainScreen.subTotalText }}>{item.label}:</p>
                      </Col>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          paddingRight: "10px",
                          color: "#0F0718",
                          fontWeight: "500",
                          fontSize: "1vw",
                        }}
                      >
                        {!item.noCurrency && <span>{currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}</span>}
                        <p style={{ margin: "0 5px", textAlign: "right" }}>{item.value}</p>
                        {!item.noCurrency && <span>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>}
                      </Col>
                    </Row>
                  ))}
                </div>
              </div>
            </Modal>

            <Drawer
              placement="bottom"
              height="75vh"
              title={null}
              closeIcon={null}
              className="filter"
              headerStyle={{ height: 0 }}
              bodyStyle={{ paddingTop: 0 }}
              visible={isProductsVisible}
              closable={true}
              onClose={closeProductPanel}
              footer={null}
            >
              <Row
                style={{
                  paddingTop: isQtyUpdate ? 0 : "1.7%",
                  width: "100%",
                  paddingLeft: "1vw",
                }}
              >
                <ProductPanelSM
                  checkIsManualWeight={checkIsManualWeight}
                  setIsSearchProducts={setIsSearchProducts}
                  getMoreProducts={getMoreProducts}
                  productItems={productItems}
                  setProductItems={setProductItems}
                  selectProductInCart={selectProductInCart}
                  setProductArray={setProductArray}
                  isProductsFilter={isProductsFilter}
                  getSearchedProducts={getSearchedProducts}
                  productListCardRef={productListCardRef}
                  productsDisplay={productsDisplay}
                  setIsProductsVisible={setIsProductsVisible}
                  pickProduct={pickProduct}
                  filterDrawer={filterDrawer}
                  setFilterDrawer={setFilterDrawer}
                  productSearchInput={productSearchInput}
                  setProductSearchInput={setProductSearchInput}
                  setOpen={setOpen}
                  keyboardType={keyboardType}
                  setKeyboardType={setKeyboardType}
                  productSearchInputRef={productSearchInputRef}
                  clearProductSearchResults={clearProductSearchResults}
                  productsData={productsData}
                  isProductsVisible={isProductsVisible}
                  productSearchRef={productSearchRef}
                  handleSelectProduct={handleSelectProduct}
                  productsList={productsList}
                  setProductsList={setProductsList}
                  setLayoutName={setLayoutName}
                  productPanelSearchRef={productPanelSearchRef}
                  setInputName={setInputName}
                  keyboard={keyboard}
                  searchInputRef={searchInputRef}
                  stockList={stockList}
                  setStockList={setStockList}
                  selectedProductInCart={selectedProductInCart}
                  setCart={setCart}
                />
              </Row>
            </Drawer>
            {isQtyUpdate ? (
              <QuantityUpdate
                selectedProductInCart={selectedProductInCart}
                addProduct={addProduct}
                setIsQtyUpdate={setIsQtyUpdate}
                isQtyUpdate={isQtyUpdate}
                increaseProductQty={increaseProductQty}
                decreaseProductQty={decreaseProductQty}
                removeProductModal={removeProductModal}
                setIsSearchProducts={setIsSearchProducts}
              />
            ) : (
              ""
            )}
            <ProductPanelSM
              checkIsManualWeight={checkIsManualWeight}
              setIsSearchProducts={setIsSearchProducts}
              getMoreProducts={getMoreProducts}
              productItems={productItems}
              setProductItems={setProductItems}
              selectProductInCart={selectProductInCart}
              setProductArray={setProductArray}
              isProductsFilter={isProductsFilter}
              getSearchedProducts={getSearchedProducts}
              productListCardRef={productListCardRef}
              productsDisplay={productsDisplay}
              setIsProductsVisible={setIsProductsVisible}
              pickProduct={pickProduct}
              filterDrawer={filterDrawer}
              setFilterDrawer={setFilterDrawer}
              productSearchInput={productSearchInput}
              setProductSearchInput={setProductSearchInput}
              setOpen={setOpen}
              keyboardType={keyboardType}
              setKeyboardType={setKeyboardType}
              productSearchInputRef={productSearchInputRef}
              clearProductSearchResults={clearProductSearchResults}
              productsData={productsData}
              productSearchRef={productSearchRef}
              handleSelectProduct={handleSelectProduct}
              productsList={productsList}
              setProductsList={setProductsList}
              setLayoutName={setLayoutName}
              productPanelSearchRef={productPanelSearchRef}
              setInputName={setInputName}
              keyboard={keyboard}
              searchInputRef={searchInputRef}
              stockList={stockList}
              setStockList={setStockList}
              selectedProductInCart={selectedProductInCart}
              setCart={setCart}
            />
            {/* <Drawer
              placement="bottom"
              height="53vh"
              title={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "2vh",
                    fontSize: "1vw",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.5em",
                      marginTop: "3vh",
                      fontWeight: "500",
                      color: "#0F0718",
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    {selectedProductForNotes !== null ? "Add Notes for Item" : "Add Notes for Order"}
                  </p>
                  <img
                    src={Close}
                    onClick={() => {
                      setNotesPopup(false);
                      setIsInputFocused(false);
                    }}
                    // style={{ marginLeft: "auto", paddingBottom: "4vh", cursor: "pointer" }}
                    style={{
                      marginLeft: "auto",
                      paddingBottom: "4vh",
                      paddingTop: "2vh",
                      cursor: "pointer",
                      width: "1.5vw",
                    }}
                  />
                </div>
              }
              closeIcon={null}
              className="filter"
              bodyStyle={{ paddingTop: 0 }}
              visible={notesPopup}
              closable={true}
              onClose={() => {
                setNotesPopup(false);
                setIsInputFocused(false);
              }}
              footer={null}
            >
              <Row style={{ padding: "0 5vw", fontSize: "1vw" }}>
                <Col span={11}>
                  <TextArea
                    id="notes-input"
                    ref={notesInputRef}
                    style={{ resize: "none" }}
                    maxLength={200}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => onChangeInputKeyboard(e)}
                    value={notesValue}
                    rows={11}
                  />
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontSize: "0.8em",
                      color: "#929098",
                      fontWeight: 500,
                    }}
                  >
                    Max Characters : 200
                  </span>
                </Col>
                <Col span={12} offset={1}>
                  <Keyboard
                    theme={"hg-theme-default aprvl"}
                    onChange={(input) => onChange(input)}
                    keyboardRef={(r) => (keyboardRef.current = r)}
                    onKeyPress={(button) => {
                      if (button === "{shift}" || button === "{lock}") handleShift();
                      if (button === "{number}") {
                        setLayoutName("number");
                      }
                      if (button === "{numbers}") {
                        setLayoutName("numbers");
                      }
                      if (button === "{small}") {
                        setLayoutName("shift");
                      }
                      if (button === "{caps}") {
                        setLayoutName("default");
                      }
                      if (button === "{enter}") {
                        onAddNotes();
                      }
                    }}
                    layoutName={layoutName}
                    display={{
                      "{abc}": "ABC",
                      "{smileys}": "\uD83D\uDE03",
                      "{back}": "Enter",
                      "{numbers}": "123",
                      "{number}": "123",
                      "{bksp}": "backspace",
                      "{backspace}": "⌫",
                      "{shift}": "⇧",
                      "{tab}": "tab",
                      "{lock}": "lock",
                      "{enter}": "Enter",
                      "{space}": "Space",
                      "{caps}": "ABC",
                      "{small}": "abc",
                    }}
                    layout={{
                      shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                      numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                      number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                      default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
                    }}
                  />
                </Col>
              </Row>
            </Drawer> */}
            {/* Cash Management modal end */}
            <RetailModals
              {...props}
              selectBagRef={selectBagRef}
              offersDrawerOpen={offersDrawerOpen}
              setOffersDrawerOpen={setOffersDrawerOpen}
              setOnlineBatches={setOnlineBatches}
              onlineBatches={onlineBatches}
              fetchOnlineBatches={fetchOnlineBatches}
            />
          </div>
          <div
            style={{
              backgroundColor: colorVariable ? colorVariable : "#f3f4f9",
              height: "100vh",
              width: "100%",
              display: isLocked ? "block" : "none",
            }}
          >
            {/* <div style={{display:"grid",marginTop:"3rem",position:"relative"}}>
            <div style={{maxWidth:"27rem",margin:"0 auto",background:"#fff",border:'1px solid #e2e2e2'}}>
               <img src={LockScreen} alt="" />
              <Row >
                <Col>
                <label >Username</label>
                <Input
                style={{width:"100%"}}
                  // className="mb-4 w-full h-[40px] sm:h-[40px] rounded px-3 py-1 text-[#101828] placeholder:text-[#98A2B3] border-[0.5px] border-[#DaDaDa] text-xs ff-inter font-normal outline-none"
                  // required
                  type="text"
                  // placeholder="Enter Email"
                  // value={email}
                  id="username"
                  name="username"
                  // onChange={(ev) => { setEmail(ev.target.value) }}
                />
                </Col>
              </Row>
            </div>
          </div> */}
            <Row style={{ height: "9vh", background: "", padding: "0.8% 0" }}>
              <Col span={6}>
                <img
                  src={POSLogo}
                  style={{
                    height: "2.8vw",
                    paddingLeft: "1vw",
                    paddingTop: "1vh",
                  }}
                />
              </Col>
              <Col
                span={18}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  paddingRight: "1%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "center",
                    padding: "0.5vw",
                    border: "1px solid #3C424B",
                    borderRadius: "50%",
                  }}
                >
                  <img src={userIcon} style={{ height: "2.7vh" }} />
                </div>
                <span
                  style={{
                    color: "#0F0718",
                    fontSize: "1vw",
                    fontFamily: "Inter",
                    padding: "0 2%",
                    fontWeight: "600",
                    wordWrap: "break-word",
                  }}
                >
                  Till ID : {JSON.parse(localStorage.getItem("tillValue"))?.name}
                </span>
                <div style={{ paddingRight: "2%" }}>
                  <img src={isOnline ? Online : Ofline} style={{ height: "3.5vh", cursor: "pointer" }} /> &nbsp;
                </div>
                {/* <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2vw" }}>{formattedDateTime}</div>
              <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2vw" }}>{clock1}</div> */}
              </Col>
            </Row>
            <Row style={{ paddingTop: "17vh" }}>
              <Col span={8} />
              <Col
                span={8}
                style={{
                  background: "#fff",
                  borderRadius: "5px",
                  height: "45vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 4px 4px 0px #00000033",
                }}
              >
                <img
                  src={LockScreen}
                  style={{
                    marginBottom: "0.2vh",
                    marginTop: "-17vh",
                    width: "25%",
                  }}
                  alt=""
                />
                <span style={{ fontSize: "14px", fontWeight: 400 }}>Screen Locked </span>
                <Form layout="vertical" style={{ width: "80%" }}>
                  <Col style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                    <label style={{ fontWeight: 500, fontSize: "15px" }}>Username</label>
                    <Form.Item>
                      <Input
                        value={userData.user}
                        style={{
                          width: "100%",
                          padding: "10px",
                          fontWeight: 500,
                        }}
                      />
                    </Form.Item>
                  </Col>
                  {/* <Col  style={{ padding: "0 2vw", marginTop: "2.5vh" }}> */}
                  {/* <label style={{fontWeight:500,fontSize:"15px"}}>Password</label>
                    <Form.Item  >
                      <Input value={password} type="password" onPressEnter={() => handleLogin()} onChange={(e)=>{setPassword(e.target.value)}} style={{width:"100%",padding:"10px"}} />
                    </Form.Item>
                  </Col> */}
                  <Col style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                    <Button
                      style={{
                        background: "#2F3856",
                        fontWeight: 500,
                        fontSize: "18px",
                        color: "#fff",
                        width: "100%",
                        height: "7vh",
                        borderRadius: "5px",
                        border: "none",
                      }}
                      onClick={handleLogin}
                    >
                      Log In
                    </Button>
                  </Col>
                </Form>
              </Col>

              <Col span={8} />
            </Row>
          </div>

          <div
            style={{
              backgroundColor: colorVariable || "#f3f4f9",
              height: "100vh",
              width: "100%",
              display: isSectionVisible ? "block" : "none",
              position: "relative",
            }}
          >
            {/* Header Section */}
            <Row style={{ height: "9vh", background: "", padding: "0.8% 0", position: "absolute", width: "100%" }}>
              <Col span={6}>
                <img
                  src={POSLogo}
                  style={{
                    height: "2.8vw",
                    paddingLeft: "1vw",
                    paddingTop: "1vh",
                  }}
                />
              </Col>
              <Col
                span={18}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  paddingRight: "1%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "center",
                    padding: "0.5vw",
                    border: "1px solid #3C424B",
                    borderRadius: "50%",
                  }}
                >
                  <img src={userIcon} style={{ height: "2.7vh" }} />
                </div>
                <span
                  style={{
                    color: "#0F0718",
                    fontSize: "1vw",
                    fontFamily: "Inter",
                    padding: "0 2%",
                    fontWeight: "600",
                    wordWrap: "break-word",
                  }}
                >
                  Till ID : {JSON.parse(localStorage.getItem("tillValue"))?.name}
                </span>
                <div style={{ paddingRight: "2%" }}>
                  <img src={isOnline ? Online : Ofline} style={{ height: "3.5vh", cursor: "pointer" }} /> &nbsp;
                </div>
                {/* <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2vw" }}>{formattedDateTime}</div>
              <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2vw" }}>{clock1}</div> */}
              </Col>
            </Row>

            {!showOrderSelection ? (
              <div
                style={{
                  height: "100vh",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px", // Add gap between columns
                    marginBottom: "20px",
                    width: "100%",
                  }}
                >
                  {[
                    {
                      title: "Sales Quotation",
                      desc: "Create a new price quote for a customer",
                      btnText: "Create Quotation",
                    },
                    {
                      title: "Sales Order",
                      desc: "Create a new customer order",
                      btnText: "Create Order",
                    },
                  ].map((card, index) => (
                    <Col key={index} xs={24} sm={12} md={6}>
                      <div
                        style={{
                          background: "white",
                          padding: "1.1rem",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          height: "25vh", // Increase height slightly for better spacing
                          position: "relative",
                          display: "flex",
                          width: "25vw",
                          flexDirection: "column",
                          justifyContent: "space-between", // Push button to bottom
                        }}
                      >
                        <div>
                          <h3 style={{ fontSize: "1.2rem", fontWeight: "600", margin: 0 }}>{card.title}</h3>
                          <p style={{ fontSize: "0.7rem", color: "#666" }}>{card.desc}</p>
                        </div>
                        <button
                          style={{
                            background: "#242B3A",
                            color: "white",
                            padding: "7px 20px",
                            border: "none",
                            borderRadius: "3px",
                            cursor: "pointer",
                            width: "100%",
                          }}
                          onClick={() => setShowOrderSelection(true)}
                        >
                          {card.btnText}
                        </button>
                      </div>
                    </Col>
                  ))}
                </Row>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    gap: "20px", // Add gap between columns
                  }}
                >
                  {[
                    {
                      title: "Sales Invoice",
                      desc: "Generate a new invoice for completed orders",
                      btnText: "Create Invoice",
                    },
                    {
                      title: "Proforma Invoice",
                      desc: "Create a preliminary invoice for estimates",
                      btnText: "Create Proforma Invoice",
                    },
                  ].map((card, index) => (
                    <Col key={index} xs={24} sm={12} md={6}>
                      <div
                        style={{
                          background: "white",
                          padding: "1.1rem",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          height: "25vh", // Increase height slightly for better spacing
                          position: "relative",
                          display: "flex",
                          width: "25vw",
                          flexDirection: "column",
                          justifyContent: "space-between", // Push button to bottom
                        }}
                      >
                        <div>
                          <h3 style={{ fontSize: "1.2rem", fontWeight: "600", margin: 0 }}>{card.title}</h3>
                          <p style={{ fontSize: "0.7rem", color: "#666" }}>{card.desc}</p>
                        </div>
                        <button
                          style={{
                            background: "#242B3A",
                            color: "white",
                            padding: "7px 20px",
                            border: "none",
                            borderRadius: "3px",
                            cursor: "pointer",
                            width: "100%",
                          }}
                        >
                          {card.btnText}
                        </button>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            ) : (
              <Row justify="center" align="middle" style={{ height: "100vh" }}>
                <Col xs={22} sm={16} md={12} lg={10} xl={8}>
                  <h2 style={{ textAlign: "left", marginBottom: "20px" }}>Create Sales Invoice</h2>
                  <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item name="customerName" label="Customer Name" style={{ marginBottom: "15px" }} rules={[{ required: false, message: "Please enter the customer name" }]}>
                      <Input />
                    </Form.Item>

                    <Form.Item name="email" label="Email" style={{ marginBottom: "15px" }} rules={[{ type: "email", message: "Please enter a valid email" }]}>
                      <Input />
                    </Form.Item>

                    <Form.Item name="phone" label="Phone Number" style={{ marginBottom: "15px" }} rules={[{ required: false, message: "Please enter the phone number" }]}>
                      <Input />
                    </Form.Item>

                    <Form.Item name="address" label="Address" style={{ marginBottom: "15px" }}>
                      <Input.TextArea />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        onClick={() => {
                          setShowOrderSelection(true);
                          setIsSectionVisible(false);
                        }}
                        style={{ width: "11vw", backgroundColor: "#242B3A", color: "#fff", textAlign: "center" }}
                        htmlType="submit"
                        block
                      >
                        Next: Add Items
                      </Button>
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            )}
          </div>
        </>
      ) : (
        <>
          <LoadingScreen
            colorVariable={colorVariable}
            POSLogo={POSLogo}
            formattedDateTime={formattedDateTime}
            clock1={clock1}
            leftLoading={leftLoading}
            percent={percent}
            productCategoryPercentage={productCategoryPercentage}
            productPercentage={productPercentage}
            promotionPercentage={promotionPercentage}
          />
        </>
      )}

      {open && showVirtualKeyboard && (
        <Drawer placement="bottom" closable={false} bodyStyle={{ paddingBottom: 0 }} onClose={onClose} height="47vh" visible={open && showVirtualKeyboard} mask={false}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
            <img
              src={Close}
              onClick={() => {
                setOpen(false);
                setLayoutName("default");
              }}
              style={{
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
          <div style={{ padding: "0 5vw" }}>
            <Keyboard
              keyboardRef={(r) => {
                keyboard.current = r;
              }}
              layoutName={layoutName}
              onChangeAll={(inputs) => {
                updateKeyboardInputs(inputs);
              }}
              onKeyPress={onKeyPress}
              inputName={inputName}
              display={{
                "{bksp}": "⌫",
                "{numbers}": "123",
                "{shift}": "⇧",
                "{enter}": "Enter",
                "{space}": "Space",
                "{number}": "123",
                "{caps}": "ABC",
                "{small}": "abc",
              }}
              layout={{
                shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} @ {space} . {enter}"],
                numbers: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{caps} {space} {enter}"],
                number: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{small} {space} {enter}"],
                default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} @ {space} . {enter}"],
              }}
            />
          </div>
        </Drawer>
      )}

      <Drawer
        placement="left"
        width="20%"
        closable={false}
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={POSLogo} style={{ height: "2vw" }} />
            {/* <p style={{ fontSize: "2vw", paddingTop: "3vh", fontWeight: "500", color: "#2F3856", flex: 1, textAlign: "center" }}>Add Discount</p> */}
            <img
              src={Close}
              onClick={() => {
                (setTillLink(false), setActiveInput("search"));
                if (searchInputRef?.current) {
                  searchInputRef?.current.focus();
                }
              }}
              // style={{ marginLeft: "auto", paddingBottom: "5vh", cursor: "pointer" }}
              style={{
                marginLeft: "auto",
                // paddingBottom: "4vh",
                paddingTop: "2vh",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
        }
        bodyStyle={{ paddingTop: 0 }}
        visible={tillLink}
        onClose={() => {
          (setTillLink(false), setActiveInput("search"));
          if (searchInputRef?.current) {
            searchInputRef?.current.focus();
          }
        }}
      >
        <Row gutter={[16, 16]} style={{ fontSize: "1vw" }}>
          <Col span={24}>
            <Scrollbars style={{ height: "80vh" }}>
              <Row>
                <Col
                  span={1}
                  style={{
                    cursor: "pointer",
                    display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                  }}
                />
                <Col
                  onClick={tillUnlink}
                  style={{
                    cursor: "pointer",
                    display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                    marginBottom: "2vh",
                  }}
                  span={22}
                >
                  <img src={unlinkTillIcon} style={{ height: "2.5vh" }} alt="" />
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "1.2em",
                      paddingLeft: "1vw",
                      color: "#0F0718",
                    }}
                  >
                    Unlink Till
                  </span>
                </Col>
                <Col
                  span={1}
                  style={{
                    cursor: "pointer",
                    display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                  }}
                />
                {enableProduction ? (
                  <Row>
                    {" "}
                    <Col
                      span={1}
                      style={{
                        cursor: "pointer",
                        display: "block",
                      }}
                    />
                    <Col
                      onClick={() => {
                        window.location.reload();
                      }}
                      style={{
                        cursor: "pointer",
                        display: "block",
                        marginBottom: "2vh",
                      }}
                      span={22}
                    >
                      <RedoOutlined />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Refresh
                      </span>
                    </Col>
                  </Row>
                ) : (
                  <>
                    <Col span={1} />
                    <Col
                      style={{ cursor: "pointer", marginBottom: "2vh" }}
                      span={22}
                      onClick={() => {
                        if (cart.items.length > 0 && cart.isReturn !== true) {
                          setCouponModalVisible(true);
                          setTillLink(false);
                          setCouponInput("");
                        } else {
                          message.error(`${messages.errors.coupons.coupon_not_applied}`);
                        }
                      }}
                    >
                      <img src={couponIcon} style={{ height: "2.5vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          paddingTop: "0.3vh",
                          color: "#0F0718",
                        }}
                      >
                        Coupon Code
                      </span>
                    </Col>
                    <Col span={1} />
                    <Col span={1} />
                    <Col
                      onClick={async () => {
                        if (cart.items.length > 0) {
                          const { workflowRules, approvers } = await getWorkflowData();
                          // Check if workflowRules exist
                          if (workflowRules && workflowRules.length > 0) {
                            // If workflowRules exist, iterate over them
                            workflowRules.forEach((res) => {
                              if (res.eventName === "Print Draft bill") {
                                setTillLink(false);
                                dispatchEvent(res.eventName, res.ruleName, res.ruleCondition, approvers, null, (eventData) => {
                                  if (eventData?.approvalGranted) {
                                    let updatedCart = { ...cart, orderTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), draftFlag: true };
                                    printController(updatedCart);
                                  }
                                });
                              }
                            });
                          } else {
                            // If workflowRules do not exist, execute some other logic
                            let updatedCart = { ...cart, orderTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), draftFlag: false };
                            printController(updatedCart);
                          }
                        }
                      }}
                      style={{
                        cursor: cart.items.length > 0 && reconstructedObject?.DraftPrint === "Y" ? "pointer" : "not-allowed",
                        marginBottom: "2vh",
                      }}
                      span={22}
                    >
                      <img src={printerIcon} style={{ height: "2.9vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Print
                      </span>
                    </Col>
                    <Col span={1} />
                    <Col
                      span={1}
                      style={{
                        display: tillData?.tillAccess?.layAway === "Y" && selectedSaleTypeData?.cwrSaletype?.enableLayaway === "Y" ? "block" : "none",
                      }}
                    />
                    <Col
                      onClick={() => {
                        if (cart.items.length > 0 && cart?.isReturn !== true) {
                          if (cart.paid === 0 && posConfig?.allowLayawaywithoutPayment === "Y") {
                            upsertPOSLog(cart, "LAY");
                            cart.layAway = "Y";
                            setCart(cart);
                            localStorage.setItem("cartObj", JSON.stringify(cart));
                            setShowPaymentMethods(true);
                            setTillLink(false);
                            processOrder("layaway");
                          }
                          //  else if (cart.paid === 0 && posConfig?.allowLayawaywithoutPayment === "Y") {
                          //   upsertPOSLog(cart, "LAY");
                          //   processOrder("layaway");
                          // }
                        } else if (cart.items.length === 0) {
                        } else {
                          message.error("Layaway isn't supported for returns. Please choose a different option.");
                        }
                      }}
                      style={{
                        cursor: cart.items.length > 0 ? "pointer" : "not-allowed",
                        display: tillData?.tillAccess?.layAway === "Y" ? "block" : "none",
                        marginBottom: "2vh",
                      }}
                      span={22}
                    >
                      <img src={layAwaySvg} style={{ height: "2.5vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Layaway
                      </span>
                    </Col>
                    <Col
                      span={1}
                      style={{
                        display: posConfig?.enableReceiptlessReturn === "Y" ? "block" : "none",
                      }}
                    />
                    <Col
                      onClick={() => {
                        if (isReturnDisabled) return; // 🔥 HARD STOP

                        const posConfigLS = JSON.parse(localStorage.getItem("posConfig"));
                        const walletEnabled = posConfigLS?.enableReceiptlessReturn2 === "Y";

                        // 🔥 WALLET FLOW
                        if (walletEnabled) {
                          if (cart.isReturn === true) return;

                          if (cart.payments.length > 0) {
                            message.error("Payments already added. Cannot process return.");
                            return;
                          }

                          const updatedCart = {
                            ...cart,
                            isReturn: true,
                            isBlindReceipt: true,
                          };

                          setCart(updatedCart);
                          localStorage.setItem("cartObj", JSON.stringify(updatedCart));

                          setTillLink(false);
                          if (posConfig?.allowReturnRefund === "Y" || posConfig?.allowReturnCreditNote === "Y" || posConfig?.allowReturnExchange === "Y") {
                            setShowReturnOptions(true);
                          } else {
                            setFilterDrawer(true);
                          }
                          return;
                        }

                        if (cart.isReturn !== true && cart.items.length > 0 && cart.payments.length === 0) {
                          Modal.confirm({
                            title: "You are about to process a return without a receipt. Would you like to proceed?",
                            icon: null,
                            cancelText: "No",
                            okText: "Yes",
                            autoFocusButton: null,
                            okButtonProps: { style: { display: "inline-block" } },
                            onOk: async () => {
                              setTillLink(false);
                              let updatedCart = { ...cart };

                              updatedCart.total = -updatedCart.total;
                              updatedCart.tax = -updatedCart.tax;
                              updatedCart.isReturn = true;
                              updatedCart.isBlindReceipt = true;
                              updatedCart.totalQty = -updatedCart.totalQty;

                              updatedCart.items = updatedCart.items.map((item) => {
                                let grossUnit = (Math.abs(item.sunitprice) - Math.abs(item.discount)) / Math.abs(item.weight);
                                let newItem = { ...item };

                                newItem.nettotal = -item.nettotal;
                                newItem.weight = -item.weight;
                                newItem.isReturn = true;
                                newItem.sunitprice = -item.sunitprice;
                                newItem.netList = -item.nettotal;
                                newItem.linetax = Math.abs(newItem.nettotal) > 0 ? -parseFloat(item.taxAmount.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)) : 0;
                                newItem.linenet =
                                  Math.abs(newItem.nettotal) > 0
                                    ? -parseFloat((item.nettotal - item.taxAmount).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
                                    : 0;
                                newItem.linegross = Math.abs(newItem.nettotal) > 0 ? parseFloat(item.nettotal.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)) : 0;
                                newItem.netStd = -item.netStd;
                                newItem.listPrice = Math.abs(newItem.nettotal) > 0 ? -item.listPrice : 0;
                                newItem.grossunit =
                                  Math.abs(newItem.nettotal) > 0
                                    ? item.isReturn
                                      ? -parseFloat(grossUnit.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
                                      : parseFloat(grossUnit.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
                                    : 0;
                                newItem.taxAmount = -item.taxAmount;
                                return newItem;
                              });

                              await setCart(updatedCart);
                              localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                              if (posConfig?.showReason === "Y" || posConfig?.showReferenceNo === "Y" || posConfig?.showRemarks === "Y") {
                                setReasonPopup(true);
                              } else {
                                await handleCartTotalClick();
                              }
                            },
                          });
                        }
                      }}
                      style={{
                        cursor: isReturnDisabled ? "not-allowed" : "pointer",
                        display: shouldShowReturnButton ? "block" : "none",
                        marginBottom: "2vh",
                      }}
                      span={22}
                    >
                      <img src={Discard} style={{ height: "2.7vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Return this Receipt
                      </span>
                    </Col>
                    <Col
                      span={1}
                      style={{
                        display: posConfig?.enableReceiptlessReturn === "Y" ? "block" : "none",
                      }}
                    />
                    <Col
                      span={1}
                      style={{
                        display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                      }}
                    />
                    <Col
                      span={22}
                      onClick={async () => {
                        if (!isOnline) {
                          errorMessage("Sync Failed", "Please check your network connection and try again");
                          return;
                        }

                        setTillLink(false);

                        if (cart.items.length > 0) {
                          message.error("To perform a Full Sync, please clear the cart items!");
                          return;
                        }

                        // ✅ Start Full Sync only if cart is empty
                        localStorage.removeItem("lastUpdatedTime");
                        setSyncLoad(true);

                        const tillData = JSON.parse(localStorage.getItem("tillData"));
                        const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData.customer : tillData?.tillAccess?.csBunit?.b2cCustomer;

                        setCart((prevCart) => ({
                          ...prevCart,
                          customer: defaultCustomer,
                        }));

                        await processSync(tillData, setGlobalStore, "Full Sync");

                        setSyncLoad(false);
                        setGlobalStore({ percent: "0%" });
                        setGlobalStore({ productCategoryPercentage: "0" });
                        setGlobalStore({ productPercentage: "0" });
                        setGlobalStore({ promotionPercentage: "0" });
                        if (parkedList.length > 0) {
                          handleKeyvalue("parked-bill");
                          setIsparkedBill(true);
                        }
                        const saleData = await db.posSaletypes.toArray();
                        const defaultSale = saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
                        localStorage.setItem("saleTypeData", JSON.stringify(defaultSale));
                      }}
                      style={{
                        cursor: "pointer",
                        display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                        marginBottom: "2vh",
                      }}
                    >
                      <img src={SyncSide} style={{ height: "2vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Full Sync
                      </span>
                    </Col>
                    <Col
                      span={1}
                      style={{
                        display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                      }}
                    />
                    <Col
                      span={1}
                      style={{
                        display: tillData?.tillAccess?.salesReport === "Y" ? "block" : "none",
                      }}
                    />
                    <Col
                      onClick={async () => {
                        let ordersData = await db.ordersData.toArray();
                        ordersData = ordersData.filter((data) => data.tillStatus === "open");
                        if (CWHardwareController) {
                          salesReportCWHCPrinter(ordersData);
                        } else {
                          salesReportPrinter(ordersData);
                        }
                      }}
                      style={{
                        cursor: "pointer",
                        display: tillData?.tillAccess?.salesReport === "Y" ? "block" : "none",
                        marginBottom: "2vh",
                      }}
                      span={22}
                    >
                      <img src={salesReportIcon} style={{ height: "2.5vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Sales Report
                      </span>
                    </Col>
                    <Col
                      span={1}
                      style={{
                        display: tillData?.tillAccess?.salesReport === "Y" ? "block" : "none",
                      }}
                    />
                    <Col span={1} />
                    <Col
                      onClick={() => {
                        openDrawer();
                      }}
                      style={{ cursor: "pointer", marginBottom: "2vh" }}
                      span={22}
                    >
                      <img src={openDrawerIcon} style={{ height: "2.5vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Open Drawer
                      </span>
                    </Col>
                    <Col span={1} />
                    {posConfig?.showOffers === "Y" && (
                      <>
                        <Col span={1} />
                        <Col
                          onClick={() => {
                            setTillLink(false); // CLOSE LEFT DRAWER
                            setOffersDrawerOpen(true); // OPEN OFFERS DRAWER
                          }}
                          style={{ cursor: "pointer", marginBottom: "2vh" }}
                          span={22}
                        >
                          <img src={openDrawerIcon} style={{ height: "2.5vh" }} alt="" />
                          <span
                            style={{
                              fontFamily: "Inter",
                              fontWeight: 500,
                              fontSize: "1.2em",
                              paddingLeft: "1vw",
                              color: "#0F0718",
                            }}
                          >
                            Offers
                          </span>
                        </Col>
                        <Col span={1} />
                      </>
                    )}

                    <Col span={1} />
                    <Col
                      onClick={() => posConfig?.dataSyncDashboard === "Y" && tillData.tillAccess.dataSyncMonitor === "Y" && history.push("/dashboard2")}
                      style={{ cursor: posConfig?.dataSyncDashboard === "Y" && tillData.tillAccess.dataSyncMonitor === "Y" ? "pointer" : "not-allowed", marginBottom: "2vh" }}
                      span={22}
                    >
                      <img src={openDrawerIcon} style={{ height: "2.5vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Data Sync Monitor
                      </span>
                    </Col>
                    <Col span={1} />

                    <Col span={1} />
                    <Col
                      onClick={() => {
                        parseInt(cart.total) > 0 && setManualDiscountModalVisible(true);
                      }}
                      style={{ cursor: "pointer", marginBottom: "2vh" }}
                      span={22}
                    >
                      <img src={openDrawerIcon} style={{ height: "2.5vh" }} alt="" />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Discount
                      </span>
                    </Col>
                    <Col span={1} />

                    {posConfig?.enableUAECustomer === "Y" && <Col span={1} />}
                    {posConfig?.enableUAECustomer === "Y" && (
                      <Col
                        onClick={() => {
                          setDisplayUAECustomerSearch(true);
                        }}
                        style={{ cursor: "pointer", marginBottom: "2vh" }}
                        span={22}
                      >
                        <img src={userIcon} style={{ height: "2.5vh" }} alt="" />
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 500,
                            fontSize: "1.2em",
                            paddingLeft: "1vw",
                            color: "#0F0718",
                          }}
                        >
                          UAE Customer
                        </span>
                      </Col>
                    )}
                    {posConfig?.enableUAECustomer === "Y" && <Col span={1} />}
                    {posConfig?.enableProduction === "Y" && <Col span={1} />}
                    {posConfig?.enableProduction === "Y" && (
                      <Col onClick={handleProductionClick} style={{ cursor: "pointer", marginBottom: "2vh" }} span={22}>
                        <img src={productionIcon} style={{ height: "2.5vh", marginBottom: "0.2rem" }} alt="" />
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 500,
                            fontSize: "1.2em",
                            paddingLeft: "1vw",
                            color: "#0F0718",
                          }}
                        >
                          Production Order
                        </span>
                      </Col>
                    )}

                    {posConfig?.enableStockIndent === "Y" && (
                      <Col onClick={() => history.push("/inventory/stock-indent")} style={{ cursor: "pointer", marginBottom: "2vh" }} span={22}>
                        <AppstoreOutlined />
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 500,
                            fontSize: "1.2em",
                            paddingLeft: "1vw",
                            color: "#0F0718",
                          }}
                        >
                          Stock Indent
                        </span>
                      </Col>
                    )}

                    {posConfig?.enablePurchase === "Y" && (
                      <Col onClick={() => history.push("/purchaseOrder")} style={{ cursor: "pointer", marginBottom: "2vh" }} span={22}>
                        <AppstoreOutlined />
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 500,
                            fontSize: "1.2em",
                            paddingLeft: "1vw",
                            color: "#0F0718",
                          }}
                        >
                          Purchase Order
                        </span>
                      </Col>
                    )}
                    <Col span={1} />
                    {posConfig?.enableAggregator === "Y" && (
                      <Col
                        style={{ cursor: "pointer", marginBottom: "2vh" }}
                        span={22}
                        onClick={() => {
                          history.push("/aggregator");
                        }}
                      >
                        <img src={openDrawerIcon} style={{ height: "2.5vh" }} alt="" />
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 500,
                            fontSize: "1.2em",
                            paddingLeft: "1vw",
                            color: "#0F0718",
                          }}
                        >
                          Aggregator
                        </span>
                      </Col>
                    )}
                    {posConfig?.enableEstimate === "Y" && (
                      <Col
                        onClick={() => {
                          deleteReceipt(true);
                          history.push("/estimate");
                        }}
                        style={{ cursor: "pointer", marginBottom: "2vh" }}
                        span={22}
                      >
                        <AppstoreOutlined />
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 500,
                            fontSize: "1.2em",
                            paddingLeft: "1vw",
                            color: "#0F0718",
                          }}
                        >
                          Estimate
                        </span>
                      </Col>
                    )}
                    {posConfig?.enablePreOrder === "Y" && (
                      <Col
                        onClick={() => {
                          deleteReceipt(true);
                          history.push("/preorder");
                        }}
                        style={{ cursor: "pointer", marginBottom: "2vh" }}
                        span={22}
                      >
                        <AppstoreOutlined />
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 500,
                            fontSize: "1.2em",
                            paddingLeft: "1vw",
                            color: "#0F0718",
                          }}
                        >
                          Pre-Order
                        </span>
                      </Col>
                    )}
                    {renderCustomerWallet()}
                    <Col
                      span={1}
                      style={{
                        cursor: "pointer",
                        display: "block",
                      }}
                    />
                    <Col
                      onClick={() => {
                        window.location.reload();
                      }}
                      style={{
                        cursor: "pointer",
                        display: "block",
                        marginBottom: "2vh",
                      }}
                      span={22}
                    >
                      <RedoOutlined />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "1.2em",
                          paddingLeft: "1vw",
                          color: "#0F0718",
                        }}
                      >
                        Refresh
                      </span>
                    </Col>
                  </>
                )}
              </Row>
            </Scrollbars>
          </Col>
          {/* ) : (
            ""
          )} */}
          {/* <Col span={24}>
            <Row>
              <Col span={1} />
              <Col style={{ cursor: "pointer" }} span={22}>
                <img src={couponIcon} style={{ height: "2.5vh" }} alt="" />
                <span style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2vw", paddingLeft: "1vw" }}>Coupon Code</span>
              </Col>
            </Row>
          </Col> */}
          <Col
            span={24}
            style={{
              width: "80%",
              borderTop: "1px solid #929098",
              position: "absolute",
              bottom: "2.5vh",
              padding: "1vh 1vw",
            }}
          >
            <Row>
              <Col span={1} />

              <Col style={{ cursor: logoutLoading ? "not-allowed" : "pointer", paddingTop: "1vh" }} onClick={handleLogout} span={20}>
                <img src={Logout} alt="" />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.2em",
                    color: "#0F0718",
                  }}
                >
                  {logoutLoading ? `Logging out...` : `Logout`}
                </span>
              </Col>
              <Col span={24} style={{ position: "absolute", bottom: "5vh", right: "0" }}>
                <p style={{ color: "#0f071840", textAlign: "right", paddingRight: "1vw", fontSize: "0.6rem", fontWeight: 400 }}>v{version_number}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
      <Drawer
        title={
          <div style={{ display: "flex", fontSize: "1vw", alignItems: "center" }}>
            <p style={{ fontSize: "1.5em", fontWeight: 600, color: "#0F0718", flex: 1 }}>Additional Charges</p>
            <img
              src={Close} // Ensure Close is imported or replace with a valid image path
              onClick={() => {
                //resetToInitialState();
                setAdditionalCharges(false);
              }}
              style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
            />
          </div>
        }
        closable={true}
        maskClosable={false}
        placement="right"
        closeIcon={null}
        visible={additionalCharges}
        width={400} // Increased width for a cleaner look
        onClose={() => {
          //resetToInitialState();
          setAdditionalCharges(false);
        }}
      >
        {/* <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontSize: "15px", fontWeight: 550 }}>% Service Charges</span>
          <Switch checked={serviceChargeEnabled} onChange={(checked) => setServiceChargeEnabled(checked)} style={{ marginRight: "10px" }} />
        </div>
        <div style={{ marginBottom: "20px", display: "flex", alignItems: "center" }}>
          <Select
            value={serviceChargePercentage}
            onChange={(value) => setServiceChargePercentage(value)}
            disabled={!serviceChargeEnabled}
            style={{ width: "80px", marginRight: "10px" }}
          >
            <Option value={5}>5%</Option>
            <Option value={7}>7%</Option>
            <Option value={10}>10%</Option>
            <Option value={12}>12%</Option>
            <Option value={15}>15%</Option>
          </Select>
        </div> */}

        {/* <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", fontSize: "15px", fontWeight: 550 }}>
            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
            Tip
            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
          </p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Select
              value={tipMode}
              onChange={(value) => {
                setTipMode(value); // Handle change for tip mode
                if (value === "Percentage") {
                  setTipPercentage(0);
                  setTipAmount(0);
                } else {
                  setTipPercentage(0);
                  setTipAmount(0);
                }
              }}
              style={{ width: 130, marginRight: "10px" }}
            >
              <Option value="Percentage">Percentage</Option>
              <Option value="Amount">Amount</Option>
            </Select>
            {tipMode === "Percentage" ? (
              <Select value={tipPercentage} onChange={(value) => setTipPercentage(value)} style={{ width: "80px", marginRight: "10px" }}>
                <Option value={0}>0%</Option>
                <Option value={5}>5%</Option>
                <Option value={7}>7%</Option>
                <Option value={10}>10%</Option>
                <Option value={12}>12%</Option>
                <Option value={15}>15%</Option>
              </Select>
            ) : (
              <Input
                value={tipAmount}
                onChange={(e) => setTipAmount(parseFloat(e.target.value) || 0)}
                style={{ width: "100px", textAlign: "right" }}
                prefix={`${currenciesList[0].currSymbol}`}
              />
            )}
          </div>
        </div> */}

        {/* <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <CarOutlined />
            </span>{" "}
            Delivery Charges
          </p>
          <Input
            value={deliveryCharge}
            onChange={(e) => setDeliveryCharge(parseFloat(e.target.value) || 0)}
            style={{ width: "100px", textAlign: "right" }}
            prefix={`${currenciesList[0].currSymbol}`}
          />
        </div> */}
        {/* 
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <GiftOutlined />
            </span>{" "}
            Packing Charges
          </p>
          <Input
            value={packingCharge}
            onChange={(e) => setPackingCharge(parseFloat(e.target.value) || 0)}
            style={{ width: "100px", textAlign: "right" }}
            prefix={`${currenciesList[0].currSymbol}`}
          />
        </div> */}

        {/* <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <ReloadOutlined />
            </span>{" "}
            Rounding
          </p>
          <Select value={roundingOption} onChange={(value) => setRoundingOption(value)} style={{ width: "150px" }}>
            <Option value="No Rounding">No Rounding</Option>
            <Option value="Round Up">Round Up</Option>
            <Option value="Round Down">Round Down</Option>
          </Select>
        </div> */}
        <div style={{ height: "calc(100% - 100px)", overflowY: "auto", paddingRight: 8 }}>
          {tempSaleTypeData?.map((charge) => (
            <div key={charge.chargeType} style={{ padding: "10px 0", borderBottom: "1px solid #e8e8e8" }}>
              <span style={{ fontSize: "14px", fontWeight: 600 }}>
                {charge.chargeType === "TCS" ? `TCS - ${(JSON.parse(localStorage.getItem("cartObj"))?.tcs ?? 0).toFixed(2)}` : getChargeLabel(charge, cart)}
              </span>
            </div>
          ))}
        </div>
        {/* <div
    style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      padding: "12px",
      display: "flex",
      justifyContent: "flex-end",
      background: "#fff",
      borderTop: "1px solid #e8e8e8"
    }}
  >
    <Button
      style={{
        backgroundColor: "#fff",
        color: "#2F3856",
        height: "40px",
        width: "100px",
        borderRadius: "5px",
        marginRight: "10px",
      }}
      onClick={() => setAdditionalCharges(false)}
    >
      Cancel
    </Button>

    <Button
      style={{
        backgroundColor: "#2F3856",
        color: "#fff",
        height: "40px",
        width: "140px",
        borderRadius: "5px",
        textAlign: "center",
      }}
      onClick={handleApplyCharges}
    >
      Apply Charges
    </Button>
  </div> */}
      </Drawer>
      <Modal visible={showTcsModal} footer={null} centered onCancel={() => setShowTcsModal(false)}>
        <div style={{ padding: 20, textAlign: "center" }}>
          <h3 style={{ marginBottom: 10 }}>TCS Applied</h3>
          <p style={{ fontSize: "18px", fontWeight: "bold" }}>₹ {tcsModalAmount}</p>
        </div>
      </Modal>
      <Drawer
        placement="bottom"
        height="53vh"
        maskClosable={false}
        title={
          <div style={{ display: "flex", alignItems: "center", height: "2vh" }}>
            <p
              style={{
                fontSize: "2vw",
                marginTop: "3vh",
                fontWeight: "500",
                color: "#0F0718",
                flex: 1,
                textAlign: "center",
              }}
            >
              Reason for Return
            </p>
            <img
              src={Close}
              onClick={() => {
                setReasonPopup(false);
                setIsInputFocused(false);
              }}
              style={{
                marginLeft: "auto",
                paddingBottom: "4vh",
                cursor: "pointer",
              }}
            />
          </div>
        }
        closeIcon={null}
        className="filter"
        bodyStyle={{ paddingTop: 0 }}
        visible={reasonPopup}
        onClose={() => {
          setReasonPopup(false);
          setIsInputFocused(false);
        }}
        footer={null}
      >
        <Form layout="vertical" form={reasonForm} onFinish={onFinish}>
          <Row gutter={16}>
            {posConfig?.showReferenceNo === "Y" ? (
              <Col span={8} offset={4}>
                <Form.Item label="Reference No" name="referenceNo">
                  <Input />
                </Form.Item>
              </Col>
            ) : null}
            {posConfig?.showReason === "Y" ? (
              <Col span={8}>
                <Form.Item label="Reason" name="reason">
                  <Select>
                    {returnReasons?.map((res) => (
                      <Option key={res.returnReasonId} value={res.returnReasonId}>
                        {res.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            ) : null}
            {posConfig?.showRemarks === "Y" ? (
              <Col span={8} offset={4}>
                <Form.Item label="Remarks" name="remarks">
                  <TextArea />
                </Form.Item>
              </Col>
            ) : null}
          </Row>
          <Row>
            <Col span={24} style={{ display: "flex", float: "left", height: "100%" }}>
              <div style={{ flex: 1 }}></div>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    background: "#0F0718",
                    color: "#fff",
                    marginTop: "auto",
                  }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      {/* <Drawer
        placement="bottom"
        height="72vh"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "2vh",
              fontSize: "1vw",
            }}
          >
            <p
              style={{
                fontSize: "1.5em",
                marginTop: "3vh",
                fontWeight: "500",
                color: "#0F0718",
                flex: 1,
                textAlign: "center",
              }}
            >
              Reject Quotation
            </p>
            <img
              src={Close}
              onClick={() => {
                setRejectQuotation(false);
                // setIsInputFocused(false);
              }}
              // style={{ marginLeft: "auto", paddingBottom: "4vh", cursor: "pointer" }}
              style={{
                marginLeft: "auto",
                paddingBottom: "4vh",
                paddingTop: "2vh",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
        }
        closeIcon={null}
        className="filter"
        bodyStyle={{ paddingTop: 0 }}
        visible={rejectQuotation}
        closable={true}
        onClose={() => {
          setRejectQuotation(false);
          // setIsInputFocused(false);
        }}
        footer={null}
      >
        <Row style={{ padding: "0 5vw", fontSize: "1vw", paddingTop: "2vh" }}>
          <Col span={11}>
            <span
              style={{
                fontFamily: "Inter",
                fontSize: "1.25em",
                color: "#0F0718",
                fontWeight: 500,
              }}
            >
              Reject Notes
            </span>
            <TextArea
              id="notes-input"
              style={{ resize: "none", paddingTop: "2vh" }}
              maxLength={200}
              placeholder="Type Here"
              // onKeyDown={handleKeyDown}
              // onChange={(e) => onChangeInputKeyboard(e)}
              // value={notesValue}
              rows={11}
            />
          </Col>
          <Col span={12} offset={1} style={{ marginTop: "4vh" }}>
            <Keyboard
              theme={"hg-theme-default aprvl"}
              onChange={(input) => onChange(input)}
              keyboardRef={(r) => (keyboardRef.current = r)}
              onKeyPress={(button) => {
                if (button === "{shift}" || button === "{lock}") handleShift();
                if (button === "{number}") {
                  setLayoutName("number");
                }
                if (button === "{numbers}") {
                  setLayoutName("numbers");
                }
                if (button === "{small}") {
                  setLayoutName("shift");
                }
                if (button === "{caps}") {
                  setLayoutName("default");
                }
                if (button === "{enter}") {
                  onAddNotes();
                }
              }}
              layoutName={layoutName}
              display={{
                "{abc}": "ABC",
                "{smileys}": "\uD83D\uDE03",
                "{back}": "Enter",
                "{numbers}": "123",
                "{number}": "123",
                "{bksp}": "backspace",
                "{backspace}": "⌫",
                "{shift}": "⇧",
                "{tab}": "tab",
                "{lock}": "lock",
                "{enter}": "Enter",
                "{space}": "Space",
                "{caps}": "ABC",
                "{small}": "abc",
              }}
              layout={{
                shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "2.3vh", fontSize: "1vw" }} gutter={[16]}>
          <Col span={12} />
          <Col span={5} style={{ textAlign: "right", marginLeft: "1.6vw" }}>
            <Button
              style={{ width: "100%", height: "7.5vh", fontSize: "1.5em", fontWeight: "500", color: "#000", borderRadius: "5px" }}
              onClick={() => setShowReturnPurchase(false)}
              disabled={loader}
            >
              Cancel
            </Button>
          </Col>
          <Col span={5} style={{ textAlign: "right" }}>
            <Button
              style={{ width: "100%", height: "7.5vh", fontSize: "1.5em", fontWeight: "500", color: "#fff", background: "#2F3856", borderRadius: "5px" }}
              ref={returnProcessRef}
              disabled={modalEditState || loader}
              className="focusDashboardCard"
            >
              Confirm
            </Button>
          </Col>
        </Row>
      </Drawer> */}
      <GroupedProducts
        showCustomMix={showCustomMix}
        setShowCustomMix={setShowCustomMix}
        cart={cart}
        setCart={setCart}
        customMixItems={customMixItems}
        setCustomMixItems={setCustomMixItems}
        groupName={groupName}
        setGroupName={setGroupName}
        groupQty={groupQty}
        setGroupQty={setGroupQty}
        existingGroupItems={existingGroupItems}
        setExistingGroupItems={setExistingGroupItems}
        selectedCustomMix={selectedCustomMix}
        setSelectedCustomMix={setSelectedCustomMix}
        orderType={orderType}
        setOrderType={setOrderType}
        posSaleTypes={posSaleTypes}
        setPosSaleTypes={setPosSaleTypes}
        currenciesData={currenciesData}
        setCurrenciesData={setCurrenciesData}
        searchInputRef={searchInputRef}
        setActiveInput={setActiveInput}
        setProductStock={setProductStock}
        showPreviousItems={showPreviousItems}
        showMoreItems={showMoreItems}
        setShowCompleteSaleStock={setShowCompleteSaleStock}
        setCompleteSaleStockData={setCompleteSaleStockData}
        processBillDiscounts={processBillDiscounts}
        setLoader={setLoader}
        processTotalManualDiscount={processTotalManualDiscount}
      />
      {/* Print Template Selection Modal */}
      <Modal
        visible={showPrintTemplateModal}
        title={<span style={{ fontSize: "16px", fontWeight: 600, color: "#1f1f1f" }}>Select Receipt Template</span>}
        onCancel={handlePrintTemplateCancel}
        footer={
          <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
            <Button
              style={{
                height: "36px",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: 500,
                border: "1px solid #d9d9d9",
                color: "#333",
                padding: "0 20px",
              }}
              onClick={handlePrintTemplateCancel}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              style={{
                height: "36px",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: 500,
                backgroundColor: "#2d3748",
                borderColor: "#2d3748",
                padding: "0 20px",
              }}
              onClick={handlePrintTemplateConfirm}
              disabled={!selectedPrintTemplate}
            >
              Print Receipt
            </Button>
          </div>
        }
        centered
        width={480}
        bodyStyle={{ padding: "16px 24px", maxHeight: "400px", overflowY: "auto" }}
        maskClosable={false}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Radio.Group
            value={selectedPrintTemplate}
            onChange={(e) => {
              setSelectedPrintTemplate(e.target.value);
            }}
            style={{ width: "100%" }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {printTemplates.map((template) => (
                <div
                  key={template.cwr_printtemplate_id}
                  style={{
                    border: selectedPrintTemplate === template.cwr_printtemplate_id ? "1px solid #2d3748" : "1px solid #e8e8e8",
                    borderRadius: "6px",
                    padding: "12px 14px",
                    cursor: "pointer",
                    backgroundColor: selectedPrintTemplate === template.cwr_printtemplate_id ? "#f7fafc" : "#fff",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    setSelectedPrintTemplate(template.cwr_printtemplate_id);
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Radio value={template.cwr_printtemplate_id} />
                    <span style={{ fontWeight: 500, fontSize: "14px", color: "#1f1f1f" }}>{template.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </Radio.Group>
        </div>
      </Modal> 
    </Spin>
  );
};

export default PointOfSaleMarket;
